import React, { Component, createContext, createRef, useState, useEffect } from 'react';
import { Row, Col, Card, Alert, Button, Dropdown, Form, Modal } from 'react-bootstrap';
import { ArrowsFullscreen, InfoCircle } from 'react-bootstrap-icons';
import Fullscreen from 'fullscreen-react';
import disableScroll from 'disable-scroll';

import { withRouter } from 'react-router-dom';
import { LeadContext } from 'Leads/Details/hooks/context';
import DroneIframeModal from 'components/DroneIframeModal';
import { computeUtilityTotalUsageKwh } from 'Leads/Details/utils/utility';
import {
  buildFixedInverterPanelCapacityNotification,
  FIXED_INVERTER_PANEL_CAPACITY_CALLBACK,
  countProductionPayloadPanels,
  FIXED_INVERTER_PANEL_CAPACITY_MESSAGE,
  hasFixedInverterQuantity,
  matchesPrimaryInverterType,
  resolveAppliedPanelCount,
  resolveMicroInverterQuantity,
} from 'Leads/Details/utils/inverter';
import {
  Canvas3D,
  DesignContext,
  setSegmentAttributes,
  filterDictByKeys,
} from '@aerialytic/canvas-library';
import {
  buildProductionJson,
  buildAiTaskStorageKey,
  buildEffectiveInlineHardwareSpec,
  buildHistorySnapshot,
  buildProductionPanelSelection,
  calculateInverterClipping as calculateDesignerInverterClipping,
  calculateOptimalInverterQuantity as calculateDesignerOptimalInverterQuantity,
  changeDesignerAdditionalInverters,
  changeDesignerInverterQuantity,
  compactDroneProject,
  countPlacedDesignerPanels,
  createProposalData,
  diffCanvasStates,
  isDirtyStatus,
  UNSAVED_CHANGES_GUARD_MESSAGE,
  createDesignerCanvasCommands,
  createDesignerCanvasContextValue,
  DesignerCommandTypes,
  DesignerEffectTypes,
  DesignerHistoryCommandTypes,
  createProductionResetCanvas,
  createProductionResetState,
  createInitialDesignerState,
  createInitialDesignHistoryState,
  DEFAULT_CANVAS_SIZE,
  DESIGNER_CANVAS_COMMAND_NAMES,
  detectShadingHasRun,
  DESIGN_SCALE,
  findPrimaryInverterUsage,
  HISTORY_KEYS,
  normalizeProductionPerPanelData,
  normalizeProductionLosses,
  parseDatasetKeyFromPath,
  pushHistory,
  applyAutomaticInverterQuantity,
  applyDesignerRoofEffects,
  applyPendingDesignerPanelHardware,
  applyProductionReset,
  applySolarProductionResult,
  applySetbacks,
  patchFireSetbacks,
  patchSegmentSetbacks,
  transitionAccordion,
  toggleSelectedRoofPlacement,
  removeGeometry,
  runDesignerCommand,
  runDesignerHistoryCommand,
  applyAddToSelection,
  applyRemoveFromSelection,
  applyClearSelection,
  applySegmentShadingFactors,
  applyServerSideSegmentShadingFactors,
  buildGroundMountSegment,
  buildSelectedPanelCommit,
  calculateLegacySegmentArea,
  calculateSegmentArea,
  clearPanelSelectionFlags,
  deleteSelectedRoofSegments,
  moveSelectedRoofVertices,
  resolveDesignerDsmParams,
  resolvePendingPanelForFirstPlacement,
  resolveShadingStaleTransition,
  resolveShadingStatusPatch,
  syncSelectedRoofFrom3D as syncSelectedRoofFrom3DTransition,
  syncSelectedRoofFrom2D as syncSelectedRoofFrom2DTransition,
  syncSelectedPanelFrom3D as syncSelectedPanelFrom3DTransition,
  syncSelectedPanelFrom2D as syncSelectedPanelFrom2DTransition,
  shouldAutoEnableSelectedRoofPlacement,
  resolveSlotHardwareFromCanvas,
  resolveMediaUrl,
  selectDesignerPanelHardware,
  hydrateDesignerStateFromCanvas,
  resetLegacyFlagsAfterPlacement as resetLegacyPlacementFlags,
  rotateSegmentPanels,
  transitionSegmentEdgeTypes,
  translateDesignerGeometry,
  updateSelectedSegmentMeasurement,
  suggestedNameForLead,
} from '@aerialytic/designer-states/core';
import {
  shapeCanvasDesignTree,
  pickNextActiveScope,
  collectArchivedScopes,
  resolveArchiveTarget,
  parseScopeOptionValue,
  parseArchivedScopeValue,
} from '@aerialytic/designer-states/host';
import { createDesignerStateController } from './design-tool-adapter';
import { buildEffectiveSystemLosses } from './system-losses';
import {
  positiveFiniteResolution,
  resolveDesignResolution,
} from './resolution';

import {
  distance,
  isPointInShape,
  retry,
  ios,
} from './utils';
import Controls from './Controls';
import ControlsBottom from './ControlsBottom';
import Menu from './Menu';
import canvasHandler from './DrawCanvas/handlers/canvasHandler';
import ShadeReport from '../ShadeReport';
import IFrameLogo from 'components/IFrameLogo';
import {
  buildProductionCallbackPayload,
  getPanelCounts,
  mapRoofKeyedPayloadToDesign,
  mapSelectedPanelsPerRoofToDesign,
  mapStringingDataToDesign,
} from 'Leads/Details/utils/productionCallback';
import { CURRENT_PROPOSAL_VERSION } from 'IFrame/postMessage';
import { runDesignerBootstrap } from './bootstrap';
import {
  buildDroneShellUrl,
  getDroneBackendUrl,
  getDroneFrontendUrl,
  isDroneReadyMessage,
  parseDroneExportMessage,
  postDroneBootstrap,
} from 'drone';
import {
  loadAssignedHardwareCatalog,
  retrieveCompanyHardwareWithFallback,
  visibleHardwareCatalog,
} from './hardware-selection';
import {
  countAddedPanels,
  countPlacedPanels,
  createPanelPlacementActionId,
  panelPlacementOutcomeMessage,
  persistPanelPlacement,
} from './panel-placement';
import {
  ProductionRunQueue,
  resolveRequestedPowerOptimizer,
  resolveProductionPanelSelection,
  runIframeProductionCommand,
} from './production-selection';
import AuthManager from 'api/auth';
const samplingRate = 30;
const konvaKeys = ['shading', 'setback', 'design', 'revise', 'production'];
const canvasKeys = ['segments', 'obstacles', 'trees'];
const DIRTY_WATCH_KEYS = [
  'segments',
  'obstacles',
  'trees',
  'panels',
  'annotations',
  'colorRange',
  'buffer',
  'rowSpacing',
  'panelTilt',
  'azimuthRestriction',
  'panelPlacementFillMode',
  'panelPlacementLayoutMode',
  'panelPlacementOnlySelectedRoof',
  'losses',
  'package',
  'primaryInverterAutoQuantity',
  'useTargetProduction',
  'targetProductionKwh',
  'maxDcAcRatio',
  'onlySelectedPanels',
  'totalAnnualKwh',
  'totalMonthlyKwh',
  'totalClippingKwh',
  'totalMonthlyClippingKwh',
  'dcAcRatio',
  'systemSizeKw',
  'stringingData',
  'invertersUsed',
  'productionPerPanel',
  'productionPerString',
];
const mediaUrl = (path) =>
  resolveMediaUrl(
    path,
    process.env.REACT_APP_PROPERTY_DATA_DSM_PUBLIC_URL || ''
  );

class DesignTool extends Component {
  constructor(props) {
    super(props);

    this.state = createInitialDesignerState();
    this.state = {
      designerLoadError: null,
      designerIsLoading: false,
      ...this.state,
      droneModal: {
        ...this.state.droneModal,
        bootstrap: null,
      },
      cloneDialogOpen: false,
      cloneName: '',
      cloneTarget: '',
      archiveSiblingsOpen: false,
      archiveSiblings: [],
      saveNeeded: false,
      scopeConfirm: null,
      renameModal: null,
      archiveModal: null,
      dirtyStatus: {
        isCanvasChanged: false,
        isDesignChanged: false,
        isAnnotationChanged: false,
      },
    };
    this.auth = AuthManager();

    this.histories = [];
    this.productionRunQueue = new ProductionRunQueue();
    this.historyState = createInitialDesignHistoryState();
    this.designerState = createDesignerStateController({
      getState: () => this.state,
      setStatePatch: (patch) => this.setState(patch),
      getHistories: () => this.histories,
      setHistories: (h) => {
        this.histories = h;
      },
      getHistoryState: () => this.historyState,
      setHistoryState: (hs) => {
        this.historyState = hs;
      },
      onIframeState: (data, check) => this.callbackDesignerIframe(data, check),
    });
    const sharedCommands = new Set([
      'setSelectionMode',
      'setShadingIsRunning',
      'setServerSideShadingIsRunning',
      'setMoveMode',
      'setUpdateRGBTextureIsRunning',
    ]);
    const commandPorts = Object.fromEntries(
      DESIGNER_CANVAS_COMMAND_NAMES.filter(
        (name) => !sharedCommands.has(name) && typeof this[name] === 'function'
      ).map((name) => [name, (...args) => this[name](...args)])
    );
    this.designerCanvasCommands = createDesignerCanvasCommands({
      getState: () => this.state,
      dispatch: this.designerState.dispatch,
      ports: commandPorts,
    });
    this.suppressSolarProductionFromSelection = false;
    this.lastProductionSnapshot = null;
    this.panelPlacementCallbackArmed = false;
    this.panelPlacementCallbackRequestId = null;
    this.panelPlacementStartTimer = null;
    this.panelPlacementFinalizeTimer = null;
    this.panelPlacementUpdateTimer = null;
    this.panelPlacementCompletion = null;
    this.panelPlacementPersistencePromise = null;
    this.panelPlacementRequestId = 0;
    this.panelPlacementUnmounted = false;
    this.skipNextSegmentsAutoSave = false;
    this.droneIframeRef = createRef();
    this.droneExportIsSaving = false;
  }

  unlockPageScroll = () => {
    try {
      disableScroll.off();
    } catch (e) { }
  };

  handleWindowBlur = () => {
    this.unlockPageScroll();
  };

  handleVisibilityChange = () => {
    if (document.hidden) {
      this.unlockPageScroll();
    }
  };

  handleWindowMouseOut = (e) => {
    if (!e?.relatedTarget && !e?.toElement) {
      this.unlockPageScroll();
    }
  };

  handleWindowMouseUp = () => {
    try {
      const hovered = this.container?.matches?.(':hover');
      if (!hovered) this.unlockPageScroll();
    } catch (e) {
      this.unlockPageScroll();
    }
  };

  blockDesignAltAreaSelect = (e) => {
    if (this.state.currentAccordion !== 'design') return;
    if (!this.container || !this.container.contains(e.target)) return;
    if (
      !e.altKey &&
      !(typeof e.getModifierState === 'function' && e.getModifierState('Alt'))
    ) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
    if (e.type === 'pointerdown' || e.type === 'mousedown') {
      try {
        this.container.querySelectorAll('.selectBox').forEach((node) => {
          if (node.parentElement) node.parentElement.removeChild(node);
        });
      } catch (err) { }
    }
  };

  loadDesignerData = () => {
    const { company, uid, packageAPI, CanvasAPI, lead, newEndpoint } =
      this.context;
    const {
      iframe,
      designFrame,
      context: iframeContext = {},
      callback: iframeCallback,
    } = this.props;

    try {
      this.loadDesigns();
    } catch (e) { }
    try {
      window.addEventListener('crm-ai-design-task', this.handleAIDesignTaskEvent);
      this.resumeStoredAITask();
    } catch (e) { }

    const propertyResolution = positiveFiniteResolution(lead.property.resolution);
    const { production: overlay, design_type: designType } = lead.property;
    const setbackAPI = newEndpoint('hardware/setbacks/');
    const assignedHardwareCatalogPromise = iframe
      ? Promise.resolve({ panels: [], inverters: [] })
      : loadAssignedHardwareCatalog(newEndpoint);
    const lossesEndpoint = newEndpoint('hardware/losses/');
    const nsrdbDatasetsAPI = newEndpoint('api/nsrdb/datasets/');

    const imagery = lead?.property?.rgb;

    if (iframe && !imagery) {
      iframeCallback('Error', { code: '46', message: 'Lead has no imagery' });
    }

    try {
      const rgbKey = lead?.property?.rgb;
      let rgbUrl = null;
      if (typeof rgbKey === 'string' && rgbKey) {
        if (rgbKey.startsWith('pd_')) {
          rgbUrl = `${process.env.REACT_APP_PROPERTY_DATA_RGB_PUBLIC_URL}/${rgbKey}/rgb.tiff`;
        } else {
          rgbUrl = mediaUrl(rgbKey);
        }
      }
      if (rgbUrl) {
        const img = new window.Image();
        img.onload = () => {
          const n = Math.min(
            img.width || DEFAULT_CANVAS_SIZE,
            img.height || DEFAULT_CANVAS_SIZE
          );
          if (Number.isFinite(n) && n > 0) this.setState({ canvasSize: n });
        };
        img.onerror = () => { };
        img.src = rgbUrl;
      }
    } catch (e) { }

    const byLeadAPI = newEndpoint('designer/canvas/by_lead');
    const ensureDesignsThenGetCanvas = () =>
      byLeadAPI.list(`?lead=${encodeURIComponent(uid)}`).then(() => CanvasAPI.getCanvas());

    return runDesignerBootstrap(() => Promise.all([
      ensureDesignsThenGetCanvas(),
      packageAPI.list().then((data) => (data.length !== 0 ? data : Object())),
      setbackAPI.retrieve(company),
      assignedHardwareCatalogPromise.then(({ panels }) => panels),
      assignedHardwareCatalogPromise.then(({ inverters }) => inverters),
      lossesEndpoint.retrieve(company),
    ])
      .then(
        ([
          canvasData,
          packageData,
          fireSetbacks,
          solarPanels,
          inverters,
          losses,
        ]) => {
          const resolution = resolveDesignResolution(
            canvasData?.resolution,
            propertyResolution
          );
          const weatherDatasetFetchedPath =
            canvasData && typeof canvasData.weather_dataset === 'string'
              ? canvasData.weather_dataset
              : null;
          const weatherDatasetSelectedFromDb =
            parseDatasetKeyFromPath(weatherDatasetFetchedPath) ||
            'nsrdb_goes_v4_2024';

          const statePackage = packageData.filter(
            (item, index) => item.state === lead.address.state
          )[0];
          const defaultPackage = packageData.filter(
            (item, index) => item.state === null
          )[0];
          // console.log('selected package: ', statePackage !== undefined ? statePackage : defaultPackage);

          const package_ = statePackage || defaultPackage;
          const flagPackage = { ...package_ };
          const normalizeAdditionalInverter = (entry) => {
            if (!entry || typeof entry !== 'object') return null;
            const id =
              entry.id ??
              entry.inverter_id ??
              entry.inverterId ??
              entry.companyInverterID ??
              entry.companyInverterId ??
              null;
            if (!id) return null;
            const quantity = Number(entry.quantity || 1);
            return {
              id,
              quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
              autoQuantity:
                (entry.autoQuantity ?? entry.auto_quantity ?? true) !== false,
            };
          };
          const normalizeAdditionalInverters = (list) =>
            Array.isArray(list)
              ? list.map(normalizeAdditionalInverter).filter(Boolean)
              : [];
          const packageAdditionalInvertersSnapshot =
            normalizeAdditionalInverters(package_?.additional_inverters);
          package_.additional_inverters = packageAdditionalInvertersSnapshot;
          const { panel: panelHardware } = package_;
          const hasIframeCompanyPanelID =
            iframeContext?.companyPanelID !== null &&
            iframeContext?.companyPanelID !== undefined;
          const hasIframePanelType = Boolean(
            iframeContext?.panelType &&
              typeof iframeContext.panelType === 'object'
          );
          const hasExplicitIframePanelMode =
            iframeContext?.panelDefault !== undefined &&
            iframeContext?.panelDefault !== null;
          const hasInvalidExplicitPanelConfig =
            hasExplicitIframePanelMode &&
            iframeContext?.panelDefault !== 'default' &&
            !hasIframeCompanyPanelID &&
            !hasIframePanelType;
          if (
            iframe &&
            iframeContext &&
            !hasIframeCompanyPanelID &&
            (hasIframePanelType || hasInvalidExplicitPanelConfig)
          ) {
            if (iframe && !designFrame && hasIframePanelType) {
              iframeContext.panelType = {
                ...panelHardware,
                ...iframeContext.panelType,
              };
              // console.log(`(************ iframe panel: ${iframeContext.panelType}`)
              package_.panel = iframeContext.panelType;
              if (
                package_.panel?.model === flagPackage.panel?.model &&
                Number(package_.panel?.power) ===
                Number(flagPackage.panel?.power)
              ) {
                iframeCallback('Error', {
                  code: '445',
                  message: 'iframe panel config is not set properly! (same)',
                });
                this.setState({
                  panelNotSet: true,
                });
              }
            } else {
              if (!designFrame) {
                iframeCallback('Error', {
                  code: '445',
                  message: 'iframe panel config is not set properly!',
                });
                this.setState({
                  panelNotSet: true,
                });
              }
            }
          }

          if (iframeContext?.panelDefault === 'default') {
            iframeContext.panelType = { ...panelHardware };
            package_.panel = iframeContext.panelType;
          }

          if (
            iframe &&
            iframeContext &&
            iframeContext?.companyPanelID !== null &&
            iframeContext?.companyPanelID !== undefined
          ) {
            const { companyPanelID } = iframeContext;
            // console.log(`************ companyPanelID = ${companyPanelID} in didMount`);
            const companyPanelsAPI = newEndpoint('panels/company/');
            retrieveCompanyHardwareWithFallback({
              retrieve: (id) => companyPanelsAPI.retrieve(id),
              id: companyPanelID,
              currentHardware: package_.panel,
              inlineHardware: iframeContext.panelType,
              kind: 'panel',
            })
              .then(({ hardware, source }) => {
                package_.panel = hardware;
                if (source !== 'registered') {
                  console.warn(
                    `[Iframe] panel ${companyPanelID} is unavailable; using ${source}`
                  );
                }
              })
              .catch((error) => {
                console.error('[Iframe] panel hardware lookup failed', error);
                if (error?.iframeCode) {
                  iframeCallback('Error', {
                    code: error.iframeCode,
                    message: error.message,
                  });
                }
              });
          }
          if (
            iframe &&
            iframeContext &&
            iframeContext?.companyInverterID !== null &&
            iframeContext?.companyInverterID !== undefined
          ) {
            const { companyInverterID } = iframeContext;
            // console.log(`************ companyInverterID = ${companyInverterID} in didMount`);
            const companyInverterAPI = newEndpoint('inverters/company/');
            retrieveCompanyHardwareWithFallback({
              retrieve: (id) => companyInverterAPI.retrieve(id),
              id: companyInverterID,
              currentHardware: package_.inverter,
              inlineHardware: iframeContext.inverter,
              kind: 'inverter',
            })
              .then(({ hardware, source }) => {
                package_.inverter = hardware;
                if (source !== 'registered') {
                  console.warn(
                    `[Iframe] inverter ${companyInverterID} is unavailable; using ${source}`
                  );
                }
              })
              .catch((error) => {
                console.error('[Iframe] inverter hardware lookup failed', error);
                if (error?.iframeCode) {
                  iframeCallback('Error', {
                    code: error.iframeCode,
                    message: error.message,
                  });
                }
              });
          }
          const filteredIframeContext = filterDictByKeys(iframeContext, [
            'buffer',
            'rowSpacing',
            'panelTilt',
            'maxDcAcRatio',
            'includeHourlyProduction',
            'azimuthRestriction',
            'setback',
            'panelType',
            'wiring',
            'powerOptimizer',
            'defaultBtnView',
          ]);
          const normalizeWiringConfig = (value) => {
            if (!value || typeof value !== 'object') return null;
            const next = {};
            const ohm = Number(value.ohm_per_m_string);
            const loop = Number(value.loop_factor);
            if (Number.isFinite(ohm) && ohm > 0) {
              next.ohm_per_m_string = ohm;
            }
            if (Number.isFinite(loop) && loop > 0) {
              next.loop_factor = loop;
            }
            if (!Object.keys(next).length) return null;
            return { ...this.state.wiring, ...next };
          };
          const wiringFromIframe =
            normalizeWiringConfig(iframeContext?.wiring) ||
            normalizeWiringConfig(
              iframeContext?.inverter?.ohm_per_m_string !== undefined ||
                iframeContext?.inverter?.loop_factor !== undefined
                ? {
                  ohm_per_m_string: iframeContext.inverter.ohm_per_m_string,
                  loop_factor: iframeContext.inverter.loop_factor,
                }
                : null
            );
          if (wiringFromIframe) {
            filteredIframeContext.wiring = wiringFromIframe;
            filteredIframeContext.wiringConfigured = true;
          }

          const losses_ = buildEffectiveSystemLosses({
            baseLosses: losses,
            canvasLosses:
              normalizeProductionLosses(canvasData?.losses) ||
              canvasData?.losses,
            iframeLosses:
              iframe && iframeContext
                ? normalizeProductionLosses(iframeContext?.losses) ||
                  iframeContext?.losses
                : null,
            lead,
            forceStateSnow: true,
          });

          console.log(`--> system losses: ${JSON.stringify(losses_)}`);

          solarPanels = visibleHardwareCatalog(solarPanels);
          inverters = visibleHardwareCatalog(inverters);

          // Inline specs have no registered row, so load them before FK/id values.
          const panelResolved = resolveSlotHardwareFromCanvas({
            spec: canvasData.selected_panel_spec,
            fkObject: canvasData.selected_panel,
            idValue: canvasData.selected_panel_id,
            catalog: solarPanels,
          });
          if (panelResolved.hardware) {
            package_.panel = panelResolved.hardware;
            package_.selectedPanelSpec =
              panelResolved.source === 'spec' ? panelResolved.hardware : null;
          }

          const inverterResolved = resolveSlotHardwareFromCanvas({
            spec: canvasData.selected_inverter_spec,
            fkObject: canvasData.selected_inverter,
            idValue: canvasData.selected_inverter_id,
            catalog: inverters,
          });
          const rawInverterSpec = canvasData.selected_inverter_spec;
          if (rawInverterSpec && rawInverterSpec.capacity) {
            package_.inverter = {
              ...rawInverterSpec,
              id: rawInverterSpec.id || rawInverterSpec.hardware_id,
            };
            package_.selectedInverterSpec = package_.inverter;
          } else if (inverterResolved.hardware) {
            package_.inverter = inverterResolved.hardware;
            package_.selectedInverterSpec =
              inverterResolved.source === 'spec'
                ? inverterResolved.hardware
                : null;
          }
          if (
            canvasData.inverter_quantity !== undefined &&
            canvasData.inverter_quantity !== null
          ) {
            package_.inverterQuantity = canvasData.inverter_quantity;
          } else if (
            iframeContext?.inverterQuantity !== undefined &&
            iframeContext?.inverterQuantity !== null
          ) {
            package_.inverterQuantity = iframeContext.inverterQuantity;
          }
          if (canvasData.additional_inverters) {
            package_.additional_inverters = normalizeAdditionalInverters(
              canvasData.additional_inverters
            );
          } else if (
            iframeContext?.companyAdditionalInverterIDs ||
            iframeContext?.additionalInverters
          ) {
            const rawAdditionalInverters =
              Array.isArray(iframeContext?.additionalInverters) &&
                iframeContext.additionalInverters.length > 0
                ? iframeContext.additionalInverters
                : iframeContext.companyAdditionalInverterIDs || [];
            const configAdditionalInverters = rawAdditionalInverters
              .map((item) => {
                if (typeof item === 'string') {
                  return { id: item, quantity: 1, autoQuantity: true };
                }
                if (item && typeof item === 'object') {
                  const id = item.companyInverterID || item.id;
                  if (!id) return null;
                  return {
                    id,
                    quantity: item.quantity || 1,
                    autoQuantity: item.autoQuantity !== false,
                  };
                }
                return null;
              })
              .filter(Boolean);
            if (configAdditionalInverters.length > 0) {
              package_.additional_inverters = configAdditionalInverters;
            }
          }

          // Load primary inverter auto quantity state
          const savedPrimaryInverterAutoQuantity =
            canvasData.primary_inverter_auto_quantity;
          const primaryInverterAutoQuantityFromDb =
            savedPrimaryInverterAutoQuantity !== undefined &&
              savedPrimaryInverterAutoQuantity !== null
              ? savedPrimaryInverterAutoQuantity
              : this.state.primaryInverterAutoQuantity;
          const primaryInverterAutoQuantityFromConfig =
            typeof iframeContext?.primaryInverterAutoQuantity === 'boolean'
              ? iframeContext.primaryInverterAutoQuantity
              : null;
          const primaryInverterAutoQuantityResolved =
            Array.isArray(canvasData.inverters_used) && canvasData.inverters_used.length
              ? false
              : primaryInverterAutoQuantityFromConfig !== null
                ? primaryInverterAutoQuantityFromConfig
                : primaryInverterAutoQuantityFromDb;

          let totalAnnualKwhFromDb = canvasData.total_annual_kwh || 0;
          let totalMonthlyKwhFromDb =
            canvasData.total_monthly_kwh || Array(12).fill(0);
          let totalClippingKwhFromDb = canvasData.total_clipping_kwh || 0;
          const totalMonthlyClippingKwhFromDb =
            canvasData.total_monthly_clipping_kwh || Array(12).fill(0);
          const dcAcRatioFromDb = canvasData.dc_ac_ratio ?? null;
          const stringingDataFromDb = canvasData.stringing_data || null;
          const invertersUsedFromDb = canvasData.inverters_used || null;
          const productionPerPanelDataFromDb =
            canvasData.production_per_panel || null;
          const productionPerStringDataFromDb =
            canvasData.production_per_string || null;
          const hourlyProductionFromDb =
            canvasData.hourly_production || null;
          const countPanelsFromProduction = (data) =>
            Array.isArray(data)
              ? data.reduce(
                (sum, roof) =>
                  sum +
                  (Array.isArray(roof?.roofPanels)
                    ? roof.roofPanels.filter((v) => Number(v) > 0).length
                    : 0),
                0
              )
              : 0;
          const selectedPanelCountFromDb = Array.isArray(stringingDataFromDb)
            ? stringingDataFromDb.reduce(
              (sum, s) => sum + (s?.panels?.length || 0),
              0
            )
            : countPanelsFromProduction(productionPerPanelDataFromDb);
          let productionHandledFromDb =
            Boolean(stringingDataFromDb) ||
            Boolean(invertersUsedFromDb) ||
            totalAnnualKwhFromDb > 0 ||
            totalClippingKwhFromDb > 0;
          if (
            productionPerPanelDataFromDb ||
            productionPerStringDataFromDb ||
            hourlyProductionFromDb
          ) {
            productionHandledFromDb = true;
          }

          if (
            productionHandledFromDb &&
            (!canvasData.total_annual_kwh ||
              canvasData.total_annual_kwh === 0) &&
            Array.isArray(totalMonthlyKwhFromDb) &&
            totalMonthlyKwhFromDb.length >= 12
          ) {
            const derived = totalMonthlyKwhFromDb.reduce(
              (a, b) => a + (Number(b) || 0),
              0
            );
            if (derived > 0) totalAnnualKwhFromDb = derived;
          }

          if (
            productionHandledFromDb &&
            (!canvasData.total_clipping_kwh ||
              canvasData.total_clipping_kwh === 0) &&
            Array.isArray(totalMonthlyClippingKwhFromDb) &&
            totalMonthlyClippingKwhFromDb.length >= 12
          ) {
            const derivedClip = totalMonthlyClippingKwhFromDb.reduce(
              (a, b) => a + (Number(b) || 0),
              0
            );
            if (derivedClip > 0) totalClippingKwhFromDb = derivedClip;
          }

          const productionPerPanelFromDb =
            selectedPanelCountFromDb > 0
              ? totalAnnualKwhFromDb / selectedPanelCountFromDb
              : 0;

          const systemSizeKwFromDb =
            canvasData.system_size_kw !== undefined &&
              canvasData.system_size_kw !== null
              ? canvasData.system_size_kw
              : package_?.panel?.power && selectedPanelCountFromDb > 0
                ? (Number(package_.panel.power) * selectedPanelCountFromDb) / 1000
                : null;
          const inverterType = package_?.inverter?.type;
          const invertersCountFromDb = Array.isArray(invertersUsedFromDb)
            ? invertersUsedFromDb.reduce((sum, i) => sum + (i.count || 0), 0)
            : null;
          const mpptPerInv =
            package_?.inverter?.mppt_count_per_inverter !== undefined &&
              package_?.inverter?.mppt_count_per_inverter !== null
              ? Number(package_.inverter.mppt_count_per_inverter)
              : null;
          const mpptCountTotalFromDb =
            canvasData.mppt_count_total !== undefined &&
              canvasData.mppt_count_total !== null
              ? canvasData.mppt_count_total
              : inverterType === 'M' || inverterType === 'Micro'
                ? invertersCountFromDb
                : invertersCountFromDb !== null && mpptPerInv
                  ? invertersCountFromDb * mpptPerInv
                  : null;

          const rawUseTargetProduction = canvasData.use_target_production;
          const rawTargetProductionKwh = canvasData.target_production_kwh;

          const hasSavedTargetProductionSettings =
            rawUseTargetProduction !== undefined &&
              rawUseTargetProduction !== null
              ? true
              : rawTargetProductionKwh !== undefined &&
              rawTargetProductionKwh !== null &&
              Number(rawTargetProductionKwh) > 0;

          const utilityTotalUsageKwh = computeUtilityTotalUsageKwh(
            lead?.utility
          );
          const defaultTargetProductionKwh =
            Number.isFinite(Number(utilityTotalUsageKwh)) &&
              Number(utilityTotalUsageKwh) > 0
              ? Math.round(Number(utilityTotalUsageKwh))
              : 0;

          const rawTargetNum = Number(rawTargetProductionKwh);
          const hasPositiveTarget =
            rawTargetProductionKwh !== undefined &&
            rawTargetProductionKwh !== null &&
            rawTargetProductionKwh !== '' &&
            Number.isFinite(rawTargetNum) &&
            rawTargetNum > 0;

          const targetProductionKwhFromDb = hasPositiveTarget
            ? rawTargetNum
            : defaultTargetProductionKwh;

          const useTargetProductionFromDb = hasSavedTargetProductionSettings
            ? Boolean(rawUseTargetProduction) ||
            Number(targetProductionKwhFromDb) > 0
            : true;
          const hasIframeTargetProduction =
            iframeContext &&
            Object.prototype.hasOwnProperty.call(
              iframeContext,
              'targetProduction'
            );
          const iframeTargetProductionValue = hasIframeTargetProduction
            ? Number(iframeContext.targetProduction)
            : null;
          const iframeTargetProductionOverride = hasIframeTargetProduction
            ? {
              useTargetProduction:
                Number.isFinite(iframeTargetProductionValue) &&
                iframeTargetProductionValue > 0,
              targetProductionKwh:
                Number.isFinite(iframeTargetProductionValue) &&
                  iframeTargetProductionValue > 0
                  ? iframeTargetProductionValue
                  : 0,
            }
            : null;
          const resolvedUseTargetProduction =
            iframeTargetProductionOverride?.useTargetProduction ??
            useTargetProductionFromDb;
          const resolvedTargetProductionKwh =
            iframeTargetProductionOverride?.targetProductionKwh ??
            targetProductionKwhFromDb;
          const maxDcAcRatioFromDb =
            canvasData.max_dc_ac_ratio !== undefined &&
              canvasData.max_dc_ac_ratio !== null
              ? canvasData.max_dc_ac_ratio
              : this.state.maxDcAcRatio;
          const onlySelectedPanelsFromDb = Boolean(
            canvasData.only_selected_panels
          );

          // Detect if shading has been run
          const shadingHasRun = detectShadingHasRun(canvasData);

          this.setStatex(
            {
              ...canvasData,
              segments: canvasData?.segments,
              package: package_,
              packageAdditionalInverters: packageAdditionalInvertersSnapshot,
              // ensure UI reflects persisted inverter + production state on refresh
              primaryInverterAutoQuantity: primaryInverterAutoQuantityResolved,
              hasAutoCalculatedInverterQuantity:
                primaryInverterAutoQuantityResolved === null
                  ? this.state.hasAutoCalculatedInverterQuantity
                  : !primaryInverterAutoQuantityResolved,
              // target production state
              useTargetProduction: resolvedUseTargetProduction,
              targetProductionKwh: resolvedTargetProductionKwh,
              maxDcAcRatio: maxDcAcRatioFromDb,
              onlySelectedPanels: onlySelectedPanelsFromDb,
              stringingPanelIndexMode:
                canvasData.stringing_panel_index_mode || 'all',
              productionHandled: productionHandledFromDb,
              totalAnnualKwh: totalAnnualKwhFromDb,
              totalMonthlyKwh: totalMonthlyKwhFromDb,
              totalClippingKwh: totalClippingKwhFromDb,
              totalMonthlyClippingKwh: totalMonthlyClippingKwhFromDb,
              dcAcRatio: dcAcRatioFromDb,
              stringingData: stringingDataFromDb,
              invertersUsed: invertersUsedFromDb,
              selectedPanelCount: selectedPanelCountFromDb,
              productionPerPanel: productionPerPanelFromDb,
              productionPerPanelData: productionPerPanelDataFromDb,
              productionPerStringData: productionPerStringDataFromDb,
              hourlyProduction: hourlyProductionFromDb,
              productionHardware: productionHandledFromDb
                ? {
                  panel: package_?.panel || null,
                  inverter: package_?.inverter || null,
                  additionalInverters: package_?.additional_inverters || [],
                  inverterQuantity: package_?.inverterQuantity || 1,
                }
                : null,
              systemSizeKw: systemSizeKwFromDb,
              mpptCountTotal: mpptCountTotalFromDb,
              fireSetbacks,
              solarPanels,
              inverters,
              resolution,
              overlay,
              designType,
              losses: losses_,
              weatherDatasetSelected: weatherDatasetSelectedFromDb,
              weatherDatasetFetchedPath,
              shadingHasRun,
              ...filteredIframeContext,
            },
            () => {
              this.updateSetbacks();
              this.snapshotCommittedPayload();
              this.canvasSceneBaseline = this.canvasSceneKey();
              this.refreshDirtyState();
              if (iframe) return;
              nsrdbDatasetsAPI
                .list()
                .then((nsrdbDatasetsMeta) => {
                  const catalogDefault = nsrdbDatasetsMeta?.default;
                  if (!catalogDefault) return;
                  this.setState((prev) => {
                    if (prev.weatherDatasetFetchedPath) return null;
                    if (parseDatasetKeyFromPath(weatherDatasetFetchedPath)) {
                      return null;
                    }
                    if (
                      prev.weatherDatasetSelected &&
                      prev.weatherDatasetSelected !== 'nsrdb_goes_v4_2024'
                    ) {
                      return null;
                    }
                    if (prev.weatherDatasetSelected === catalogDefault) {
                      return null;
                    }
                    return { weatherDatasetSelected: catalogDefault };
                  });
                })
                .catch(() => {});
            }
          );

          try {
            const shouldPersistDefaultPanel =
              !iframe &&
              !canvasData?.inverters_used &&
              !(Number(canvasData?.total_annual_kwh) > 0) &&
              !canvasData?.selected_panel &&
              (canvasData?.selected_panel_id === undefined || canvasData?.selected_panel_id === null) &&
              package_?.panel?.id !== undefined &&
              package_?.panel?.id !== null;
            if (shouldPersistDefaultPanel) {
              this.context.CanvasAPI.saveCanvas({
                selected_panel_id: String(package_.panel.id),
                selected_panel_spec: null,
              });
            }
          } catch (e) { }

          if (stringingDataFromDb) {
            setTimeout(() => {
              this.restoreStringingSelection(stringingDataFromDb);
            }, 0);
          }

          if (iframe && iframeContext?.setback) {
            const s = iframeContext.setback;
            if (Array.isArray(s)) {
              const bfireSetbacks = {
                ...fireSetbacks,
                eave: s[0],
                ridge: s[1],
                rake: s[2],
                hip: s[3],
                valley: s[4],
              };
              this.updateSetbacks(bfireSetbacks, 1);
            } else {
              const bfireSetbacks = { ...fireSetbacks, general: s };
              this.updateSetbacks(bfireSetbacks, 0);
            }
          }
        }
      ), {
        setLoading: (designerIsLoading) => this.setState({ designerIsLoading }),
        setError: (designerLoadError) => this.setState({ designerLoadError }),
        notifyError: (message) => iframeCallback?.('Error', { code: 'DESIGN_LOAD_FAILED', message })
      });
  };

  componentDidMount() {
    this.loadDesignerData();
    const { lead } = this.context;

    document.addEventListener('keydown', this.onKeyDown, false);
    [
      'pointerdown',
      'pointermove',
      'pointerup',
      'mousedown',
      'mousemove',
      'mouseup',
    ].forEach((type) => {
      document.addEventListener(type, this.blockDesignAltAreaSelect, true);
    });

    this.setState3x({
      coordinates: lead.property.coordinates,
    });

    window.addEventListener('blur', this.handleWindowBlur);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    window.addEventListener('mouseout', this.handleWindowMouseOut);
    window.addEventListener('mouseup', this.handleWindowMouseUp);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.context.CanvasAPI?.setManualPersistOnly?.(true);
  }

  resolveDefaultDesignIdForCanvas = (canvas) => {
    if (!canvas) return '';
    if (canvas.default_design_id) return String(canvas.default_design_id);
    const nested = Array.isArray(canvas.designs) ? canvas.designs : [];
    const active = nested.filter((row) => !row?.archived_at);
    const preferred =
      active.find((row) => row?.is_default) ??
      active.find(
        (row) => String(row?.id) === String(canvas.id || canvas.pk || '')
      ) ??
      active[0];
    return String(preferred?.id || canvas.id || canvas.pk || '');
  };

  getActiveDesignId = () => {
    const { uid, designId, CanvasAPI, canvasScopeId } = this.context;
    if (typeof designId === 'string' && designId.trim()) return designId.trim();
    const resolvedDesign = CanvasAPI?.getCanvasDesignTargetId?.();
    if (resolvedDesign) return String(resolvedDesign);
    const designs = this.state?.designs;
    if (Array.isArray(designs)) {
      const canvasId =
        (typeof canvasScopeId === 'string' && canvasScopeId.trim()) ||
        CanvasAPI?.getCanvasTargetId?.() ||
        '';
      const canvas =
        designs.find(
          (item) => String(item?.id || item?.pk || '') === String(canvasId)
        ) ||
        designs.find((item) => item?.is_default && !item?.archived_at) ||
        designs.find((item) => item?.is_default);
      const fromDefault = this.resolveDefaultDesignIdForCanvas(canvas);
      if (fromDefault) return fromDefault;
    }
    const resolved = CanvasAPI?.getCanvasTargetId?.();
    if (resolved) return String(resolved);
    return uid;
  };

  selectedCanvasImagery = () => {
    const canvasId = String(this.getActiveCanvasId() || '');
    const row = (this.state.designs || []).find(
      (item) => String(item?.id || item?.pk || '') === canvasId
    );
    const rgb = row?.rgb ? String(row.rgb) : '';
    const dsm =
      row?.dsm && row?.image_source !== 'nearmap_rgb_only'
        ? String(row.dsm)
        : '';
    return { rgb, dsm };
  };

  getActiveCanvasId = () => {
    const { canvasScopeId, CanvasAPI } = this.context;
    if (typeof canvasScopeId === 'string' && canvasScopeId.trim()) {
      return canvasScopeId.trim();
    }
    const resolved = CanvasAPI?.getCanvasTargetId?.();
    if (resolved) return String(resolved);
    return this.getActiveDesignId();
  };

  getAITaskStorageKey = () => {
    const { uid } = this.context;
    return buildAiTaskStorageKey(uid, this.getActiveCanvasId());
  };

  clearStoredAITask = () => {
    try {
      window.localStorage.removeItem(this.getAITaskStorageKey());
    } catch (e) { }
  };

  resumeStoredAITask = () => {
    try {
      const raw = window.localStorage.getItem(this.getAITaskStorageKey());
      if (!raw) return;
      const data = JSON.parse(raw);
      if (!data?.taskId) return;
      clearInterval(this.ai_interval);
      this.setState3x({ AIIsRunning: true });
      this.ai_interval = setInterval(() => this.trackTask(data.taskId), 1500);
      this.trackTask(data.taskId);
    } catch (e) { }
  };

  handleAIDesignTaskEvent = (event) => {
    const detail = event?.detail || {};
    const { uid } = this.context;
    if (String(detail.leadId) !== String(uid)) return;
    if (String(detail.canvasId || uid) !== String(this.getActiveCanvasId())) return;
    if (detail.state === 'STARTED' && detail.taskId) {
      clearInterval(this.ai_interval);
      this.setState3x({ AIIsRunning: true });
      this.ai_interval = setInterval(() => this.trackTask(detail.taskId), 1500);
      return;
    }
    if (detail.state === 'SUCCESS') {
      this.clearStoredAITask();
      clearInterval(this.ai_interval);
      this.setState({ AIIsRunning: false, updateRGBTextureIsRunning: false });
      this.reloadCanvas();
      this.loadDesigns();
    }
  };

  loadDesigns = async () => {
    const { newEndpoint, uid } = this.context;
    try {
      this.setState({ isLoadingDesigns: true });
      const canvasesAPI = newEndpoint('designer/canvas/by_lead');
      const data = await canvasesAPI.list(
        `?lead=${encodeURIComponent(uid)}&include_archived=true`,
      );
      const items = Array.isArray(data) ? data : [];
      this.setState({
        designs: items.filter((item) => !item?.archived_at),
        archivedScopes: collectArchivedScopes(items),
      });
    } catch (e) {
    } finally {
      this.setState({ isLoadingDesigns: false });
    }
  };

  setDesignIdInUrl = (nextCanvasId, nextDesignId) => {
    const { uid } = this.context;
    const { history } = this.props;
    if (!history || !uid) return;

    const canvasId =
      typeof nextCanvasId === 'string' ? nextCanvasId.trim() : '';
    const designId =
      typeof nextDesignId === 'string' ? nextDesignId.trim() : '';
    if (!designId && !canvasId) {
      history.push(`/leads/${uid}/design-tool`);
      return;
    }
    const params = new URLSearchParams();
    if (designId) params.set('design_id', designId);
    if (canvasId && canvasId !== designId) {
      params.set('canvas_id', canvasId);
    }
    history.push(`/leads/${uid}/design-tool?${params.toString()}`);
  };

  handleDesignChange = (e) => {
    const raw = String(e?.target?.value || '').trim();
    if (!raw) return;
    const scope = parseScopeOptionValue(raw);
    if (scope) {
      this.handleScopeSelect(scope.canvasId, scope.designId);
      return;
    }
    const canvasId = raw;
    const designs = Array.isArray(this.state?.designs) ? this.state.designs : [];
    const canvas = designs.find(
      (item) => String(item?.id || item?.pk || '') === canvasId
    );
    const designId =
      this.resolveDefaultDesignIdForCanvas(canvas) || canvasId;
    this.handleScopeSelect(canvasId, designId);
  };

  handleScopeSelect = (canvasId, designId) => {
    const nextCanvasId = String(canvasId || '').trim();
    const nextDesignId = String(designId || '').trim();
    if (!nextCanvasId || !nextDesignId) return;
    if (
      String(nextCanvasId) === String(this.getActiveCanvasId()) &&
      String(nextDesignId) === String(this.getActiveDesignId())
    ) {
      return;
    }
    if (this.state.saveNeeded) {
      this.setState({
        scopeConfirm: { canvasId: nextCanvasId, designId: nextDesignId },
      });
      return;
    }
    void this.applyScopeSelect(nextCanvasId, nextDesignId);
  };

  applyScopeSelect = async (canvasId, designId) => {
    const { CanvasAPI } = this.context;
    CanvasAPI?.setCanvasTargetId?.(canvasId, designId);
    this.setDesignIdInUrl(canvasId, designId);
    await this.reloadCanvas();
    const rows = Array.isArray(this.state.designs) ? this.state.designs : [];
    const canvas = rows.find(
      (item) => String(item?.id || item?.pk || '') === String(canvasId)
    );
    const activeDesigns = ((canvas?.designs) || []).filter(
      (row) => !row?.archived_at
    );
    if (String(canvasId) === String(designId) && activeDesigns.length === 0) {
      this.clearSelectedPanelsOnly();
      this.handleCurrentAccordion('segments');
    } else {
      this.handleCurrentAccordion('production');
    }
  };

  reloadCanvas = async (options = {}) => {
    const { CanvasAPI, uid } = this.context;
    if (!CanvasAPI?.getCanvas) return;
    try {
      const canvasData = await CanvasAPI.getCanvas(uid);
      if (canvasData && typeof canvasData === 'object') {
        this.applyCanvasDataFromDb(canvasData, options);
      }
    } catch (e) {
      console.warn('[DesignTool] reloadCanvas failed', e);
    }
  };

  openDroneApp = async () => {
    const { company, lead, uid } = this.context;
    const { drone_project: droneProject } = this.state;
    const backendUrl = getDroneBackendUrl();
    const frontendUrl = getDroneFrontendUrl();
    if (!backendUrl || !frontendUrl) {
      this.context.displaySnack({
        variant: 'warning',
        message: 'Drone integration is not configured for this environment.',
      });
      return;
    }
    const coords = lead?.property?.coordinates || [];
    const lat = Number(coords[0]);
    const long = Number(coords[1]);
    this.setState2x({
      droneModal: {
        show: true,
        loading: true,
        src: '',
        project: droneProject || null,
        bootstrap: null,
      },
    });
    try {
      let project = droneProject;
      if (!project?.projectId) {
        const token = this.auth.getToken();
        if (!token) throw new Error('Please sign in again to start the Drone app.');
        const response = await fetch(`${backendUrl}/projects/${company}/projects`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`,
          },
          body: JSON.stringify({
            name: lead?.address?.street || uid,
            leadId: uid,
            hostLeadId: uid,
            projectType: 'PIPELINE',
            leadType: 'PIPELINE',
            lat,
            long,
            address: lead?.address || {},
          }),
        });
        if (!response.ok) throw new Error('Drone project was not created.');
        const created = await response.json();
        project = {
          projectId: created._id,
          hostLeadId: created.hostLeadId,
          companyId: company,
          projectType: created.leadType || 'PIPELINE',
          projectName: created.name,
        };
      }
      const projectId = project.projectId || project._id;
      const shellUrl = buildDroneShellUrl(frontendUrl);
      if (!shellUrl) throw new Error('Drone shell URL is invalid.');
      const bootstrap = {
        companyId: String(company),
        projectId: String(projectId),
        leadId: String(uid),
        leadName: project.projectName || lead?.address?.street || uid,
        leadType: project.projectType || project.leadType || 'PIPELINE',
        step: 'ORTHOGRAPHY',
        latitude: lat,
        longitude: long,
        address: lead?.address || {},
      };
      window.addEventListener('message', this.handleDroneExportMessage);
      this.setState2x({
        droneModal: {
          show: true,
          loading: false,
          src: shellUrl.toString(),
          project,
          bootstrap,
        },
      });
    } catch (e) {
      this.setState2x({
        droneModal: {
          show: false,
          loading: false,
          src: '',
          project: null,
          bootstrap: null,
        },
      });
      this.context.displaySnack({
        variant: 'danger',
        message: e.message || 'Drone app not started.',
      });
    }
  };

  postDroneBootstrapToFrame = () => {
    const { droneModal } = this.state;
    const ok = postDroneBootstrap(
      this.droneIframeRef.current?.contentWindow,
      getDroneFrontendUrl(),
      droneModal.bootstrap
    );
    if (ok) return;
    this.closeDroneModal();
    this.context.displaySnack({
      variant: 'danger',
      message: 'Drone opened without valid bootstrap data.',
    });
  };

  handleDroneExportMessage = (event) => {
    if (
      isDroneReadyMessage(
        event,
        this.droneIframeRef.current?.contentWindow
      )
    ) {
      this.postDroneBootstrapToFrame();
      return;
    }
    if (this.droneExportIsSaving) return;
    const result = parseDroneExportMessage(
      event,
      this.droneIframeRef.current?.contentWindow
    );
    if (!result.ok) {
      if (!result.ignored) {
        this.context.displaySnack({ variant: 'danger', message: result.error });
      }
      return;
    }

    this.droneExportIsSaving = true;
    this.saveDroneDesignExport(result.payload)
      .catch((error) => {
        this.context.displaySnack({
          variant: 'danger',
          message: error.message || 'Drone export failed.',
        });
      })
      .finally(() => {
        this.droneExportIsSaving = false;
      });
  };

  saveDroneDesignExport = async (payload) => {
    const { newEndpoint, uid } = this.context;
    const canvasId = this.getActiveCanvasId();
    const droneImageryAPI = newEndpoint('crm/lead/drone-imagery/');
    const data = await droneImageryAPI.send('POST', {
      lead: uid,
      canvas_id: canvasId,
      drone_project: compactDroneProject(payload),
      rgb_png_base64: payload.rgbPngBase64,
      dsm_tiff_base64: payload.dsmTiffBase64,
    });
    window.removeEventListener('message', this.handleDroneExportMessage);
    this.setState2x({
      droneModal: {
        show: false,
        loading: false,
        src: '',
        project: null,
        bootstrap: null,
      },
      rgb: data.rgb,
      dsm: data.dsm,
      resolution: data.resolution ? Number(data.resolution) : this.state.resolution,
      dsmParams: data.dsm_params || this.state.dsmParams,
      imageryCacheKey: Date.now(),
      drone_project: data.drone_project,
    });
    await this.reloadCanvas();
    this.context.displaySnack({ variant: 'info', message: 'Drone imagery exported.' });
    this.runAIHandler();
  };

  closeDroneModal = () => {
    window.removeEventListener('message', this.handleDroneExportMessage);
    this.droneExportIsSaving = false;
    this.setState2x({
      droneModal: {
        show: false,
        loading: false,
        src: '',
        project: null,
        bootstrap: null,
      },
    });
  };

  restoreStringingSelection = (strings) => {
    if (!Array.isArray(strings) || strings.length === 0) return;
    if (!this.canvas3DElement?.selectPanelsFromStringing) return;
    this.suppressSolarProductionFromSelection = true;
    try {
      this.canvas3DElement.selectPanelsFromStringing(strings, 'all');
    } catch (e) { }
    if (this.stringingRestoreTimer) clearTimeout(this.stringingRestoreTimer);
    this.stringingRestoreTimer = setTimeout(() => {
      this.suppressSolarProductionFromSelection = false;
      this.stringingRestoreTimer = null;
    }, 800);
  };

  applyCanvasDataFromDb = (canvasData, options = {}) => {
    if (!canvasData || typeof canvasData !== 'object') return;
    const patch = hydrateDesignerStateFromCanvas({
      state: this.state,
      canvasData,
      utility: this.context?.lead?.utility,
      propertyResolution: this.context?.lead?.property?.resolution,
    });
    const placed = (panels) =>
      Array.isArray(panels) &&
      panels.some(
        (panel) =>
          (panel?.horizontal?.points?.length || 0) > 0 ||
          (panel?.vertical?.points?.length || 0) > 0
      );
    if (placed(options.preservePanels)) {
      patch.panels = options.preservePanels;
    }
    if (options.shadingCompleted) {
      patch.shadingHasRun = true;
      patch.shadingNeedsRerun = false;
      patch.shadingRerunNoticeShown = false;
    }
    this.setStatex(
      patch,
      () => {
        this.restoreStringingSelection(patch.stringingData);
        this.snapshotCommittedPayload();
        this.refreshDirtyState();
      }
    );
    this.canvasSceneBaseline = JSON.stringify({
      segments: patch.segments,
      obstacles: patch.obstacles,
      trees: patch.trees,
      annotations: patch.annotations,
      colorRange: patch.colorRange,
    });
  };

  canvasSceneKey = () => JSON.stringify({
    segments: this.state.segments,
    obstacles: this.state.obstacles,
    trees: this.state.trees,
    annotations: this.state.annotations,
    colorRange: this.state.colorRange,
  });

  isCanvasDirty = () => {
    if (!this.canvasSceneBaseline) return false;
    return this.canvasSceneKey() !== this.canvasSceneBaseline;
  };

  committedSavePayload = null;

  snapshotCommittedPayload = () => {
    try {
      this.committedSavePayload = JSON.parse(
        JSON.stringify(this.buildSavePayload())
      );
    } catch (e) {
      console.warn('[DesignTool] snapshotCommittedPayload failed', e);
      this.committedSavePayload = null;
    }
  };

  designDirtyStatus = () => {
    const empty = {
      isCanvasChanged: false,
      isDesignChanged: false,
      isAnnotationChanged: false,
    };
    if (!this.committedSavePayload) return empty;
    try {
      return diffCanvasStates(this.committedSavePayload, this.buildSavePayload());
    } catch (e) {
      console.warn('[DesignTool] dirty check failed', e);
      return empty;
    }
  };

  refreshDirtyState = () => {
    const status = this.designDirtyStatus();
    const saveNeeded = isDirtyStatus(status);
    const prevStatus = this.state.dirtyStatus || {};
    if (
      saveNeeded !== this.state.saveNeeded ||
      status.isCanvasChanged !== prevStatus.isCanvasChanged ||
      status.isDesignChanged !== prevStatus.isDesignChanged ||
      status.isAnnotationChanged !== prevStatus.isAnnotationChanged
    ) {
      this.setState({ saveNeeded, dirtyStatus: status });
    }
  };

  handleBeforeUnload = (event) => {
    if (this.state.saveNeeded) event.preventDefault();
  };

  buildSavePayload = () => {
    const {
      segments,
      obstacles,
      trees,
      panels,
      annotations,
      colorRange,
      buffer,
      rowSpacing,
      panelTilt,
      azimuthRestriction,
      panelPlacementFillMode,
      panelPlacementLayoutMode,
      panelPlacementOnlySelectedRoof,
      losses,
      package: installationPackage,
      primaryInverterAutoQuantity,
      useTargetProduction,
      targetProductionKwh,
      maxDcAcRatio,
      onlySelectedPanels,
    } = this.state;
    return {
      segments,
      obstacles,
      trees: (trees || []).map((tree) => {
        const key = 'trunkHeight' in tree ? 'trunkHeight' : 'trunk_height';
        if (tree[key] === undefined || tree[key] === null) return tree;
        return { ...tree, [key]: Number(Number(tree[key]).toFixed(2)) };
      }),
      panels,
      annotations,
      colorRange,
      buffer,
      rowSpacing,
      panelTilt,
      azimuthRestriction,
      panelPlacementFillMode,
      panelPlacementLayoutMode,
      panelPlacementOnlySelectedRoof,
      losses,
      ...(() => {
        const identityKeys = new Set([
          'id',
          'pk',
          'hardware_id',
          'hardwareId',
          'companyPanelID',
          'companyPanelId',
          'companyInverterID',
          'companyInverterId',
        ]);
        const inlineSpec = (spec) => {
          if (!spec || typeof spec !== 'object' || Array.isArray(spec)) return null;
          const next = {};
          Object.keys(spec).forEach((key) => {
            if (identityKeys.has(key) || spec[key] === undefined) return;
            next[key] = spec[key];
          });
          return Object.keys(next).length ? next : null;
        };
        const panelSpec = inlineSpec(installationPackage?.selectedPanelSpec);
        const inverterSpec = inlineSpec(installationPackage?.selectedInverterSpec);
        return {
          selected_panel_id: panelSpec
            ? null
            : installationPackage?.panel?.id || null,
          selected_panel_spec: panelSpec,
          selected_inverter_id: inverterSpec
            ? null
            : installationPackage?.inverter?.id || null,
          selected_inverter_spec: inverterSpec,
        };
      })(),
      inverter_quantity: installationPackage?.inverterQuantity ?? 1,
      primary_inverter_auto_quantity: primaryInverterAutoQuantity,
      additional_inverters: installationPackage?.additional_inverters || [],
      use_target_production: useTargetProduction,
      target_production_kwh: targetProductionKwh,
      max_dc_ac_ratio: maxDcAcRatio,
      only_selected_panels: onlySelectedPanels,
      total_annual_kwh: this.state.totalAnnualKwh,
      total_monthly_kwh: Array.isArray(this.state.totalMonthlyKwh)
        ? this.state.totalMonthlyKwh.join(',')
        : this.state.totalMonthlyKwh,
      total_clipping_kwh: this.state.totalClippingKwh,
      total_monthly_clipping_kwh: Array.isArray(this.state.totalMonthlyClippingKwh)
        ? this.state.totalMonthlyClippingKwh.join(',')
        : this.state.totalMonthlyClippingKwh,
      dc_ac_ratio: this.state.dcAcRatio,
      system_size_kw: this.state.systemSizeKw,
      stringing_data: this.state.stringingData,
      stringing_panel_index_mode: this.state.stringingPanelIndexMode || 'all',
      inverters_used: this.state.invertersUsed,
      production_per_panel:
        this.state.productionPerPanelData ?? this.state.productionPerPanel,
      production_per_string:
        this.state.productionPerStringData ?? this.state.productionPerString,
      hourly_production: this.state.hourlyProduction,
    };
  };

  scopeName = (canvasId, designId) => {
    const rows = Array.isArray(this.state.designs) ? this.state.designs : [];
    const canvas = rows.find(
      (item) => String(item?.id || item?.pk || '') === String(canvasId)
    );
    const nested = Array.isArray(canvas?.designs) ? canvas.designs : [];
    const child = nested.find(
      (row) => String(row?.id || '') === String(designId)
    );
    if (child) {
      return (
        (child.name && String(child.name).trim()) ||
        (child.is_default ? 'Default design' : '')
      );
    }
    const name = canvas?.name && String(canvas.name).trim();
    return name || (canvas?.is_default ? 'Default design' : '');
  };

  handleRenameDesign = async (scopeCanvasId, scopeDesignId, scopeKind) => {
    const canvasId = String(scopeCanvasId || this.getActiveCanvasId() || '').trim();
    const activeId = String(scopeDesignId || this.getActiveDesignId() || '').trim();
    if (!canvasId || !activeId) return;

    const kind = scopeKind || resolveArchiveTarget(canvasId, activeId, this.state.designs);
    const nameId = kind === 'canvas' ? canvasId : activeId;
    const currentName = this.scopeName(canvasId, nameId);
    this.setState({
      renameModal: {
        canvasId,
        designId: nameId,
        kind,
        name: currentName || '',
      },
    });
  };

  submitRenameModal = async () => {
    const { newEndpoint, displaySnack } = this.context;
    const modal = this.state.renameModal;
    if (!modal) return;
    const trimmed = String(modal.name || '').trim();
    if (!trimmed) return;
    const { canvasId, designId: activeId, kind: target } = modal;

    try {
      this.setState({ isRenamingDesign: true });
      if (target === 'canvas') {
        await newEndpoint('designer/canvas').update(
          canvasId, { name: trimmed }, true
        );
      } else {
        const api = newEndpoint(
          `designer/canvas/${encodeURIComponent(canvasId)}/designs`
        );
        await api.update(activeId, { name: trimmed }, true);
      }
      await this.loadDesigns();
      this.setState({ renameModal: null });
      try {
        displaySnack({
          variant: 'success',
          message: 'Design renamed',
        });
      } catch (e) {}
    } catch (e) {
      try {
        displaySnack({
          variant: 'danger',
          message: 'Failed to rename design',
        });
      } catch (err) {}
    } finally {
      this.setState({ isRenamingDesign: false });
    }
  };

  handleArchiveDesign = async (scopeCanvasId, scopeDesignId, scopeKind, scopeLabel) => {
    const canvasId = String(scopeCanvasId || this.getActiveCanvasId() || '').trim();
    const designId = String(scopeDesignId || this.getActiveDesignId() || '').trim();
    if (!canvasId || !designId) return;
    const target = scopeKind || resolveArchiveTarget(
      canvasId,
      designId,
      this.state.designs,
    );
    const scopedDesignId = target === 'canvas' ? canvasId : designId;
    const label = scopeLabel
      || this.scopeName(canvasId, scopedDesignId)
      || (target === 'canvas' ? 'canvas' : 'design');
    let message = `Archive "${label}"?`;
    if (target === 'canvas') {
      const rows = Array.isArray(this.state.designs) ? this.state.designs : [];
      const canvas = rows.find(
        (item) => String(item?.id || item?.pk || '') === String(canvasId)
      );
      const count = ((canvas?.designs) || []).filter(
        (row) => !row?.archived_at
      ).length;
      if (count > 1) {
        message = `This canvas has ${count} unarchived designs. Archive "${label}" anyway?`;
      }
    }
    this.setState({
      archiveModal: { canvasId, designId: scopedDesignId, kind: target, label, message },
    });
  };

  submitArchiveModal = async () => {
    const { CanvasAPI, displaySnack } = this.context;
    const modal = this.state.archiveModal;
    if (!modal) return;
    const { canvasId, designId, kind: target } = modal;
    this.setState({ archiveModal: null });
    const wasActive =
      String(canvasId) === String(this.getActiveCanvasId()) &&
      (target === 'canvas' ||
        String(designId) === String(this.getActiveDesignId()));

    try {
      this.setState({ isArchivingDesign: true });
      if (target === 'canvas') {
        await CanvasAPI.archiveCanvas(canvasId);
      } else {
        await CanvasAPI.archiveDesign(canvasId, designId);
      }
      const data = await CanvasAPI.listCanvasDesignsForLead({
        includeArchived: true,
      });
      const items = Array.isArray(data) ? data : [];
      this.setState({
        designs: items.filter((item) => !item?.archived_at),
        archivedScopes: collectArchivedScopes(items),
      });
      if (wasActive) {
        const next = pickNextActiveScope(items);
        if (next) {
          CanvasAPI.setCanvasTargetId(next.canvasId, next.designId);
          this.setDesignIdInUrl(next.canvasId, next.designId);
          await this.reloadCanvas();
        } else {
          this.setDesignIdInUrl(null, null);
        }
      }
      try {
        displaySnack({
          variant: 'success',
          message: 'Design archived',
        });
      } catch (e) {}
    } catch (e) {
      try {
        const detail = e?.response?.data?.detail;
        displaySnack({
          variant: 'danger',
          message:
            (Array.isArray(detail) ? detail[0] : detail) ||
            'Failed to archive design',
        });
      } catch (err) {}
    } finally {
      this.setState({ isArchivingDesign: false });
    }
  };

  handleRestoreDesign = async (rawValue) => {
    const { CanvasAPI, displaySnack } = this.context;
    const scope = parseArchivedScopeValue(rawValue);
    if (!scope) return;

    try {
      this.setState({ isArchivingDesign: true });
      if (scope.kind === 'design') {
        await CanvasAPI.restoreDesign(scope.canvasId, scope.designId);
      } else {
        await CanvasAPI.restoreCanvas(scope.canvasId);
      }
      await this.loadDesigns();
      CanvasAPI.setCanvasTargetId(scope.canvasId, scope.designId);
      this.setDesignIdInUrl(scope.canvasId, scope.designId);
      await this.reloadCanvas();
      try {
        displaySnack({
          variant: 'success',
          message: 'Design restored',
        });
      } catch (e) {}
    } catch (e) {
      try {
        const detail = e?.response?.data?.detail;
        displaySnack({
          variant: 'danger',
          message:
            (Array.isArray(detail) ? detail[0] : detail) ||
            'Failed to restore design',
        });
      } catch (err) {}
    } finally {
      this.setState({ isArchivingDesign: false });
    }
  };

  suggestedCloneName = (kind) => {
    const canvases = Array.isArray(this.state.designs) ? this.state.designs : [];
    return suggestedNameForLead({
      kind,
      existingNames: canvases.flatMap((canvas) => [
        String(canvas?.name || ''),
        ...(Array.isArray(canvas?.designs) ? canvas.designs : []).map((d) =>
          String(d?.name || '')
        ),
      ]),
    });
  };

  openCloneDialog = () => {
    if (!this.getActiveCanvasId()) return;
    this.setState({
      cloneDialogOpen: true,
      cloneName: this.suggestedCloneName(
        this.state.dirtyStatus?.isCanvasChanged ? 'canvas' : 'design'
      ),
      cloneTarget: 'canvas',
    });
  };

  closeCloneDialog = () => {
    if (this.state.isCloningDesign) return;
    this.setState({ cloneDialogOpen: false });
  };

  confirmCloneDesign = async () => {
    const { newEndpoint, displaySnack } = this.context;
    const canvasId = this.getActiveCanvasId();
    const designId = this.getActiveDesignId();
    const name = String(this.state.cloneName || '').trim();
    if (!canvasId || !name) {
      return;
    }

    try {
      this.setState({ isCloningDesign: true });
      let snapshot = null;
      try {
        const shot = await this.canvas3DElement?.exportDesignSnapshot?.();
        snapshot = shot?.base64 || null;
      } catch (e) {}
      const cloneAPI = newEndpoint(`designer/canvas/${canvasId}/save-as`);
      const created = await cloneAPI.create({
        name,
        design_name: name,
        target: 'auto',
        design_id: designId,
        state: this.buildSavePayload(),
        update_lead_design_default: true,
      });

      if (!created?.id) {
        throw new Error('Clone did not return id');
      }

      this.setState({ cloneDialogOpen: false });
      await this.loadDesigns();
      const nextCanvasId = String(
        created.canvas_id || created.canvas || canvasId
      );
      const nextDesignId = String(
        created.design_id ||
          created.default_design_id ||
          (created.save_as_target === 'design' ? created.id : designId)
      );
      try {
        await this.uploadDesignSnapshot(nextDesignId, snapshot);
      } catch (e) {}
      await this.applyScopeSelect(nextCanvasId, nextDesignId);
    } catch (e) {
      try {
        displaySnack({
          variant: 'danger',
          message: 'Failed to save as canvas',
        });
      } catch (err) { }
    } finally {
      this.setState({ isCloningDesign: false });
    }
  };

  // TODO: Implement saving for each annotation type instead of always calling saveAll
  componentDidUpdate(prevProps, prevState) {
    try {
      const prevSearch = prevProps?.location?.search || '';
      const nextSearch = this.props?.location?.search || '';
      if (prevSearch !== nextSearch) {
        const prevParams = new URLSearchParams(prevSearch);
        const nextParams = new URLSearchParams(nextSearch);
        const prevDesignId = prevParams.get('design_id');
        const nextDesignId = nextParams.get('design_id');
        const prevCanvasId = prevParams.get('canvas_id');
        const nextCanvasId = nextParams.get('canvas_id');
        if (
          prevDesignId !== nextDesignId ||
          prevCanvasId !== nextCanvasId
        ) {
          this.reloadCanvas();
          this.loadDesigns();
          return;
        }
      }
    } catch (e) { }

    if (!(this.canvas3DElement && this.canvas3DElement.isLoaded)) return;

    const { currentAccordion, fireSetbacks } = this.state;

    if (currentAccordion === 'segments') {
      this.refreshRoofAreasFromCanvas();
    }

    const enteringProduction =
      prevState.currentAccordion !== 'production' &&
      currentAccordion === 'production';
    if (
      enteringProduction &&
      this.state.stringingData &&
      this.canvas3DElement?.selectPanelsFromStringing
    ) {
      try {
        this.restoreStringingSelection(this.state.stringingData);
        const countSelected = () => {
          try {
            const byVertex = this.canvas3DElement?.getSelectedPanelsByVertex
              ? this.canvas3DElement.getSelectedPanelsByVertex()
              : {};
            return Object.values(byVertex || {}).reduce(
              (sum, arr) => sum + (Array.isArray(arr) ? arr.length : 0),
              0
            );
          } catch {
            return 0;
          }
        };
        if (countSelected() === 0) {
          let tries = 0;
          const retry = () => {
            tries += 1;
            if (tries > 6) return;
            try {
              this.restoreStringingSelection(this.state.stringingData);
              if (countSelected() > 0) return;
            } catch (e) { }
            setTimeout(retry, 100);
          };
          setTimeout(retry, 100);
        }
      } catch (e) { }
    }
    const { iframe, context: iframeContext = {} } = this.props;
    const { currentAccordion: prevAccordion } = prevState;
    const { context: prevContext = {} } = prevProps;

    if (
      iframe &&
      iframeContext?.setback &&
      JSON.stringify(prevContext?.setback) !==
      JSON.stringify(iframeContext?.setback)
    ) {
      const s = iframeContext.setback;
      if (Array.isArray(s)) {
        const bfireSetbacks = {
          ...fireSetbacks,
          eave: s[0],
          ridge: s[1],
          rake: s[2],
          hip: s[3],
          valley: s[4],
        };
        this.updateSetbacks(bfireSetbacks, 1);
      } else {
        const bfireSetbacks = { ...fireSetbacks, general: s };
        this.updateSetbacks(bfireSetbacks, 0);
      }
    } else if (
      !konvaKeys.includes(prevAccordion) &&
      konvaKeys.includes(currentAccordion)
    ) {
      console.log('update setbacks.');
      this.updateSetbacks();
    }

    const previousSelectedRoofSegmentCount =
      prevState.selectedObjects?.roofSegments?.length || 0;
    const selectedRoofSegmentCount =
      this.state.selectedObjects?.roofSegments?.length || 0;
    if (
      shouldAutoEnableSelectedRoofPlacement(
        previousSelectedRoofSegmentCount,
        selectedRoofSegmentCount,
        this.state.panelPlacementOnlySelectedRoof
      )
    ) {
      this.setState({ panelPlacementOnlySelectedRoof: true });
    }
    if (
      DIRTY_WATCH_KEYS.some((key) => prevState[key] !== this.state[key])
    ) {
      this.refreshDirtyState();
    }
  }

  componentWillUnmount() {
    this.panelPlacementUnmounted = true;
    this.panelPlacementRequestId += 1;
    this.panelPlacementCallbackArmed = false;
    this.panelPlacementCallbackRequestId = null;
    if (this.panelPlacementStartTimer) {
      clearTimeout(this.panelPlacementStartTimer);
      this.panelPlacementStartTimer = null;
    }
    if (this.panelPlacementFinalizeTimer) {
      clearTimeout(this.panelPlacementFinalizeTimer);
      this.panelPlacementFinalizeTimer = null;
    }
    if (this.panelPlacementUpdateTimer) {
      clearTimeout(this.panelPlacementUpdateTimer);
      this.panelPlacementUpdateTimer = null;
    }
    document.removeEventListener('keydown', this.onKeyDown, false);
    [
      'pointerdown',
      'pointermove',
      'pointerup',
      'mousedown',
      'mousemove',
      'mouseup',
    ].forEach((type) => {
      document.removeEventListener(type, this.blockDesignAltAreaSelect, true);
    });
    try {
      window.removeEventListener('blur', this.handleWindowBlur);
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
      window.removeEventListener('crm-ai-design-task', this.handleAIDesignTaskEvent);
      window.removeEventListener('message', this.handleDroneExportMessage);
      window.removeEventListener('mouseout', this.handleWindowMouseOut);
      window.removeEventListener('mouseup', this.handleWindowMouseUp);
      document.removeEventListener(
        'visibilitychange',
        this.handleVisibilityChange
      );
    } catch (e) { }
    this.unlockPageScroll();
    try {
      clearTimeout(this.solarProductionDebounceTimer);
      clearInterval(this.ai_interval);
      clearInterval(this.rectification_interval);
    } catch (e) { }
    this.resolvePanelPlacementCompletion(new Error('Panel placement cancelled'));
  }

  resolvePanelPlacementCompletion = (
    error = null,
    requestId = null,
    result = undefined
  ) => {
    const completion = this.panelPlacementCompletion;
    if (!completion) return;
    if (requestId !== null && completion.requestId !== requestId) return;
    this.panelPlacementCompletion = null;
    if (error) completion.reject(error);
    else completion.resolve(result);
  };

  queuePanelPlacementPersistence = (save) => {
    const previous =
      this.panelPlacementPersistencePromise || Promise.resolve();
    const persistence = previous.then(() => save());
    const settledPersistence = persistence.catch(() => {});
    this.panelPlacementPersistencePromise = settledPersistence;
    settledPersistence.finally(() => {
      if (this.panelPlacementPersistencePromise === settledPersistence) {
        this.panelPlacementPersistencePromise = null;
      }
    });
    return persistence;
  };

  refreshRoofAreasFromCanvas = () => {
    try {
      const getter = this.canvas3DElement?.getRoofAreas3D;
      if (typeof getter !== 'function') return;
      const data = getter();
      const signature = data?.signature || '';
      if (signature === this.state.roofAreasSignature) return;
      const areasSqFt = Array.isArray(data?.areasSqFt) ? data.areasSqFt : [];
      const unit = data?.unit || 'ft²';
      this.setState({
        roofAreasSqFt: areasSqFt,
        roofAreasUnit: unit,
        roofAreasSignature: signature,
      });
    } catch (e) { }
  };

  isKeyboardShortcutTargetEditable = (target) => {
    if (!target) return false;
    const tagName = String(target.tagName || '').toLowerCase();
    return (
      target.isContentEditable ||
      ['input', 'textarea', 'select'].includes(tagName)
    );
  };

  hasSelectedPanelsForShortcut = () => {
    const { selectedObjects, selectedPanels } = this.state;
    if (selectedPanels) return true;
    const panels = selectedObjects?.panels;
    return (
      panels &&
      Object.values(panels).some(
        (items) => Array.isArray(items) && items.length > 0
      )
    );
  };

  runPanelKeyboardShortcut = (key) => {
    const { currentAccordion, selectedRoof } = this.state;
    if (currentAccordion !== 'revise') return false;

    if (key === 'v' || key === 'h') {
      if (selectedRoof === -1) return false;
      this.setPanelPlacementFillMode(key === 'v' ? 2 : 1);
      this.canvas3DElement?.toggleView?.('insert', false, true);
      return true;
    }

    if (!this.hasSelectedPanelsForShortcut()) return false;

    switch (key) {
      case 'r':
        this.handleRotatePanel();
        return true;
      case 'm':
        this.canvas3DElement?.toggleView?.('move', false, true);
        return true;
      case 'd':
        this.handleDeletePanel();
        return true;
      case 'a':
        this.canvas3DElement?.alignVertical?.();
        return true;
      case 'b':
        this.canvas3DElement?.alignHorizontal?.();
        return true;
      default:
        return false;
    }
  };

  runModeKeyboardShortcut = (key) => {
    const { currentAccordion } = this.state;
    if (!['segments', 'obstacles', 'trees'].includes(currentAccordion)) {
      return false;
    }

    const modeByKey = {
      1: 'draw',
      2: 'edit',
      3: 'delete',
    };
    const mode = modeByKey[key];
    if (!mode) return false;
    this.handleMode(mode);
    return true;
  };

  onKeyDown = (e) => {
    if (this.isKeyboardShortcutTargetEditable(e.target)) return;
    if (e.ctrlKey || e.metaKey || e.altKey) return;

    if (e.key === '+') {
      this.handleScaleUp();
      return;
    }
    if (e.key === '-') {
      this.handleScaleDown();
      return;
    }

    const key = String(e.key || '').toLowerCase();
    const handled =
      this.runPanelKeyboardShortcut(key) || this.runModeKeyboardShortcut(key);
    if (handled) e.preventDefault();
  };

  clearProductionCache = () => {
    this.lastProductionSnapshot = null;
    this.lastSelectedPanelIndexMapForPayload = null;
    this.lastRoofIndexMapForPayload = null;
  };

  resetProductionForLayoutChange = (extraState = {}) => {
    this.clearProductionCache();
    const { productionIsRunning, ...resetState } = applyProductionReset({});
    return {
      ...resetState,
      ...extraState,
    };
  };

  persistProductionReset = (extraCanvas = {}, options = {}) => {
    const { CanvasAPI } = this.context;
    if (!CanvasAPI?.saveCanvas) return Promise.resolve();
    return CanvasAPI.saveCanvas(
      {
        ...createProductionResetCanvas(),
        ...extraCanvas,
      },
      options
    );
  };

  uploadDesignSnapshot = async (designId, base64) => {
    const id = String(designId || '').trim();
    const endpoint = this.context?.newEndpoint?.('designer/design');
    if (!id || typeof endpoint?.send !== 'function') return;
    let image = base64;
    if (!image) {
      const shot = await this.canvas3DElement?.exportDesignSnapshot?.();
      image = shot?.base64;
    }
    if (!image) return;
    const response = await fetch(image);
    const blob = await response.blob();
    const file = new File([blob], `design_snapshot_${Date.now()}.png`, {
      type: 'image/png',
    });
    const form = new FormData();
    form.append('snapshot', file);
    await endpoint.send('POST', form, `${id}/snapshot`);
  };

  handleSaveAll = (confirmArchiveSiblings = false) => {
    const { CanvasAPI, displaySnack, newEndpoint } = this.context;
    if (!CanvasAPI?.saveCanvas) {
      try {
        displaySnack({
          variant: 'danger',
          message: 'Unable to save canvas.',
        });
      } catch (e) {}
      return;
    }

    const payload = this.buildSavePayload();

    CanvasAPI.saveCanvas(payload, {
      force: true,
      strict: true,
      canvasChanged: this.isCanvasDirty(),
      confirmArchiveSiblings: confirmArchiveSiblings === true,
      updateDefaults: true,
      updateLeadDesignDefault: true,
    })
      .then(async (canvasData) => {
        if (canvasData && typeof canvasData === 'object') {
          this.applyCanvasDataFromDb(canvasData);
        }
        this.setState({ archiveSiblingsOpen: false });
        const canvasId = this.getActiveCanvasId();
        const designId =
          String(canvasData?.design_id || this.getActiveDesignId() || '');
        if (canvasId && designId && newEndpoint) {
          try {
            const defaultAPI = newEndpoint(
              `designer/canvas/${canvasId}/designs/${designId}/default`
            );
            await defaultAPI.create({});
          } catch (e) {}
        }
        try {
          await this.uploadDesignSnapshot(designId);
        } catch (e) {}
        await this.loadDesigns();
        try {
          displaySnack({
            variant: 'success',
            message: 'Canvas saved.',
          });
        } catch (e) {}
      })
      .catch((error) => {
        if (error?.status === 409 || error?.message === 'canvas_sibling_archive_required') {
          this.setState({
            archiveSiblingsOpen: true,
            archiveSiblings: Array.isArray(error.designs) ? error.designs : [],
          });
          return;
        }
        try {
          displaySnack({
            variant: 'danger',
            message: 'Unable to save canvas.',
          });
        } catch (e) {}
      });
  };

  // This function is for sending data to backend and receive auto-placed panels in return.
  exportCanvas = (includeChildren = false) => {
    const {
      lead: { property },
      uid,
      user,
    } = this.context;
    const { obstacles, segments, trees, resolution } = this.state;
    console.log('exporting...');

    const [lat, lng] = property.coordinates;
    const request = {
      lat,
      lng,
      uid,
      design_id: this.getActiveDesignId(),
      company: user?.company?.id,
      resolution,
      ai_design: false, // property.design_type === 'A',
      obstacles,
    };

    request.obstacles = obstacles;

    request.roofs = segments.map(({ pitch, ...roof }, index) => {
      if (includeChildren) {
        roof.children = segments
          .filter(({ geometry: shape }, jdx) => {
            if (index === jdx) return false;
            return shape.every((pt) => isPointInShape(pt, roof.geometry));
          })
          .map((child) => child.geometry);
      }
      return { ...roof, pitch };
    });

    request.trees = trees.map(({ geometry: points, ...tree }) => {
      let radius = 0;
      let geometry = points;
      if (tree.shape === 'Circle') {
        const [p1, p2] = points;
        radius = Math.ceil(distance(p1, p2));
        geometry = [p1];
      }
      return { ...tree, geometry, radius };
    });
    return request;
  };

  handlePlacement = (
    params = null,
    serverSide = false,
    fillMode = 3,
    layoutMode = 2
  ) => {
    const requestId = ++this.panelPlacementRequestId;
    const actionId = createPanelPlacementActionId();
    this.unlockPageScroll();
    this.panelPlacementCallbackArmed = false;
    this.panelPlacementCallbackRequestId = null;
    if (this.panelPlacementStartTimer) {
      clearTimeout(this.panelPlacementStartTimer);
      this.panelPlacementStartTimer = null;
    }
    if (this.panelPlacementFinalizeTimer) {
      clearTimeout(this.panelPlacementFinalizeTimer);
      this.panelPlacementFinalizeTimer = null;
    }
    if (this.panelPlacementUpdateTimer) {
      clearTimeout(this.panelPlacementUpdateTimer);
      this.panelPlacementUpdateTimer = null;
    }
    this.resolvePanelPlacementCompletion(new Error('Panel placement superseded'));

    const placementCompletion = new Promise((resolve, reject) => {
      this.panelPlacementCompletion = {
        requestId,
        actionId,
        targetSegmentIndices: null,
        baselinePanelCount: countPlacedPanels(this.state.panels),
        resolve,
        reject,
        fail: null
      };
    });
    placementCompletion.catch(() => {});

    console.info('[Fill Panels] started', {
      actionId,
      requestId,
      serverSide,
      fillMode,
      layoutMode
    });

    const isCurrentRequest = () =>
      !this.panelPlacementUnmounted &&
      this.panelPlacementRequestId === requestId;
    const failPlacement = (error) => {
      const completion = this.panelPlacementCompletion;
      const ownsCompletion = completion?.requestId === requestId;
      if (this.panelPlacementRequestId !== requestId || !ownsCompletion) return;
      const normalizedError =
        error instanceof Error
          ? error
          : new Error(String(error || 'Panel placement failed'));
      if (this.panelPlacementStartTimer) {
        clearTimeout(this.panelPlacementStartTimer);
        this.panelPlacementStartTimer = null;
      }
      if (this.panelPlacementFinalizeTimer) {
        clearTimeout(this.panelPlacementFinalizeTimer);
        this.panelPlacementFinalizeTimer = null;
      }
      this.panelPlacementCallbackArmed = false;
      this.panelPlacementCallbackRequestId = null;
      if (!this.panelPlacementUnmounted) {
        this.setState3x({ panelPlacementIsRunning: false });
      }
      this.unlockPageScroll();
      console.error('[Fill Panels] error', {
        actionId,
        requestId,
        message: normalizedError.message
      });
      try {
        this.context.displaySnack({
          variant: 'danger',
          message: `Fill Panels failed: ${normalizedError.message}. Reference: ${actionId}`
        });
      } catch (e) {}
      const { callback: iframeCallback } = this.props;
      if (iframeCallback) {
        iframeCallback('Error', {
          code:
            normalizedError.iframeCode || 'PANEL_PLACEMENT_FAILED',
          message: normalizedError.message,
          action_id: actionId
        });
      }
      this.resolvePanelPlacementCompletion(normalizedError, requestId);
    };
    if (this.panelPlacementCompletion?.requestId === requestId) {
      this.panelPlacementCompletion.fail = failPlacement;
    }

    const runPlacement = async () => {
      const pendingPersistence = this.panelPlacementPersistencePromise;
      if (pendingPersistence) await pendingPersistence;
      if (!isCurrentRequest()) {
        throw new Error('Panel placement cancelled');
      }

      await this.applyPendingPanelHardware();
      if (!isCurrentRequest()) return;

      const {
        iframe,
        context: iframeContext,
      } = this.props;
      this.clearSelectedPanelsOnly();
      this.setState3x({ panelPlacementIsRunning: true });

      if (!serverSide) {
        const companyPanelID = iframe
          ? params?.companyPanelID !== undefined
            ? params.companyPanelID
            : iframeContext?.companyPanelID
          : null;
        if (companyPanelID !== null && companyPanelID !== undefined) {
          const { newEndpoint } = this.context;
          const companyPanelsAPI = newEndpoint('panels/company/');
          const panelResolution = await retrieveCompanyHardwareWithFallback({
            retrieve: (id) => companyPanelsAPI.retrieve(id),
            id: companyPanelID,
            currentHardware: this.state.package?.panel,
            inlineHardware: params?.panelType || iframeContext?.panelType,
            kind: 'panel',
          });
          if (!isCurrentRequest()) return;
          if (panelResolution.source !== 'current-fallback') {
            await this.changePanelHardware(panelResolution.hardware);
          } else {
            console.warn(
              `[Iframe] panel ${companyPanelID} is unavailable; keeping current package panel`
            );
          }
          if (!isCurrentRequest()) return;
        }

        let panelPlacementFillMode = fillMode;
        let panelPlacementLayoutMode = layoutMode;
        if (params?.fill_mode) {
          panelPlacementFillMode = params?.fill_mode;
        } else if (iframeContext?.panelOrientation) {
          panelPlacementFillMode = iframeContext?.panelOrientation;
        }
        if (params?.layout_mode) {
          panelPlacementLayoutMode = params?.layout_mode;
        } else if (iframeContext?.panelLayout) {
          panelPlacementLayoutMode = iframeContext?.panelLayout;
        }
        const {
          panelPlacementOnlySelectedRoof,
          selectedObjects,
        } = this.state;
        const selectedRoofSegments = Array.isArray(
          selectedObjects?.roofSegments
        )
          ? [...selectedObjects.roofSegments]
          : [];
        const hasRoofSelection = selectedRoofSegments.length > 0;
        const restrictToSelection = panelPlacementOnlySelectedRoof;
        if (this.panelPlacementCompletion?.requestId === requestId) {
          const targetSegmentIndices =
            restrictToSelection && hasRoofSelection
              ? selectedRoofSegments
              : null;
          this.panelPlacementCompletion.targetSegmentIndices =
            targetSegmentIndices;
          this.panelPlacementCompletion.baselinePanelCount = countPlacedPanels(
            this.state.panels,
            targetSegmentIndices
          );
        }
        const fillModeNum = Number(panelPlacementFillMode);
        const layoutModeNum = Number(panelPlacementLayoutMode);
        const startTimer = setTimeout(() => {
          if (this.panelPlacementStartTimer === startTimer) {
            this.panelPlacementStartTimer = null;
          }
          if (!isCurrentRequest()) return;
          try {
            this.panelPlacementCallbackArmed = true;
            this.panelPlacementCallbackRequestId = requestId;
            if (restrictToSelection && hasRoofSelection) {
              this.canvas3DElement.panelPlacementByIndices(
                selectedRoofSegments,
                fillModeNum,
                layoutModeNum
              );
            } else {
              this.canvas3DElement.panelPlacement(
                false,
                fillModeNum,
                layoutModeNum
              );
            }
            if (
              this.panelPlacementCallbackArmed &&
              !this.panelPlacementFinalizeTimer
            ) {
              throw new Error('Panel placement did not complete');
            }
            if (!isCurrentRequest()) return;
            this.resetLegacyFlagsAfterPlacement(
              restrictToSelection && hasRoofSelection
                ? selectedRoofSegments
                : null
            );
          } catch (error) {
            failPlacement(error);
          }
        }, 1500);
        this.panelPlacementStartTimer = startTimer;
      } else {
        const {
          segments,
          buffer,
          rowSpacing,
          panelTilt,
          azimuthRestriction,
          package: { panel },
        } = this.state;
        const fireSetbacks = segments.map((seg) => seg.setbacks);
        const { panelPlacementAPI, uid } = this.context;
        const panels = await panelPlacementAPI.create({
          uid,
          design_id: this.getActiveDesignId(),
          panel,
          fireSetbacks,
          buffer,
          rowSpacing,
          panelTilt,
          azimuthRestriction,
          fillMode,
        });
        if (!isCurrentRequest()) return;

        this.panelPlacementCallbackArmed = true;
        this.panelPlacementCallbackRequestId = requestId;
        this.setPanelPlacement(panels);
        if (
          this.panelPlacementCallbackArmed &&
          !this.panelPlacementFinalizeTimer
        ) {
          throw new Error('Panel placement did not complete');
        }
        if (!isCurrentRequest()) return;
        this.resetLegacyFlagsAfterPlacement();
        try {
          const { CanvasAPI } = this.context;
          const {
            buffer: buf,
            rowSpacing: rs,
            panelTilt: pt,
            azimuthRestriction: ar,
            panelPlacementFillMode: fillModeVal,
            panelPlacementLayoutMode: layoutModeVal,
            panelPlacementOnlySelectedRoof: onlySelectedRoofVal,
          } = this.state;
          if (CanvasAPI?.saveCanvas) {
            this.queuePanelPlacementPersistence(() =>
              CanvasAPI.saveCanvas({
                panels,
                buffer: buf,
                rowSpacing: rs,
                panelTilt: pt,
                azimuthRestriction: ar,
                panelPlacementFillMode: fillModeVal,
                panelPlacementLayoutMode: layoutModeVal,
                panelPlacementOnlySelectedRoof: onlySelectedRoofVal,
              })
            ).catch(() => {});
          }
        } catch (e) {}
      }
    };
    runPlacement().catch(failPlacement);
    return placementCompletion;
  };

  resetLegacyFlagsAfterPlacement = (targetIndices = null) => {
    try {
      const { CanvasAPI } = this.context;
      const next = resetLegacyPlacementFlags(this.state, targetIndices);
      if (next === this.state) return;
      this.setState3x({ segments: next.segments });
      try {
        if (CanvasAPI?.saveCanvas) {
          this.queuePanelPlacementPersistence(() =>
            CanvasAPI.saveCanvas({ segments: next.segments })
          ).catch(() => {});
        }
      } catch (e) {}
    } catch (e) {}
  };

  // TODO: do we need to enforce that request ids match segment ids?
  // this point would be generally applicable to other methods/functions
  handleMeasure = (serverSide = false) => {
    const { mode } = this.state;
    if (mode !== 'select') {
      this.handleMode('select');
      setTimeout(() => {
        this.handleMeasure(serverSide);
      }, 200);
      return;
    }

    this.setState3x({ measureIsRunning: true });
    if (!serverSide) {
      setTimeout(this.canvas3DElement.measure, 0);
    } else {
      const { measureAPI, uid } = this.context;
      // const { segments } = this.state;
      measureAPI
        .create({ uid, design_id: this.getActiveDesignId() })
        .then((data) => {
          const [newSegments, offset] = data;
          this.setSegmentParameters(newSegments);
          // const copySegments = [...segments];
          // newSegments.forEach((seg, i) => {
          //   copySegments[i].pitch = seg.pitch.toFixed(2);
          //   copySegments[i].azimuth = seg.azimuth.toFixed(2);
          //   copySegments[i].height = seg.height.toFixed(2);
          // });
          // this.setStatex({ segments: copySegments });
          this.canvas3DElement.changeOffset(offset);
        })
        .finally(() => this.setState3x({ measureIsRunning: false }));
    }
  };

  handleDownload3DJSON = () => {
    try {
      this.canvas3DElement?.downloadJSON?.();
    } catch (e) {}
  };

  handleDownloadDXF = () => {
    const { displaySnack } = this.context;
    const canvas3D = this.canvas3DElement;
    if (typeof canvas3D?.downloadDXF !== 'function') {
      try {
        displaySnack({
          variant: 'warning',
          message: 'Canvas is still loading. Try again in a moment.',
        });
      } catch (e) {}
      return;
    }

    try {
      canvas3D.downloadDXF();
    } catch (e) {
      try {
        displaySnack({
          variant: 'danger',
          message: 'Unable to export DXF.',
        });
      } catch (err) {}
    }
  };

  setPVwattsLosses = (losses) => {
    this.setState2x({ losses });
    try {
      this.context.CanvasAPI.saveCanvas({ losses });
    } catch (e) { }
  };

  maybeApplyPendingPanelForFirstPlacement = (prevPanels, nextPanels) => {
    const transition = resolvePendingPanelForFirstPlacement({
      previousPanels: prevPanels,
      nextPanels,
      lastRenderedPlacedPanelCount: this.lastRenderedPlacedPanelCount,
      manualPanel: this.firstManualInsertPanel,
      pendingPanel: this.state.package?.pendingPanel,
    });
    if (transition.consumeManualPanel) {
      this.firstManualInsertPanel = null;
    }
    return transition.panel;
  };

  handlePVWatts = async () => {
    const { newEndpoint, company: id } = this.context;
    const {
      iframe,
      context: iframeContext,
      callback: iframeCallback,
    } = this.props;
    const {
      PVWattsAPI,
      displaySnack,
      updateLead,
      lead: { property },
    } = this.context;
    const {
      package: { inverter, inverterQuantity = 1, additional_inverters = [] },
      losses,
    } = this.state;

    // Ensure we have required inverter data before proceeding
    if (!inverter) {
      console.warn('handlePVWatts: No inverter selected');
      if (iframe && iframeCallback) {
        iframeCallback('Error', {
          code: '50',
          message: 'No inverter selected for PVWatts calculation',
        });
      }
      return;
    }

    let tryCount = 3;
    let [optPitch, optAzimuth] = [24.0, 184.0];
    try {
      // calculate optimal pitch and azimuth for poa request
      [optPitch, optAzimuth] = this.canvas3DElement.getOptPitchAndAzimuth();
      await new Promise((r) => setTimeout(r, 4000));
      if (
        tryCount > 0 &&
        (optPitch === undefined || optAzimuth === undefined)
      ) {
        [optPitch, optAzimuth] = this.canvas3DElement.getOptPitchAndAzimuth();
        await new Promise((r) => setTimeout(r, 2000));
        tryCount -= 1;
      }
    } catch (err) {
      if (iframe && tryCount === 0 /*&& err.response.data.code*/) {
        // console.log(err);
        iframeCallback('Error', {
          code: '22',
          message: 'Error in calculating optimal pitch and azimuth',
        });
      }
    }

    // alert(`${property.optimal_roof.pitch.toFixed(1)}, ${property.optimal_roof.azimuth.toFixed(1)}`);

    const request = this.exportCanvas(true);
    if (property.optimal_poa.reduce((a, b) => a + b, 0) === 0) {
      request.optPitchAndAzimuth = [
        property?.optimal_roof?.pitch
          ? property?.optimal_roof?.pitch.toFixed(1)
          : optPitch.toFixed(1),
        property?.optimal_roof?.azimuth
          ? property?.optimal_roof?.azimuth.toFixed(1)
          : optAzimuth.toFixed(1),
      ];
    }
    request.inverter_efficiency = inverter?.efficiency;
    if (iframe) {
      const filteredIframeContext = filterDictByKeys(iframeContext, [
        'panelType',
        'inverter',
        'monitoring',
        'mounting',
      ]);
      if (iframeContext?.companyInverterID) {
        request.inverter_efficiency = inverter?.efficiency;
      } else if (filteredIframeContext?.inverter?.efficiency) {
        request.inverter_efficiency =
          filteredIframeContext?.inverter.efficiency;
      } else {
        console.log('default inverter efficiency');
        request.inverter_efficiency = 97.0;
      }
    }

    request.inverter = inverter;
    if (inverter?.type !== 'M' && inverter?.type !== 'Micro') {
      // Transform additional inverters to the format expected by PVWatts API
      request.additional_inverters = additional_inverters
        .filter((inv) => inv?.id) // Only include entries with valid IDs
        .map((inv) => {
          // Look up the full hardware details to get actual capacity
          const { hardware } = this.context;
          const inverterHardware = hardware.inverters.find(
            (h) => h.id === inv.id
          );
          return {
            inverter_id: inv.id,
            capacity: inverterHardware?.capacity || inv?.capacity || 0,
            quantity: inv?.quantity || 1,
          };
        });
    }

    request.losses = losses;

    PVWattsAPI.create(request)
      .then((data) => {
        const result = JSON.parse(data);
        const { segments } = this.state;
        const updatedSegments = [...segments];
        updatedSegments.forEach((seg, i) => {
          const ac = result['ac'][i]?.split(',').map(parseFloat) ?? 0;
          const poa = result['poa'][i]?.split(',').map(parseFloat) ?? 0;
          updatedSegments[i].acMonthly = ac;
          updatedSegments[i].poaMonthly = poa;
          updatedSegments[i].acAnnual = ac.reduce((a, b) => a + b, 0);
          updatedSegments[i].pvwatts_update = false;
        });
        if (property.optimal_poa.reduce((a, b) => a + b, 0) === 0) {
          const optPOA = result['poa']['opt']?.split(',').map(parseFloat) ?? 0;
          updateLead({ property: { optimal_poa: optPOA } }, true);
        }
        this.setState2x({ segments: updatedSegments, pvwattsHandled: true });
        if (iframe) {
          this.setState({
            pvwattsHandled: true,
          });
          console.log('Data updated from PVWatts');
        } else {
          displaySnack({
            variant: 'success',
            message: 'Data updated from PVWatts',
          });
        }
      })
      .catch((err) => {
        if (iframe && err?.response?.data?.code) {
          iframeCallback('Error', {
            code: err.response.data.code,
            message: err.response.data.msg,
          });
        }
        if (iframe) {
          console.log(`Failed to update data from PVWatts: {err}`);
        } else {
          displaySnack({
            variant: 'danger',
            message: 'Failed to update data from PVWatts',
          });
        }
      });
  };

  // handleSaveShadings = (gradients) => {
  //   const { uid, user, saveShadingsAPI } = this.context;
  //   const request = {
  //     uid,
  //     company: user.company.id,
  //     gradients,
  //   };
  //   saveShadingsAPI.create(request).then((data) => {
  //     const result = JSON.parse(data);
  //     console.log(result.url);
  //   });
  // }

  download_production_json = async () => {
    const { newEndpoint, lead, displaySnack } = this.context;
    const { segments, package: packageData, coordinates } = this.state;

    try {
      if (!segments || segments.length === 0) {
        displaySnack({
          variant: 'warning',
          message: 'No segments found. Please design segments first.',
        });
        return;
      }

      if (!packageData || !packageData.panel) {
        displaySnack({
          variant: 'warning',
          message:
            'No panel hardware selected. Please select panel hardware first.',
        });
        return;
      }

      const [lat, lon] = coordinates || lead?.property?.coordinates || [];
      if (!lat || !lon) {
        displaySnack({
          variant: 'warning',
          message: 'Coordinates not found. Please set location first.',
        });
        return;
      }

      // Prepare pitches and azimuths from segments
      // const pitches = segments.map(seg => seg.pitch || 0);
      // const azimuths = segments.map(seg => seg.azimuth || 0);

      // // Call the production JSON endpoint
      // const productionJsonAPI = newEndpoint('designer/production/json/');
      // const response = await productionJsonAPI.create({
      //   lat,
      //   lon,
      //   pitches,
      //   azimuths
      // });

      const onlySelectedPanels = this.state.onlySelectedPanels;
      const includeHourlyProduction = this.state.includeHourlyProduction;

      let panelShadingData = [];
      if (this.canvas3DElement?.getAnualPanelsShadings) {
        try {
          panelShadingData = await this.canvas3DElement.getAnualPanelsShadings();
        } catch (error) { }
      }

      const selectedByVertex = onlySelectedPanels
        ? (this.canvas3DElement?.getSelectedPanelsByVertex
            ? this.canvas3DElement.getSelectedPanelsByVertex()
            : this.state?.selectedObjects?.panels) ||
          {}
        : {};

      const { productionJson: productionData } = buildProductionJson({
        lat,
        lon,
        segments,
        panelDataByIndex: this.canvas3DElement?.panelData || [],
        packageData,
        allInverters: this.state.inverters || [],
        invertersUsed: this.state.invertersUsed,
        losses: this.state.losses,
        wiringConfig: this.state.wiring,
        wiringConfigured: this.state.wiringConfigured,
        powerOptimizer: this.state.powerOptimizer,
        panelShadingData,
        onlySelectedPanels,
        includeHourlyProduction,
        selectedByVertex,
      });

      const dataStr = JSON.stringify(productionData, null, 2);
      const dataUri =
        'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);

      const exportFileDefaultName = `production_${lead?.uid || 'data'}_${new Date().toISOString().split('T')[0]
        }.json`;

      const linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.click();

      displaySnack({
        variant: 'success',
        message: 'Production JSON exported successfully!',
      });
    } catch (error) {
      console.error('Error exporting production JSON:', error);
      displaySnack({
        variant: 'danger',
        message: 'Failed to export production JSON. Please try again.',
      });
    }
  };

  applyProductionSettings = async (settings = {}) => {
    if (!settings || typeof settings !== 'object') {
      return;
    }

    const updates = {};
    const canvasUpdates = {};
    const packageUpdates = {};
    const currentPackage = this.state.package || {};
    const allInverters = this.state.inverters || [];
    const allPanels = this.state.solarPanels || [];
    const { iframe } = this.props;
    const { newEndpoint } = this.context;

    const normalizedLosses = normalizeProductionLosses(settings.losses);
    if (normalizedLosses) {
      updates.losses = { ...(this.state.losses || {}), ...normalizedLosses };
      canvasUpdates.losses = updates.losses;
    }

    const requestedPowerOptimizer = await resolveRequestedPowerOptimizer(
      settings,
      iframe && typeof newEndpoint === 'function'
        ? (id) => newEndpoint('power_optimizers/company/').retrieve(id)
        : null
    );
    if (requestedPowerOptimizer !== undefined) {
      updates.powerOptimizer = requestedPowerOptimizer;
    }

    const rawPanelId =
      settings.companyPanelID ??
      settings.companyPanelId ??
      settings.panelID ??
      settings.panelId;
    const directPanel =
      settings.panelType && typeof settings.panelType === 'object'
        ? settings.panelType
        : settings.panel && typeof settings.panel === 'object'
        ? settings.panel
        : null;
    let resolvedPanel = null;
    let panelFromCompanyId = false;
    if (rawPanelId !== undefined && rawPanelId !== null) {
      resolvedPanel = allPanels.find(
        (panel) => String(panel.id) === String(rawPanelId)
      );
      if (resolvedPanel) panelFromCompanyId = true;
      if (!resolvedPanel && iframe && newEndpoint) {
        const companyPanelsAPI = newEndpoint('panels/company/');
        const resolution = await retrieveCompanyHardwareWithFallback({
          retrieve: (id) => companyPanelsAPI.retrieve(id),
          id: rawPanelId,
          currentHardware: currentPackage.panel,
          inlineHardware: directPanel,
          kind: 'panel',
        });
        resolvedPanel = resolution.hardware;
        panelFromCompanyId = resolution.source === 'registered';
      }
    }
    const panelFromSpec = Boolean(directPanel) && !panelFromCompanyId;
    if (panelFromSpec) {
      resolvedPanel = buildEffectiveInlineHardwareSpec(
        currentPackage.panel,
        directPanel
      );
    }
    if (resolvedPanel) {
      packageUpdates.panel = resolvedPanel;
      if (panelFromSpec) {
        packageUpdates.selectedPanelSpec = resolvedPanel;
        canvasUpdates.selected_panel_spec = resolvedPanel;
        canvasUpdates.selected_panel_id = null;
      } else {
        packageUpdates.selectedPanelSpec = null;
        canvasUpdates.selected_panel_id = resolvedPanel?.id || null;
        canvasUpdates.selected_panel_spec = null;
      }
    }

    const rawInverterId =
      settings.companyInverterID ??
      settings.companyInverterId ??
      settings.primaryInverterID ??
      settings.primaryInverterId ??
      settings.inverterID ??
      settings.inverterId;
    const directInverter =
      settings.inverter && typeof settings.inverter === 'object'
        ? settings.inverter
        : null;
    let nextInverter = currentPackage.inverter || null;
    let inverterFromCompanyId = false;
    if (rawInverterId !== undefined && rawInverterId !== null) {
      const match = allInverters.find(
        (inv) => String(inv.id) === String(rawInverterId)
      );
      if (match) {
        nextInverter = match;
        packageUpdates.inverter = match;
        packageUpdates.selectedInverterSpec = null;
        canvasUpdates.selected_inverter_id = match.id;
        canvasUpdates.selected_inverter_spec = null;
        inverterFromCompanyId = true;
      } else if (iframe && newEndpoint) {
        const companyInvertersAPI = newEndpoint('inverters/company/');
        const resolution = await retrieveCompanyHardwareWithFallback({
          retrieve: (id) => companyInvertersAPI.retrieve(id),
          id: rawInverterId,
          currentHardware: currentPackage.inverter,
          inlineHardware: directInverter,
          kind: 'inverter',
        });
        const fetched = resolution.hardware;
        if (fetched) {
          nextInverter = fetched;
          packageUpdates.inverter = fetched;
          packageUpdates.selectedInverterSpec = null;
          canvasUpdates.selected_inverter_id = fetched?.id || null;
          canvasUpdates.selected_inverter_spec = null;
          inverterFromCompanyId = resolution.source === 'registered';
        }
      }
    }
    if (directInverter && !inverterFromCompanyId) {
      nextInverter = buildEffectiveInlineHardwareSpec(
        currentPackage.inverter,
        directInverter
      );
      packageUpdates.inverter = nextInverter;
      packageUpdates.selectedInverterSpec = nextInverter;
      canvasUpdates.selected_inverter_spec = nextInverter;
      canvasUpdates.selected_inverter_id = null;
    }

    const previousInverterId = currentPackage?.inverter?.id ?? null;
    const nextInverterId = nextInverter?.id ?? previousInverterId;
    const inverterChanged =
      previousInverterId &&
      nextInverterId &&
      String(previousInverterId) !== String(nextInverterId);

    const hasAutoFlag = typeof settings.primaryInverterAutoQuantity === 'boolean';
    const quantityValue = Number(settings.inverterQuantity);
    const hasQuantity = Number.isFinite(quantityValue);
    let primaryAuto = hasAutoFlag
      ? settings.primaryInverterAutoQuantity
      : this.state.primaryInverterAutoQuantity;

    if (!hasAutoFlag && hasQuantity) {
      primaryAuto = false;
    }

    if (hasAutoFlag || hasQuantity) {
      updates.primaryInverterAutoQuantity = primaryAuto;
      updates.hasAutoCalculatedInverterQuantity = !primaryAuto;
      canvasUpdates.primary_inverter_auto_quantity = primaryAuto;
    }

    if (!primaryAuto && hasQuantity) {
      const nextQty = Math.max(1, quantityValue);
      packageUpdates.inverterQuantity = nextQty;
      canvasUpdates.inverter_quantity = nextQty;
    } else if (!primaryAuto && inverterChanged && !hasQuantity) {
      packageUpdates.inverterQuantity = 1;
      canvasUpdates.inverter_quantity = 1;
    }

    const additionalInput = Array.isArray(settings.additionalInverters)
      ? settings.additionalInverters
      : Array.isArray(settings.companyAdditionalInverterIDs)
        ? settings.companyAdditionalInverterIDs.map((id) => ({ id }))
        : null;

    if (additionalInput) {
      const normalizedAdditional = additionalInput
        .map((entry) => {
          if (!entry || typeof entry !== 'object') {
            return null;
          }
          const id =
            entry.companyInverterID ??
            entry.companyInverterId ??
            entry.id;
          if (!id) {
            return null;
          }
          const idValue = Number(id);
          const normalizedId = Number.isFinite(idValue) ? idValue : id;
          const payload = { id: normalizedId };
          if (typeof entry.autoQuantity === 'boolean') {
            payload.autoQuantity = entry.autoQuantity;
          }
          const quantityNum = Number(entry.quantity);
          if (Number.isFinite(quantityNum)) {
            payload.quantity = quantityNum;
          }
          return payload;
        })
        .filter(Boolean);

      const primaryIsMicro =
        nextInverter?.type === 'M' || nextInverter?.type === 'Micro';
      const filteredAdditional = primaryIsMicro
        ? []
        : normalizedAdditional.filter((entry) => {
          if (nextInverterId && String(entry.id) === String(nextInverterId)) {
            return false;
          }
          const invObj = allInverters.find(
            (inv) => String(inv.id) === String(entry.id)
          );
          if (!invObj) {
            throw new Error(`Inverter with id ${entry.id} not found`);
          }
          return !nextInverter || matchesPrimaryInverterType(nextInverter, invObj);
        });

      packageUpdates.additional_inverters = filteredAdditional;
      canvasUpdates.additional_inverters = filteredAdditional;
    } else if (inverterChanged) {
      const primaryIsMicro =
        nextInverter?.type === 'M' || nextInverter?.type === 'Micro';
      const existingAdditional = currentPackage.additional_inverters || [];
      const filteredAdditional = primaryIsMicro
        ? []
        : existingAdditional.filter((entry) => {
          if (!entry?.id) {
            return false;
          }
          const invObj = allInverters.find(
            (inv) => String(inv.id) === String(entry.id)
          );
          if (!invObj) {
            return false;
          }
          return !nextInverter || matchesPrimaryInverterType(nextInverter, invObj);
        });
      if (primaryIsMicro || filteredAdditional.length !== existingAdditional.length) {
        packageUpdates.additional_inverters = filteredAdditional;
        canvasUpdates.additional_inverters = filteredAdditional;
      }
    }

    const rawTarget =
      settings.targetProduction ?? settings.targetProductionKwh;
    const targetValue = Number(rawTarget);
    const hasTarget = Number.isFinite(targetValue);
    const hasUseTargetFlag = typeof settings.useTargetProduction === 'boolean';

    if (hasTarget || hasUseTargetFlag) {
      const useTarget = hasUseTargetFlag
        ? settings.useTargetProduction
        : targetValue > 0;
      const nextTarget = useTarget
        ? hasTarget
          ? targetValue
          : this.state.targetProductionKwh
        : 0;
      updates.useTargetProduction = useTarget;
      updates.targetProductionKwh = nextTarget;
      canvasUpdates.use_target_production = useTarget;
      canvasUpdates.target_production_kwh =
        useTarget && nextTarget > 0 ? nextTarget : null;
    }

    const maxRatioValue = Number(settings.maxDcAcRatio);
    if (Number.isFinite(maxRatioValue)) {
      updates.maxDcAcRatio = maxRatioValue;
      canvasUpdates.max_dc_ac_ratio = maxRatioValue;
    }

    if (typeof settings.includeHourlyProduction === 'boolean') {
      updates.includeHourlyProduction = settings.includeHourlyProduction;
    }

    if (typeof settings.onlySelectedPanels === 'boolean') {
      updates.onlySelectedPanels = settings.onlySelectedPanels;
      canvasUpdates.only_selected_panels = settings.onlySelectedPanels;
    }

    if (Object.keys(packageUpdates).length) {
      updates.package = { ...currentPackage, ...packageUpdates };
    }

    if (!Object.keys(updates).length && !Object.keys(canvasUpdates).length) {
      return;
    }

    await new Promise((resolve) => {
      if (Object.keys(updates).length) {
        this.setStatex(updates, resolve);
      } else {
        resolve();
      }
    });

    if (Object.keys(canvasUpdates).length && this.context?.CanvasAPI?.saveCanvas) {
      await this.context.CanvasAPI.saveCanvas(canvasUpdates, { strict: true });
    }
  };

  /**
   * Handle solar production calculation using the solar-production service.
   * If useTargetProduction is true and targetProductionKwh > 0, performs optimal panel selection.
   * Otherwise, calculates production for ALL panels (no optimization).
   */
  handleSolarProduction = (options = {}) =>
    this.productionRunQueue.run(() => this.runSolarProduction(options));

  handleIframeSolarProduction = (settings = {}, options = {}) =>
    runIframeProductionCommand({
      queue: this.productionRunQueue,
      settings,
      options,
      applySettings: this.applyProductionSettings,
      runProduction: this.runSolarProduction,
    });

  runSolarProduction = async (options = {}) => {
    const { lead, displaySnack, CanvasAPI, solarProductionDesignAPI } =
      this.context;
    const { iframe, callback: iframeCallback } = this.props;
    const { useTargetProduction, targetProductionKwh, maxDcAcRatio } =
      this.state;
    const primaryAutoForPayload =
      typeof this.state.primaryInverterAutoQuantity === 'boolean'
        ? this.state.primaryInverterAutoQuantity
        : !this.state.hasAutoCalculatedInverterQuantity;
    let onlySelectedPanels =
      typeof options.onlySelectedPanels === 'boolean'
        ? options.onlySelectedPanels
        : this.state.onlySelectedPanels;
    const includeHourlyProduction =
      typeof options.includeHourlyProduction === 'boolean'
        ? options.includeHourlyProduction
        : this.state.includeHourlyProduction;
    const persistSelectionState =
      options.persistSelectionState !== undefined
        ? options.persistSelectionState
        : true;
    const throwOnError = Boolean(options.throwOnError);
    const emitProductionCallback = options.emitCallback !== false;

    this.setState({ productionIsRunning: true });

    try {
      let selectedByVertex = onlySelectedPanels
        ? (this.canvas3DElement?.getSelectedPanelsByVertex
            ? this.canvas3DElement.getSelectedPanelsByVertex()
            : this.state?.selectedObjects?.panels) ||
          {}
        : {};
      const selection = resolveProductionPanelSelection({
        onlySelectedPanels,
        selectedByVertex,
        fallbackToAllPanelsWhenEmpty:
          options.fallbackToAllPanelsWhenSelectionEmpty === true,
      });
      onlySelectedPanels = selection.onlySelectedPanels;
      selectedByVertex = selection.selectedByVertex;
      if (
        onlySelectedPanels &&
        selection.selectedCount <= 0 &&
        this.canvas3DElement?.getSelectedPanelsByVertex
      ) {
        const message =
          'No panels selected. Select panels or disable "Only Selected Panels".';
        if (iframe && iframeCallback && emitProductionCallback) {
          iframeCallback('Error', {
            code: '60',
            message,
          });
        }
        if (!options.throwOnError) {
          this.setState({ productionIsRunning: false });
          displaySnack({
            variant: 'warning',
            message,
          });
          return;
        }
        throw new Error(message);
      }

      const lat = lead.property?.coordinates?.[0];
      const lon = lead.property?.coordinates?.[1];
      const nextMode = onlySelectedPanels ? 'selected' : 'all';
      this.setState({ stringingPanelIndexMode: 'all' });
      const panelShadingOptions =
        options.waitForPanelShadingTextures === false
          ? { waitForTextures: false, maxTextureWaits: 0 }
          : {};
      let panelShadingData = [];
      if (this.canvas3DElement?.getAnualPanelsShadings) {
        try {
          panelShadingData =
            await this.canvas3DElement.getAnualPanelsShadings(
              panelShadingOptions
            );
        } catch (error) { }
      }

      const { productionJson, selectedPanelIndexMap, roofIndexMap } =
        buildProductionJson({
          lat,
          lon,
          segments: this.state.segments,
          panelDataByIndex: this.canvas3DElement?.panelData || [],
          packageData: this.state.package,
          allInverters: this.state.inverters || [],
          invertersUsed: this.state.invertersUsed,
          losses: this.state.losses,
          wiringConfig: this.state.wiring,
          wiringConfigured: this.state.wiringConfigured,
          powerOptimizer: this.state.powerOptimizer,
          panelShadingData,
          primaryInverterAutoQuantity: primaryAutoForPayload,
          onlySelectedPanels,
          includeHourlyProduction,
          selectedByVertex,
        });

      if (persistSelectionState) {
        this.setState({
          stringingSelectedPanelIndexMap: onlySelectedPanels
            ? selectedPanelIndexMap
            : null,
          stringingRoofIndexMap: roofIndexMap,
        });
      }
      this.lastSelectedPanelIndexMapForPayload = onlySelectedPanels
        ? selectedPanelIndexMap
        : null;
      this.lastRoofIndexMapForPayload = roofIndexMap;

      const payload = productionJson;
      payload.lead_uid = lead.uid;
      payload.design_id = this.getActiveDesignId();

      // Set target_production based on checkbox state
      // If checkbox is checked and target > 0, use target for optimal panel selection
      // Otherwise, set to null to use all panels
      payload.target_production =
        useTargetProduction && targetProductionKwh > 0
          ? targetProductionKwh
          : null;

      // Optional constraint: maximum DC/AC ratio (1-2). Pass through to solar-production.
      const maxRatioNum = Number(maxDcAcRatio);
      payload.dcac_target =
        Number.isFinite(maxRatioNum) && maxRatioNum >= 0.5 && maxRatioNum <= 2
          ? maxRatioNum
          : 1.5;
      const requestedPanelCount = countProductionPayloadPanels(payload);

      const result = await solarProductionDesignAPI.create(payload);

      if (!result.success) {
        throw new Error(
          result.message || 'Solar production calculation failed'
        );
      }

      // Update segments with per-roof data
      const { segments } = this.state;
      const roofIndexMapToUse = Array.isArray(this.lastRoofIndexMapForPayload)
        ? this.lastRoofIndexMapForPayload
        : Array.isArray(this.state.stringingRoofIndexMap)
          ? this.state.stringingRoofIndexMap
          : [];
      const segIdxToRoofIdx = new Map();
      roofIndexMapToUse.forEach((segIdx, roofIdx) => {
        const s = Number(segIdx);
        if (Number.isFinite(s)) segIdxToRoofIdx.set(s, roofIdx);
      });
      const mapPayloadRoofToSegment = (roofIdxRaw) => {
        const roofIdx = Number(roofIdxRaw);
        if (!Number.isFinite(roofIdx)) return null;
        const segIdx = roofIndexMapToUse?.[roofIdx];
        const s = Number(segIdx);
        return Number.isFinite(s) ? s : roofIdx;
      };
      const getByRoof = (obj, roofIdx, fallbackVal) =>
        obj?.[roofIdx] ?? obj?.[String(roofIdx)] ?? fallbackVal;

      const updatedSegments = segments.map((seg, idx) => {
        const roofIdx = segIdxToRoofIdx.get(idx);
        if (roofIdx === undefined || roofIdx === null) return seg;

        const roofAnnualKwh = getByRoof(result.per_roof_annual_kwh, roofIdx, 0);
        const roofMonthlyAc = getByRoof(result.per_roof_monthly_ac, roofIdx, seg.acMonthly);
        const roofMonthlyPoa = getByRoof(result.per_roof_monthly_poa, roofIdx, seg.poaMonthly);
        const roofClippingKwh = getByRoof(result.per_roof_clipping_kwh, roofIdx, 0);
        // Get selected panels array for this roof (can be empty array if no panels selected)
        const selectedPanels = getByRoof(result.selected_panels_per_roof, roofIdx, null);
        const selectedPanelCountForRoof = selectedPanels?.length ?? null;

        return {
          ...seg,
          acMonthly: roofMonthlyAc,
          poaMonthly: roofMonthlyPoa,
          acAnnual: roofAnnualKwh,
          annual_kwh: roofAnnualKwh,
          clipping_kwh: roofClippingKwh,
          selected_panel_count: selectedPanelCountForRoof,
        };
      });

      // Get inverter count from API result if auto mode is enabled
      const {
        package: installationPackage,
      } = this.state;
      const selectedProductionPanel = installationPackage?.panel || null;
      const invertersUsed = result.solar_design?.[0]?.inverters_used || null;
      const hourlyProduction = (() => {
        const raw = result.production_results;
        if (!raw || typeof raw !== 'object') return null;
        const payload = {};
        const keys = [
          'times',
          'pac_total_W',
          'pac_inverters_W',
          'pdc_inverters_W',
          'pdc_mppt_W',
          'clipping_W',
          'true_clip_W',
        ];
        keys.forEach((key) => {
          if (raw[key] !== undefined) {
            payload[key] = raw[key];
          }
        });
        return Object.keys(payload).length ? payload : null;
      })();
      const { totalCount: numTotalPanels, perRoofCounts } = getPanelCounts({
        panelData: this.canvas3DElement?.panelData,
        panels: this.state.panels,
      });
      let currentInverterQuantity = installationPackage.inverterQuantity;
      if (primaryAutoForPayload && Array.isArray(invertersUsed)) {
        const primaryInverterData = findPrimaryInverterUsage(
          invertersUsed,
          installationPackage.inverter
        );
        if (primaryInverterData) {
          currentInverterQuantity = primaryInverterData.count || 1;
        }
      }

      // Select panels used in stringing so they appear "selected" on the canvas.
      const roofIndexMapForPayload = Array.isArray(this.lastRoofIndexMapForPayload)
        ? this.lastRoofIndexMapForPayload
        : roofIndexMap;
      const panelIndexMapForPayload = Array.isArray(
        this.lastSelectedPanelIndexMapForPayload
      )
        ? this.lastSelectedPanelIndexMapForPayload
        : null;
      let strings = mapStringingDataToDesign(
        result.solar_design?.[0]?.strings || null,
        roofIndexMapForPayload,
        panelIndexMapForPayload
      );

      const selectedPanelsPerRoof = mapSelectedPanelsPerRoofToDesign(
        result.selected_panels_per_roof || {},
        roofIndexMapForPayload,
        panelIndexMapForPayload
      );
      const productionPanelSelection = buildProductionPanelSelection(
        this.state.panels,
        selectedPanelsPerRoof
      );
      const selectedPanelCount = resolveAppliedPanelCount({
        resultPanelCount: result.panel_count,
        selectedPanelsPerRoof,
        fallbackPanelCount: onlySelectedPanels ? requestedPanelCount : 0,
      });
      const productionPerPanel =
        selectedPanelCount > 0 ? result.annual_kwh / selectedPanelCount : 0;
      const systemSizeKw =
        result.system_size_kw !== undefined ? result.system_size_kw : null;
      const shouldWarnAboutFixedInverterCapacity =
        hasFixedInverterQuantity({
          primaryInverterAutoQuantity: primaryAutoForPayload,
          additionalInverters: installationPackage?.additional_inverters,
        }) && requestedPanelCount > selectedPanelCount;

      const perRoofAnnualKwh = mapRoofKeyedPayloadToDesign(
        result.per_roof_annual_kwh,
        roofIndexMapForPayload
      );
      const perRoofMonthlyAc = mapRoofKeyedPayloadToDesign(
        result.per_roof_monthly_ac,
        roofIndexMapForPayload
      );
      const perRoofMonthlyPoa = mapRoofKeyedPayloadToDesign(
        result.per_roof_monthly_poa,
        roofIndexMapForPayload
      );
      const perRoofClippingKwh = mapRoofKeyedPayloadToDesign(
        result.per_roof_clipping_kwh,
        roofIndexMapForPayload
      );

      if (strings && this.canvas3DElement?.selectPanelsFromStringing) {
        try {
          this.suppressSolarProductionFromSelection = true;
          this.canvas3DElement.selectPanelsFromStringing(strings, 'all');
        } catch (e) {
          // noop
        } finally {
          setTimeout(() => {
            this.suppressSolarProductionFromSelection = false;
          }, 400);
        }
      }

      if (
        (!Array.isArray(strings) || strings.length === 0) &&
        this.canvas3DElement?.selectPanelsFromStringing
      ) {
        if (selectedPanelsPerRoof && Object.keys(selectedPanelsPerRoof).length > 0) {
          const pairs = [];
          Object.keys(selectedPanelsPerRoof).forEach((roofKey) => {
            const segIdx = Number(roofKey);
            if (!Number.isFinite(segIdx)) return;
            const arr = Array.isArray(selectedPanelsPerRoof[roofKey])
              ? selectedPanelsPerRoof[roofKey]
              : [];
            arr.forEach((panelIdxRaw) => {
              const panelIdx = Number(panelIdxRaw);
              if (!Number.isFinite(panelIdx)) return;
              pairs.push([segIdx, panelIdx]);
            });
          });
          if (pairs.length > 0) {
            strings = [{ panels: pairs, draw: false }];
            try {
              this.suppressSolarProductionFromSelection = true;
              this.canvas3DElement.selectPanelsFromStringing(strings, 'all');
            } catch (e) { }
            setTimeout(() => {
              this.suppressSolarProductionFromSelection = false;
            }, 400);
          }
        }
      }

      const productionPerPanelRaw =
        result.production_per_panel ??
        result.productionPerPanel ??
        result.production_results?.production_per_panel ??
        [];
      const productionPerPanelData = normalizeProductionPerPanelData({
        raw: productionPerPanelRaw,
        perRoofCounts,
        roofIndexMap: this.lastRoofIndexMapForPayload,
        panelIndexMap: Array.isArray(this.lastSelectedPanelIndexMapForPayload)
          ? this.lastSelectedPanelIndexMapForPayload
          : null,
      });
      const productionPerStringRaw =
        result.production_per_string ??
        result.productionPerString ??
        result.production_results?.production_per_string ??
        [];
      const productionPerStringData = Array.isArray(productionPerStringRaw)
        ? productionPerStringRaw
        : [];
      const selectedPanelsPerRoofForSnapshot = selectedPanelsPerRoof;
      this.lastProductionSnapshot = {
        productionPerPanelData,
        productionPerStringData,
        hourlyProduction,
        stringingData: strings || null,
        invertersUsed: invertersUsed || null,
        annualProduction: result.annual_kwh || 0,
        monthlyProduction: result.monthly_kwh || Array(12).fill(0),
        annualClippingKwh: result.annual_clipping_kwh || 0,
        monthlyClippingKwh: result.monthly_clipping_kwh || Array(12).fill(0),
        dcAcRatio: result.dc_ac_ratio ?? null,
        systemSizeKw:
          result.system_size_kw !== undefined
            ? result.system_size_kw
            : systemSizeKw,
        mpptCountTotal:
          result.mppt_count_total !== undefined
            ? result.mppt_count_total
            : null,
        selectedPanelCount,
        selectedPanelsPerRoof: selectedPanelsPerRoofForSnapshot,
        perRoofAnnualKwh,
        perRoofMonthlyAc,
        perRoofMonthlyPoa,
        perRoofClippingKwh,
        limitReached: shouldWarnAboutFixedInverterCapacity,
      };

      await new Promise((resolve) => {
        const productionState = applySolarProductionResult(
          this.state,
          result,
          {
            installationPackage,
            selectedProductionPanel,
            currentInverterQuantity,
            strings,
            invertersUsed,
            hourlyProduction,
            selectedPanelCount,
            productionPerPanel,
            systemSizeKw,
            mpptCountTotal:
              result.mppt_count_total !== undefined
                ? result.mppt_count_total
                : null,
            productionPerPanelData,
            productionPerStringData,
            productionPanelSelection,
            updatedSegments,
          }
        );
        this.setState(
          {
            segments: productionState.segments,
            productionHandled: productionState.productionHandled,
            totalAnnualKwh: productionState.totalAnnualKwh,
            totalMonthlyKwh: productionState.totalMonthlyKwh,
            totalClippingKwh: productionState.totalClippingKwh,
            totalMonthlyClippingKwh: productionState.totalMonthlyClippingKwh,
            dcAcRatio: productionState.dcAcRatio,
            stringingData: productionState.stringingData,
            invertersUsed: productionState.invertersUsed,
            productionPerPanel: productionState.productionPerPanel,
            productionPerPanelData: productionState.productionPerPanelData,
            productionPerStringData: productionState.productionPerStringData,
            hourlyProduction: productionState.hourlyProduction,
            productionHardware: productionState.productionHardware,
            selectedPanelCount: productionState.selectedPanelCount,
            stringingPanelIndexMode: productionState.stringingPanelIndexMode,
            systemSizeKw: productionState.systemSizeKw,
            mpptCountTotal: productionState.mpptCountTotal,
            productionIsRunning: productionState.productionIsRunning,
            productionSaveError: productionState.productionSaveError,
            package: productionState.package,
            ...(productionPanelSelection.hasSelectedPanels
              ? {
                  panels: productionState.panels,
                  selectedPanels: productionState.selectedPanels,
                  selectedObjects: productionState.selectedObjects,
                }
              : {}),
          },
          () => {
            this.refreshDirtyState();
            resolve();
          }
        );
      });

      // Persist to canvas via API - pass the calculated values directly
      const inverterConfig = {
        inverterQuantity: currentInverterQuantity,
        primaryInverterAutoQuantity: primaryAutoForPayload,
        additionalInverters: installationPackage.additional_inverters || [],
        maxDcAcRatio,
        stringingDataOverride: strings || null,
      };

      if (persistSelectionState) {
        inverterConfig.onlySelectedPanels = onlySelectedPanels;
      }

      const persistProductionToCanvas = () =>
        this.saveProductionToCanvas(result, updatedSegments, inverterConfig, {
          productionPerPanel: productionPerPanelData,
          productionPerString: productionPerStringData,
          hourlyProduction,
          panels: productionPanelSelection.hasSelectedPanels
            ? productionPanelSelection.panels
            : this.state.panels,
        });

      if (iframe && iframeCallback) {
        const apiAnnualKwh = result.annual_kwh || 0;
        const apiMonthlyKwh = result.monthly_kwh || Array(12).fill(0);
        const productionPayload = buildProductionCallbackPayload({
          annualUsage: lead?.utility?.usage,
          annualKwh: apiAnnualKwh,
          monthlyKwh: apiMonthlyKwh,
          hourlyProduction,
          systemSizeKw:
            result.system_size_kw !== undefined &&
              result.system_size_kw !== null
              ? result.system_size_kw
              : systemSizeKw,
          numTotalPanels,
          selectedPanelCount: selectedPanelCount || 0,
          perRoofCounts,
          segments: updatedSegments,
          selectedPanelsPerRoof,
          productionPerPanel: productionPerPanelData,
          productionPerString: productionPerStringData,
          strings,
          invertersUsed,
          monthlyClippingKwh: result.monthly_clipping_kwh || Array(12).fill(0),
          clippingKwh: result.annual_clipping_kwh || 0,
          dcAcRatio: result.dc_ac_ratio,
          panelCount: selectedPanelCount || 0,
          mpptCountTotal:
            result.mppt_count_total !== undefined
              ? result.mppt_count_total
              : null,
          perRoofAnnualKwh,
          perRoofMonthlyAc,
          perRoofMonthlyPoa,
          perRoofClippingKwh,
          limitReached: shouldWarnAboutFixedInverterCapacity,
        });

        if (emitProductionCallback) {
          iframeCallback('Production', productionPayload);
        }

        // NOTE: SolarProduction callback is disabled for now. Keep for future reference.
        /*
        iframeCallback('SolarProduction', {
          success: true,
          annual_kwh: result.annual_kwh,
          monthly_kwh: result.monthly_kwh,
          clipping_kwh: result.annual_clipping_kwh,
          dc_ac_ratio: result.dc_ac_ratio,
          strings_count: result.solar_design?.[0]?.strings?.length || 0,
        });
        */
        if (emitProductionCallback && shouldWarnAboutFixedInverterCapacity) {
          iframeCallback(
            FIXED_INVERTER_PANEL_CAPACITY_CALLBACK,
            buildFixedInverterPanelCapacityNotification()
          );
        }
        const productionPersisted = await persistProductionToCanvas();
        if (!productionPersisted) {
          const message =
            'Production calculated, but saving it to the canvas failed. Recalculate before creating or sharing a proposal.';
          if (throwOnError) {
            throw new Error(message);
          }
          if (emitProductionCallback) {
            iframeCallback('Warning', {
              code: '62',
              message,
            });
          }
        }
      } else {
        const productionPersisted = await persistProductionToCanvas();

        if (!productionPersisted) {
          displaySnack({
            variant: 'warning',
            message:
              'Production calculated, but saving it to the canvas failed. Recalculate before creating or sharing a proposal.',
          });
        } else if (shouldWarnAboutFixedInverterCapacity) {
          displaySnack({
            variant: 'warning',
            message: `Production calculated: ${result.annual_kwh?.toFixed(
              0
            )} kWh/year\n${FIXED_INVERTER_PANEL_CAPACITY_MESSAGE}`,
          });
        } else {
          displaySnack({
            variant: 'success',
            message: `Production calculated: ${result.annual_kwh?.toFixed(
              0
            )} kWh/year`,
          });
        }
      }
    } catch (err) {
      this.setState({ productionIsRunning: false });

      if (options.throwOnError) {
        throw err;
      }

      if (iframe && iframeCallback) {
        iframeCallback('Error', {
          code: '60',
          message: `Solar production calculation failed: ${err.message}`,
        });
      } else {
        displaySnack({
          variant: 'danger',
          message: `Solar production calculation failed: ${err.message}`,
        });
      }
    }
  };

  setWeatherDatasetSelected = (value) => {
    this.setState({
      weatherDatasetSelected: value,
      weatherDatasetFetchedPath: null,
    });
  };

  handleWeatherDatasetFetched = (weatherDatasetPath) => {
    this.setState3x({ weatherDatasetFetchedPath: weatherDatasetPath });
  };

  /**
   * Save production data to canvas via API for persistence
   * @param {Object} result - API result from solar-production
   * @param {Array} updatedSegments - Updated segments with production data
   * @param {Object} inverterConfig - Inverter configuration to save
   */
  saveProductionToCanvas = async (
    result,
    updatedSegments,
    inverterConfig = {},
    productionData = {}
  ) => {
    const { CanvasAPI, uid } = this.context;

    try {
      const invertersUsed = result.solar_design?.[0]?.inverters_used || null;
      const hourlyProduction =
        productionData?.hourlyProduction ??
        (() => {
          const raw = result.production_results;
          if (!raw || typeof raw !== 'object') return null;
          const payload = {};
          const keys = [
            'times',
            'pac_total_W',
            'pac_inverters_W',
            'pdc_inverters_W',
            'pdc_mppt_W',
            'clipping_W',
            'true_clip_W',
          ];
          keys.forEach((key) => {
            if (raw[key] !== undefined) {
              payload[key] = raw[key];
            }
          });
          return Object.keys(payload).length ? payload : null;
        })();
      const productionPerPanel =
        productionData?.productionPerPanel ??
        result.production_per_panel ??
        result.productionPerPanel ??
        result.production_results?.production_per_panel ??
        null;
      const productionPerString =
        productionData?.productionPerString ??
        result.production_per_string ??
        result.productionPerString ??
        result.production_results?.production_per_string ??
        null;
      const panelsForSave = productionData?.panels ?? this.state.panels;

      // Prepare canvas-level production data
      const canvasData = {
        total_annual_kwh: result.annual_kwh || 0,
        total_monthly_kwh: (result.monthly_kwh || []).join(','),
        total_clipping_kwh: result.annual_clipping_kwh || 0,
        total_monthly_clipping_kwh: (result.monthly_clipping_kwh || []).join(
          ','
        ),
        dc_ac_ratio: result.dc_ac_ratio,
        system_size_kw:
          result.system_size_kw !== undefined ? result.system_size_kw : null,
        mppt_count_total:
          result.mppt_count_total !== undefined
            ? result.mppt_count_total
            : null,
        inverter_count_total: Array.isArray(invertersUsed)
          ? invertersUsed.reduce((sum, i) => sum + (i.count || 0), 0)
          : null,
        stringing_data:
          inverterConfig.stringingDataOverride !== undefined
            ? inverterConfig.stringingDataOverride
            : result.solar_design?.[0]?.strings || null,
        inverters_used: invertersUsed,
        production_per_panel: productionPerPanel,
        production_per_string: productionPerString,
        hourly_production: hourlyProduction,
        // Persist UI state for production controls
        max_dc_ac_ratio:
          inverterConfig.maxDcAcRatio !== undefined
            ? inverterConfig.maxDcAcRatio
            : this.state.maxDcAcRatio,
        only_selected_panels:
          inverterConfig.onlySelectedPanels !== undefined
            ? inverterConfig.onlySelectedPanels
            : this.state.onlySelectedPanels,
        inverter_quantity: inverterConfig.inverterQuantity,
        primary_inverter_auto_quantity:
          inverterConfig.primaryInverterAutoQuantity,
        additional_inverters: inverterConfig.additionalInverters || [],
      };
      const selectedPanelSpec = this.state.package?.selectedPanelSpec || null;
      if (selectedPanelSpec) {
        canvasData.selected_panel_spec = selectedPanelSpec;
        canvasData.selected_panel_id = null;
      } else {
        const selectedPanelId = this.state.package?.panel?.id;
        if (selectedPanelId !== undefined && selectedPanelId !== null) {
          canvasData.selected_panel_id = String(selectedPanelId);
        }
        canvasData.selected_panel_spec = null;
      }

      const selectedInverterSpec =
        this.state.package?.selectedInverterSpec || null;
      if (selectedInverterSpec) {
        canvasData.selected_inverter_spec = selectedInverterSpec;
        canvasData.selected_inverter_id = null;
      } else {
        const selectedInverterId = this.state.package?.inverter?.id;
        if (selectedInverterId !== undefined && selectedInverterId !== null) {
          canvasData.selected_inverter_id = String(selectedInverterId);
        }
        canvasData.selected_inverter_spec = null;
      }

      // CanvasAPI wrapper exposes saveCanvas/getCanvas (not update)
      // IMPORTANT: pass segments in DesignTool state shape (camelCase arrays),
      // because the CanvasAPI wrapper serializes them for the backend.
      await CanvasAPI.saveCanvas(
        {
          ...canvasData,
          segments: updatedSegments,
          panels: panelsForSave,
        },
        { strict: true }
      );
      this.setState({ productionSaveError: null });
      return true;
    } catch (err) {
      console.warn('[DesignTool.saveProductionToCanvas] failed', {
        leadId: uid,
        status: err?.response?.status,
        response: err?.response?.data ?? err?.message,
        canvasSave: err?.canvasSave,
      });
      this.setState({
        productionSaveError: err?.message || 'Production canvas save failed',
      });
      return false;
    }
  };

  runOptimizationHandler = (optimizePosition, serverSide = false) => {
    // const newSegments = clusterPoints([...this.state.segments]);
    const { mode } = this.state;
    if (mode !== 'select') {
      this.handleMode('select');
      setTimeout(() => {
        this.runOptimizationHandler(optimizePosition, serverSide);
      }, 200);
      return;
    }

    this.setState3x({
      optimizer1IsRunning: !optimizePosition,
      optimizer2IsRunning: optimizePosition,
    });
    if (!serverSide) {
      setTimeout(
        () =>
          this.canvas3DElement.runOptimizer(true, optimizePosition, serverSide),
        100
      );
    } else {
      const { optimizeAPI, uid } = this.context;
      optimizeAPI
        .create({ uid, design_id: this.getActiveDesignId() })
        .then((newSegments) => {
          this.setSegmentParameters(newSegments);
        })
        .finally(() =>
          this.setState3x({
            optimizer1IsRunning: false,
            optimizer2IsRunning: false,
          })
        );
    }
  };


  trackRectificationTask = (taskId) => {
    if (taskId === undefined) return;
    const { uid, displaySnack, getTaskStatus, CanvasAPI } = this.context;

    getTaskStatus(taskId).then(({ state }) => {
      if (state === 'PENDING' || state === 'STARTED') return;
      clearInterval(this.rectification_interval);
      this.setState3x({ rectificationIsRunning: false });
      if (state === 'SUCCESS') {
        displaySnack({ variant: 'info', message: 'Rectification complete.' });
        CanvasAPI.getCanvas(uid).then((canvasData) => {
          this.setState2x({ ...canvasData });
        });
      } else {
        displaySnack({ variant: 'danger', message: 'Rectification failed. Run AI first.' });
      }
    });
  };

  runRectificationHandler = () => {
    const { lead, rectificationAPI, displaySnack } = this.context;
    this.setState3x({ rectificationIsRunning: true });
    rectificationAPI
      .create({ uid: lead.uid, design_id: this.getActiveDesignId() })
      .then((data) => {
        if (data.task) {
          displaySnack({ variant: 'info', message: 'Rectification is processing.' });
          this.rectification_interval = setInterval(() => this.trackRectificationTask(data.task), 1500);
        } else {
          this.setState3x({ rectificationIsRunning: false });
        }
      })
      .catch(() => {
        this.setState3x({ rectificationIsRunning: false });
        displaySnack({ variant: 'danger', message: 'Rectification failed. Run AI first.' });
      });
  };


  runEdgeDetectionHandler = (depthForEdgeDetection, serverSide = false) => {
    this.setState3x({ edgeDetectionIsRunning: true });
    if (!serverSide) {
      setTimeout(
        () =>
          this.canvas3DElement.edgeDetection(depthForEdgeDetection, serverSide),
        0
      );
    } else {
      const { edgeDetectionAPI, uid } = this.context;
      edgeDetectionAPI
        .create({ uid, byDSM: true, design_id: this.getActiveDesignId() })
        .then((newSegments) => {
          this.changeEdgeTypes(newSegments);
        })
        .finally(() => this.setState3x({ edgeDetectionIsRunning: false }));
    }
  };

  trackTask = (taskId) => {
    if (taskId === undefined) return;
    const { displaySnack, getTaskStatus } = this.context;

    getTaskStatus(taskId)
      .then(async ({ state, result }) => {
        console.log(taskId, state);
        if (['PENDING', 'RECEIVED', 'STARTED', 'RETRY', 'PROGRESS'].includes(state)) return;
        clearInterval(this.ai_interval);
        this.clearStoredAITask();
        this.setState({ AIIsRunning: false, updateRGBTextureIsRunning: false });
        if (state === 'SUCCESS' && (!result?.status || result.status === 'completed')) {
          displaySnack({ variant: 'info', message: 'Your AI design is ready.' });
          await this.reloadCanvas();
          await this.loadDesigns();
          this.setState({ imageryCacheKey: Date.now() });
        } else {
          displaySnack({
            variant: 'danger',
            message:
              result?.status === 'invalid_result'
                ? 'AI design failed because roof segments could not be extracted.'
                : 'An error was encountered.',
          });
        }
      })
      .catch(() => {
        clearInterval(this.ai_interval);
        this.setState({ AIIsRunning: false, updateRGBTextureIsRunning: false });
      });
  };

  runAIHandler = (lead_image = null) => {
    const { lead, predictAPI, displaySnack } = this.context;
    const canvasId = this.getActiveCanvasId();
    const imagery = this.selectedCanvasImagery();
    if (!imagery.rgb && !lead_image) {
      displaySnack({
        variant: 'danger',
        message: 'The selected canvas does not have RGB imagery.',
      });
      return;
    }
    const hasCanvasDsm = Boolean(imagery.dsm);

    const request = {
      uid: lead.uid,
      design_type: 'A',
      no_refinement: 'F',
      lead_image,
      canvas_id: canvasId,
      run_obstacles: hasCanvasDsm,
      run_trees: hasCanvasDsm,
    };

    this.setState3x({ AIIsRunning: true, updateRGBTextureIsRunning: false });

    predictAPI
      .create(request)
      .then((data) => {
        console.log(data.task);
        if (data.task) {
          try {
            window.localStorage.setItem(
              this.getAITaskStorageKey(),
              JSON.stringify({
                taskId: data.task,
                leadId: lead.uid,
                canvasId,
              })
            );
          } catch (e) { }
          displaySnack({
            variant: 'info',
            message: 'Your AI Design is processing.',
          });
          clearInterval(this.ai_interval);
          this.ai_interval = setInterval(() => this.trackTask(data.task), 1500);
          this.trackTask(data.task);
        } else {
          this.setState({ AIIsRunning: false, updateRGBTextureIsRunning: false });
          displaySnack({
            variant: 'danger',
            message: 'AI prediction not started.',
          });
        }
      })
      .catch((error) => {
        this.setState3x({ AIIsRunning: false });
        this.setState({ updateRGBTextureIsRunning: false });
        displaySnack({
          variant: 'danger',
          message:
            error?.response?.data?.error || 'AI prediction not started.',
        });
      });
  };

  trackTreeTask = (taskId) => {
    if (taskId === undefined) return;
    const { uid, displaySnack, getTaskStatus, CanvasAPI } = this.context;

    getTaskStatus(taskId).then(({ state }) => {
      if (['PENDING', 'RECEIVED', 'STARTED', 'RETRY', 'PROGRESS'].includes(state)) return;
      clearInterval(this.tree_ai_interval);
      this.setState3x({ treeAIIsRunning: false });
      if (state === 'SUCCESS') {
        displaySnack({ variant: 'info', message: 'Tree detection is ready.' });
        CanvasAPI.getCanvas(uid).then((canvasData) => {
          this.setState2x({ ...canvasData });
        });
      } else {
        displaySnack({
          variant: 'danger',
          message: 'An error was encountered.',
        });
      }
    });
  };

  runTreeAIHandler = () => {
    const { lead, treePredictAPI, displaySnack } = this.context;
    const activeDesignId = this.getActiveCanvasId();
    const activeDesign = (this.state.designs || []).find(
      (d) => String(d?.id) === String(activeDesignId)
    );
    const canUseGoogleDSM =
      (this.state.designs || []).some((d) => d?.image_source === 'google') &&
      ['nearmap', 'nearmap_rgb_only'].includes(activeDesign?.image_source);

    const request = {
      uid: lead.uid,
      design_id: activeDesignId,
      use_google_dsm: canUseGoogleDSM && this.state.useGoogleDSMForTreeAI,
    };

    this.setState3x({ treeAIIsRunning: true });

    treePredictAPI
      .create(request)
      .then((data) => {
        if (data.task) {
          displaySnack({
            variant: 'info',
            message: 'Tree AI is processing.',
          });
          this.tree_ai_interval = setInterval(
            () => this.trackTreeTask(data.task),
            1500
          );
        }
      })
      .catch(() => {
        displaySnack({
          variant: 'danger',
          message: 'Tree AI prediction not started.',
        });
      });
  };

  // Dev-only obstacle-detection tuning tool. Synchronous endpoint: POST the
  // params, await the result, then reload the canvas (reuses the same canvas
  // reload as trackTreeTask). No polling/celery task — the endpoint persists
  // the obstacles server-side and returns the result directly.
  runObstacleTune = (params) => {
    const { lead, obstacleTunePredictAPI } = this.context;

    const request = {
      uid: lead.uid,
      ...params,
    };

    return obstacleTunePredictAPI.create(request);
  };

  // Dev-only tree-detection tuning tool. Synchronous endpoint: POST the
  // params, await the result, then reload the canvas (reuses
  // reloadCanvasObstacles, which reloads the whole canvas — trees included).
  // No polling/celery task — the endpoint persists the trees server-side and
  // returns the result directly.
  runTreeTune = (params) => {
    const { lead, treeTunePredictAPI } = this.context;

    const request = {
      uid: lead.uid,
      ...params,
    };

    return treeTunePredictAPI.create(request);
  };

  reloadCanvasObstacles = () => {
    const { uid, CanvasAPI } = this.context;
    return CanvasAPI.getCanvas(uid).then((canvasData) => {
      this.setState2x({ ...canvasData });
    });
  };

  handleShading = async (
    serverSide = false,
    serverSideInfo = false,
    datasetPath = null
  ) => {
    const resolvedDatasetPath =
      datasetPath ?? this.state.weatherDatasetFetchedPath;
    if (
      resolvedDatasetPath &&
      resolvedDatasetPath !== this.state.weatherDatasetFetchedPath
    ) {
      this.setState({ weatherDatasetFetchedPath: resolvedDatasetPath });
    }
    const {
      lead: { property, uid },
      CanvasAPI,
      displaySnack,
    } = this.context;
    const {
      iframe,
      designFrame,
      companyName,
      callback: iframeCallback,
    } = this.props;
    const saveCanvasBeforeShading =
      serverSide || Boolean(this.state.dirtyStatus?.isCanvasChanged);
    if (saveCanvasBeforeShading) {
      if (serverSide) this.designerCanvasCommands.setServerSideShadingIsRunning(true);
      try {
        await CanvasAPI.saveCanvas(
          {
            segments: this.state.segments,
            obstacles: this.state.obstacles,
            trees: this.state.trees,
          },
          { strict: true, force: true }
        );
      } catch (e) {
        if (serverSide) this.designerCanvasCommands.setServerSideShadingIsRunning(false);
        displaySnack({
          variant: 'danger',
          message: 'Unable to save the current design before shading.',
        });
        return false;
      }
    }

    // wait for page/tab be visible
    const pageVisibility = !document.hidden;
    while (document.hidden) {
      console.log('wait for page to be visible');
      await new Promise((r) => setTimeout(r, 500));
    }

    if (!pageVisibility) await new Promise((r) => setTimeout(r, 1500));

    const startServerShading = async () => {
      try {
        return await this.canvas3DElement.startServerSideShading();
      } catch (e) {
        this.designerCanvasCommands.setServerSideShadingIsRunning(false);
        return false;
      }
    };

    if (iframe || designFrame) {
      if (serverSide) {
        const serverShadingSaved = await startServerShading();
        if (!serverShadingSaved || this.state.shadingStatus < 0) {
          console.log('fallback: client-side shading');
          const fallbackSaved = await this.canvas3DElement.startShading();
          if (!fallbackSaved) return false;
        }
      } else {
        const clientShadingSaved = await this.canvas3DElement.startShading();
        if (!clientShadingSaved) return false;
      }
    } else {
      if (serverSide) {
        const serverShadingSaved = await startServerShading();
        if (!serverShadingSaved) return false;
      } else {
        await new Promise((resolve) => setTimeout(resolve, 250));
        const clientShadingSaved = await this.canvas3DElement.startShading(
          0,
          null,
          serverSideInfo
        );
        if (!clientShadingSaved) return false;
      }
    }
    await this.reloadCanvas({
      preservePanels: this.state.panels,
      shadingCompleted: true,
    });
    return true;
    // const { uid, shadingAPI, productionMapAPI, CanvasAPI } = this.context;
    // const request = this.exportCanvas();
    // return shadingAPI.create(request)
    //   .then((data) => {
    //     const { roofs, image: production, colorRange } = data;

    //     // update shade factor for each roof in response
    //     const segments = Array.from(this.state.segments);
    //     roofs.forEach(({ solarAccess }, index) => {
    //       // const access = solarAccess.reduce((a, b) => a + b, 0)/solarAccess.length;
    //       segments[index].solarAccess = solarAccess;
    //     });
    //     // save shading data to backend
    //     this.setStatex(
    //       { segments, colorRange, shade: true },
    //       () => CanvasAPI.saveCanvas({ segments })
    //     );
    //     productionMapAPI.update(uid, { production })
    //       .then(({ url }) => this.setStatex({ overlay: url }));
    //     return true;
    //   }).catch(() => false);
  };

  shadingValues = () => {
    // method that is used in iframe to pass back shading values
    const { iframe, callback: iframeCallback } = this.props;

    const { segments, panels } = this.state;
    const annualData = segments.map(({ id, solarAccess, tsrf, tof }) => {
      const panel = panels.find((pnl) => pnl.id === id);

      const annualTSRF = tsrf[12];
      const annualTOF = tof[12];
      const annualSolarAccess = solarAccess[12];

      return {
        id,
        annualSolarAccess,
        annualTSRF,
        annualTOF,
      };
    });

    if (iframeCallback) iframeCallback('ShadingValues', { data: annualData });
  };

  handleProposal = async (params = null, loadAfter = false, options = {}) => {
    /**
     * @param params: iframe params
     */

    // receive design data for creating a new proposal
    const {
      uid,
      refreshLead,
      proposalAPI,
      navigateTab,
      displaySnack,
      newEndpoint,
    } = this.context;
    const activeCanvasId = this.getActiveCanvasId();
    let activeDesignId = this.getActiveDesignId();
    const selectedDesignId = activeDesignId;

    // set hardware from state.package if it exists
    const {
      segments,
      package: _package,
      panels,
      losses,
      annotations,
    } = this.state;
    const requireProduction = options?.requireProduction !== false;

    if (this.state.isCreatingProposal) return;
    this.setState({ isCreatingProposal: true });
    try {
      if (requireProduction && !this.state.productionHandled) {
        this.setState({ isCreatingProposal: false });
        if (displaySnack) {
          displaySnack({
            variant: 'warning',
            message: 'Please click "Calculate Production" before creating a design.',
          });
        }
        return;
      }
      if (requireProduction && this.state.productionSaveError) {
        this.setState({ isCreatingProposal: false });
        if (displaySnack) {
          displaySnack({
            variant: 'warning',
            message:
              'Production was calculated but not saved. Recalculate production before creating a design.',
          });
        }
        return;
      }
      if (activeCanvasId && newEndpoint) {
        const designsAPI = newEndpoint(
          `designer/canvas/${activeCanvasId}/designs`
        );
        const designName = this.suggestedCloneName('design');
        const createdDesign = await designsAPI.create({
          name: designName,
          design_id: activeDesignId,
        });
        if (createdDesign?.id) {
          activeDesignId = String(createdDesign.id);
          this.context.CanvasAPI?.setCanvasTargetId?.(
            activeCanvasId,
            activeDesignId
          );
          try {
            const defaultAPI = newEndpoint(
              `designer/canvas/${activeCanvasId}/designs/${activeDesignId}/default`
            );
            await defaultAPI.create({});
          } catch (e) {}
          await this.loadDesigns();
        }
      }
    } catch (e) { }

    try {
      let snapshot = null;
      try {
        const shot = await this.canvas3DElement?.exportDesignSnapshot?.();
        snapshot = shot?.base64 || null;
      } catch (e) {}
      const snapshotIds = [...new Set(
        [activeDesignId, selectedDesignId]
          .map((id) => String(id || '').trim())
          .filter(Boolean)
      )];
      for (const id of snapshotIds) {
        try {
          await this.uploadDesignSnapshot(id, snapshot);
        } catch (e) {}
      }
    } catch (e) {}

    const {
      iframe,
      designFrame,
      callback: iframeCallback,
      context: iframeContext = {},
    } = this.props;

    const desCompanyPanelId = params?.companyPanelID;
    const desCompanyInverterId = params?.companyInverterID;
    const desCompanyAdditionalInverterIds =
      params?.companyAdditionalInverterIDs;
    const additionalInverters =
      params?.additionalInverters ||
      this.state.package?.additional_inverters ||
      [];
    const primaryInverterAutoQuantityParam =
      typeof params?.primaryInverterAutoQuantity === 'boolean'
        ? params.primaryInverterAutoQuantity
        : this.state.primaryInverterAutoQuantity;
    const requestedInverterQuantity =
      params?.inverterQuantity ?? this.state.package?.inverterQuantity ?? 1;
    const productionSnapshot = this.lastProductionSnapshot;
    const inverterQuantity = resolveMicroInverterQuantity({
      inverter: this.state.package?.inverter,
      primaryInverterAutoQuantity: primaryInverterAutoQuantityParam,
      selectedPanelCount:
        productionSnapshot?.selectedPanelCount ?? this.state.selectedPanelCount,
      invertersUsed:
        productionSnapshot?.invertersUsed ?? this.state.invertersUsed,
      fallbackQuantity: requestedInverterQuantity,
    });

    if (iframeContext?.panelDefault === 'default') {
      const { panel: panelHardware } = _package;
      iframeContext.panelType = { ...panelHardware };
    }

    const effectiveLosses = buildEffectiveSystemLosses({
      baseLosses: losses,
      iframeLosses: params?.losses || iframeContext?.losses,
      lead: this.context.lead,
    });

    // console.log(`handleProposal: ${desCompanyPanelId}, ${desCompanyInverterId}`);
    const data = createProposalData(
      uid,
      this.state,
      panels,
      _package,
      iframeContext,
      desCompanyPanelId,
      desCompanyInverterId,
      designFrame,
      effectiveLosses,
      desCompanyAdditionalInverterIds,
      additionalInverters,
      inverterQuantity,
      // Legacy flag: true = manual qty, false = auto qty
      !primaryInverterAutoQuantityParam
    );
    if (data?.design_data) {
      data.design_data.losses = effectiveLosses;
      data.design_data.design_id = activeDesignId;
      data.design_data.canvas_id = activeCanvasId;
      const loadedCanvasId =
        typeof this.state.canvasId === 'string' ? this.state.canvasId.trim() : '';
      const imageryMatchesSelection =
        loadedCanvasId !== '' &&
        String(loadedCanvasId) === String(activeCanvasId);
      if (imageryMatchesSelection) {
        if (this.state.rgb) data.design_data.rgb = this.state.rgb;
        if (this.state.dsm) data.design_data.dsm = this.state.dsm;
        if (this.state.dsmParams != null) {
          data.design_data.dsm_params = this.state.dsmParams;
        }
        if (this.state.resolution != null) {
          data.design_data.resolution = this.state.resolution;
        }
      }
    }
    if (productionSnapshot && data?.design_data) {
      const sortedSegments = Array.isArray(data?.design_data?.segments)
        ? data.design_data.segments
        : [];
      const originalSegments = Array.isArray(this.state.segments)
        ? this.state.segments
        : [];
      const sortedIndexById = new Map();
      sortedSegments.forEach((segment, idx) => {
        if (segment?.id !== undefined) {
          sortedIndexById.set(segment.id, idx);
        }
      });
      const mapRoofIndex = (origIdxRaw) => {
        const origIdx = Number(origIdxRaw);
        if (!Number.isFinite(origIdx)) return origIdxRaw;
        const segId = originalSegments?.[origIdx]?.id;
        if (segId !== undefined && sortedIndexById.has(segId)) {
          const mappedIdx = sortedIndexById.get(segId);
          return Number.isFinite(Number(mappedIdx)) ? Number(mappedIdx) : origIdx;
        }
        return origIdx;
      };
      const mapRoofKeyedObject = (obj) => {
        if (!obj || typeof obj !== 'object') return null;
        const mapped = Array.isArray(obj) ? [] : {};
        Object.keys(obj).forEach((key) => {
          const origIdx = Number(key);
          if (!Number.isFinite(origIdx)) return;
          const mappedIdx = mapRoofIndex(origIdx);
          if (Array.isArray(mapped)) {
            mapped[mappedIdx] = obj[key];
          } else {
            mapped[mappedIdx] = obj[key];
          }
        });
        return mapped;
      };
      const mapSelectedPanelsPerRoof = (selected) => {
        if (!selected || typeof selected !== 'object') return null;
        const mapped = {};
        Object.keys(selected).forEach((key) => {
          const origIdx = Number(key);
          if (!Number.isFinite(origIdx)) return;
          const mappedIdx = mapRoofIndex(origIdx);
          mapped[mappedIdx] = Array.isArray(selected[key])
            ? selected[key]
            : [];
        });
        return mapped;
      };
      const mapProductionPerPanel = (entries) => {
        if (!Array.isArray(entries)) return null;
        const mapped = entries
          .map((entry, idx) => {
            const origIdx = Number(
              entry?.idx !== undefined ? entry.idx : idx
            );
            const mappedIdx = mapRoofIndex(origIdx);
            return {
              ...entry,
              idx: mappedIdx,
            };
          })
          .filter((entry) => entry && Number.isFinite(Number(entry.idx)));
        return mapped.sort((a, b) => Number(a.idx) - Number(b.idx));
      };
      const mapStringingData = (strings) => {
        if (!Array.isArray(strings)) return strings;
        return strings.map((entry) => {
          const panelsRaw = Array.isArray(entry?.panels) ? entry.panels : [];
          const panels = panelsRaw
            .map((panel) => {
              if (!Array.isArray(panel) || panel.length < 2) return null;
              const mappedIdx = mapRoofIndex(panel[0]);
              return [mappedIdx, panel[1]];
            })
            .filter(Boolean);
          return {
            ...entry,
            panels,
          };
        });
      };
      const mappedProductionPerPanel = mapProductionPerPanel(
        productionSnapshot.productionPerPanelData
      );
      const mappedStringingData = mapStringingData(
        productionSnapshot.stringingData
      );
      const mappedSelectedPanelsPerRoof = mapSelectedPanelsPerRoof(
        productionSnapshot.selectedPanelsPerRoof
      );
      const mappedPerRoofAnnualKwh = mapRoofKeyedObject(
        productionSnapshot.perRoofAnnualKwh
      );
      const mappedPerRoofMonthlyAc = mapRoofKeyedObject(
        productionSnapshot.perRoofMonthlyAc
      );
      const mappedPerRoofMonthlyPoa = mapRoofKeyedObject(
        productionSnapshot.perRoofMonthlyPoa
      );
      const mappedPerRoofClippingKwh = mapRoofKeyedObject(
        productionSnapshot.perRoofClippingKwh
      );
      if (
        Array.isArray(mappedProductionPerPanel) &&
        data.design_data.productionPerPanel == null
      ) {
        data.design_data.productionPerPanel = mappedProductionPerPanel;
      }
      if (
        Array.isArray(productionSnapshot.productionPerStringData) &&
        data.design_data.productionPerString == null
      ) {
        data.design_data.productionPerString =
          productionSnapshot.productionPerStringData;
      }
      if (
        productionSnapshot.hourlyProduction != null &&
        data.design_data.hourlyProduction == null
      ) {
        data.design_data.hourlyProduction =
          productionSnapshot.hourlyProduction;
      }
      if (
        mappedStringingData &&
        data.design_data.stringing_data == null
      ) {
        data.design_data.stringing_data = mappedStringingData;
      }
      if (
        productionSnapshot.invertersUsed &&
        data.design_data.inverters_used == null
      ) {
        data.design_data.inverters_used = productionSnapshot.invertersUsed;
      }
      if (
        mappedSelectedPanelsPerRoof &&
        data.design_data.selectedPanelsPerRoof == null
      ) {
        data.design_data.selectedPanelsPerRoof = mappedSelectedPanelsPerRoof;
      }
      if (
        mappedPerRoofAnnualKwh &&
        data.design_data.perRoofAnnualKwh == null
      ) {
        data.design_data.perRoofAnnualKwh = mappedPerRoofAnnualKwh;
      }
      if (
        mappedPerRoofMonthlyAc &&
        data.design_data.perRoofMonthlyAc == null
      ) {
        data.design_data.perRoofMonthlyAc = mappedPerRoofMonthlyAc;
      }
      if (
        mappedPerRoofMonthlyPoa &&
        data.design_data.perRoofMonthlyPoa == null
      ) {
        data.design_data.perRoofMonthlyPoa = mappedPerRoofMonthlyPoa;
      }
      if (
        mappedPerRoofClippingKwh &&
        data.design_data.perRoofClippingKwh == null
      ) {
        data.design_data.perRoofClippingKwh = mappedPerRoofClippingKwh;
      }
      if (
        productionSnapshot.dcAcRatio != null &&
        data.design_data.dc_ac_ratio == null
      ) {
        data.design_data.dc_ac_ratio = productionSnapshot.dcAcRatio;
      }
      if (
        productionSnapshot.annualClippingKwh != null &&
        data.design_data.annual_clipping_kwh == null
      ) {
        data.design_data.annual_clipping_kwh =
          productionSnapshot.annualClippingKwh;
      }
      if (
        Array.isArray(productionSnapshot.monthlyClippingKwh) &&
        data.design_data.monthly_clipping_kwh == null
      ) {
        data.design_data.monthly_clipping_kwh =
          productionSnapshot.monthlyClippingKwh;
      }
      if (
        Array.isArray(productionSnapshot.monthlyProduction) &&
        data.design_data.monthlyProduction == null
      ) {
        data.design_data.monthlyProduction =
          productionSnapshot.monthlyProduction;
      }
      data.design_data.limitReached = Boolean(productionSnapshot.limitReached);
      data.design_data.limit_reached = Boolean(productionSnapshot.limitReached);
      if (productionSnapshot.annualProduction != null) {
        data.design_data.summary = {
          ...(data.design_data.summary || {}),
          solar_production: productionSnapshot.annualProduction,
          system_size:
            productionSnapshot.systemSizeKw != null
              ? productionSnapshot.systemSizeKw
              : data.design_data.summary?.system_size,
          total_panels:
            productionSnapshot.selectedPanelCount != null
              ? productionSnapshot.selectedPanelCount
              : data.design_data.summary?.total_panels,
        };
      }
    }

    // console.log(`handleProposal - iframe context: ${JSON.stringify(iframeContext)}\nhandleProposal - package: ${JSON.stringify(_package)}\nhandleProposal - data: ${JSON.stringify(data)}\n`)

    const stripDesignForLegacy = (d) => {
      if (!d || typeof d !== 'object') return d;
      const {
        id,
        azimuth,
        panel_orientation,
        horizontal,
        horizontal_size,
        horizontal_selected,
        vertical,
        vertical_size,
        vertical_selected,
        ac_monthly,
        solar_access,
        tsrf,
        tof,
      } = d;
      return {
        id,
        azimuth,
        panel_orientation,
        horizontal,
        horizontal_size,
        horizontal_selected,
        vertical,
        vertical_size,
        vertical_selected,
        ac_monthly,
        solar_access,
        tsrf,
        tof,
      };
    };
    const onCreated = ({ id, version }) => {
      const proposalVersion = version || CURRENT_PROPOSAL_VERSION;
      refreshLead('proposals');
      if (!iframe) navigateTab(`proposals?id=${id}`);
      else if (iframeCallback) iframeCallback('NewProposal', id, proposalVersion);
      if (loadAfter) {
        window.location.replace(`/iframe/${uid}?id=${id}`);
      }
      this.setState({ isCreatingProposal: false });
    };

    const proposalName = this.suggestedCloneName('proposal');
    return proposalAPI
      .create({
        ...data,
        name: '',
        version: CURRENT_PROPOSAL_VERSION,
        annotations,
        design_id: activeDesignId,
        canvas_id: activeCanvasId,
      })
      .then(onCreated)
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 400) {
          const legacyData = {
            ...data,
            designs: Array.isArray(data?.designs)
              ? data.designs.map(stripDesignForLegacy)
              : data.designs,
          };
          return proposalAPI
            .create({
              ...legacyData,
              name: proposalName,
              version: CURRENT_PROPOSAL_VERSION,
              annotations,
              design_id: activeDesignId,
              canvas_id: activeCanvasId,
            })
            .then(onCreated)
            .catch((legacyErr) => {
              this.setState({ isCreatingProposal: false });
              throw legacyErr;
            });
        }
        this.setState({ isCreatingProposal: false });
        throw err;
      });
  };

  handleMode = (mode) => {
    const { currentAccordion, currentTab } = this.state;
    if (currentAccordion === 'segments' && currentTab === 'segment-labels') {
      this.setState3x({ mode, selectedLabel: '' });
    } else {
      this.setState3x({ mode });
    }
  };

  handleCurrentAccordion = (currentAccordion) => {
    const prevAccordion = this.state.currentAccordion;
    const { iframe, designFrame } = this.props;

    if (iframe && !designFrame) {
      if (this.state.segments?.length === 0) {
        return false;
      }
    }

    const next = transitionAccordion(this.state, currentAccordion);
    const nextState = {
      currentAccordion: next.currentAccordion,
      mode: next.mode,
      tool: next.tool,
      losses: next.losses,
    };
    if (currentAccordion === 'design') {
      nextState.selectionMode = next.selectionMode;
      nextState.selectedObjects = next.selectedObjects;
    }
    this.setState3x(nextState);

    if (currentAccordion === 'design' && prevAccordion === 'revise') {
      this.clearSelectedPanelsOnly();
    }

    if (currentAccordion === 'production') {
      const inverterType = this.state.package?.inverter?.type;
      const isMicro = inverterType === 'M' || inverterType === 'Micro';
      const trySelect = () => {
        try {
          if (!(this.canvas3DElement && this.canvas3DElement.isLoaded))
            return false;
          if (!this.canvas3DElement?.selectPanelsFromStringing) return false;
          const strings = this.state.stringingData;
          if (!Array.isArray(strings) || strings.length === 0) return false;
          this.restoreStringingSelection(strings);
          return true;
        } catch (e) {
          return false;
        }
      };

      if (!trySelect()) {
        let tries = 0;
        const retry = () => {
          tries += 1;
          if (tries > 8) return;
          if (trySelect()) return;
          setTimeout(retry, 100);
        };
        setTimeout(retry, 0);
      }

      if (!isMicro) {
      }
    }
    return true;
  };

  applySharedDesignerCommand = (
    command,
    {
      strategy = 'history',
      persistCanvas = false,
      onApplied = null,
      checkShading = true,
    } = {}
  ) => {
    const commandResultBase = runDesignerCommand(
      this.pendingDesignerState || this.state,
      command
    );
    const commandResult = {
      ...commandResultBase,
      state: applyDesignerRoofEffects(
        commandResultBase.state,
        commandResultBase.effects
      ),
    };
    this.pendingDesignerState = commandResult.state;
    const persistKeys = [
      ...new Set(
        (commandResult.effects || [])
          .filter((item) => item.type === DesignerEffectTypes.PERSIST)
          .flatMap((item) => item.keys || [])
      ),
    ];
    const shouldCheckShading =
      checkShading &&
      (commandResult.effects || []).some(
        (item) => item.type === DesignerEffectTypes.CHECK_SHADING
      );
    const done = () => {
      if (this.pendingDesignerState === commandResult.state) {
        this.pendingDesignerState = null;
      }
      if (persistCanvas && persistKeys.length) {
        const payload = {};
        persistKeys.forEach((key) => {
          payload[key] = commandResult.state[key];
        });
        this.context.CanvasAPI.saveCanvas(payload);
      }
      if (typeof onApplied === 'function') onApplied(commandResult);
      const treeOnly = persistKeys.length === 1 && persistKeys[0] === 'trees';
      if (shouldCheckShading) {
        setTimeout(
          () => this.checkShadingRerunNeeded({ clearPanels: !treeOnly }),
          0
        );
      }
    };

    const patch = {};
    Object.keys(commandResult.state || {}).forEach((key) => {
      if (commandResult.state[key] !== this.state[key]) {
        patch[key] = commandResult.state[key];
      }
    });

    if (!Object.keys(patch).length) {
      done();
      return commandResult;
    }
    if (strategy === 'state2x') {
      this.setState2x(patch, done);
    } else if (strategy === 'state3x') {
      this.setState3x(patch);
      done();
    } else {
      this.setStatex(patch, done, persistKeys);
    }
    return commandResult;
  };

  handleNewSegment = ({ geometry: geom, ...segment }) => {
    const commandResult = this.applySharedDesignerCommand({
      type: DesignerCommandTypes.NEW_SHAPE,
      shape: { ...segment, geometry: geom },
      options: {
        accordion: 'segments',
        scaled: false,
        id: segment.id || canvasHandler.uuid(),
      },
    });
    return commandResult.item;
  };

  handleNewObstacle = (obstacle) => {
    this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.NEW_SHAPE,
        shape: obstacle,
        options: { accordion: 'obstacles', scaled: false },
      },
      { strategy: 'state3x' }
    );
  };

  handleNewTree = (tree) => {
    this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.NEW_SHAPE,
        shape: tree,
        options: { accordion: 'trees', scaled: false },
      },
      { strategy: 'state3x' }
    );
  };

  handlePitchInDegreesChange = (value) => {
    const next = Boolean(value);
    this.setState({ pitch_in_degrees: next });
    this.context.CanvasAPI.saveCanvas({ pitch_in_degrees: next });
  };

  handleNewShape = (shape, scaled = true) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.NEW_SHAPE,
        shape,
        options: {
          scaled,
          id:
            this.state.currentAccordion === 'segments'
              ? shape.id || canvasHandler.uuid()
              : shape.id,
        },
      },
      {
        strategy:
          this.state.currentAccordion === 'segments' ? 'history' : 'state3x',
        persistCanvas: this.state.currentAccordion === 'annotations',
      }
    );
  };

  handleSaveEdits = (updated, scaled = true) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.SAVE_SHAPE_EDITS,
        updated,
        options: { scaled },
      },
      {
        persistCanvas: this.state.currentAccordion === 'annotations',
        onApplied: (commandResult) => {
          if (commandResult.deletedKind === 'segment') {
            const productionResetState = this.resetProductionForLayoutChange();
            this.setState3x(productionResetState);
            this.persistProductionReset({
              segments: commandResult.state.segments,
              panels: commandResult.state.panels,
            });
          }
        },
      }
    );
  };

  handleAddPointToPolygon = (index, lineIndex, point, scaled = false) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.ADD_POLYGON_POINT,
        index,
        lineIndex,
        point,
        options: { scaled },
      },
      { strategy: 'state2x' }
    );
  };

  handleRemovePointFromPolygon = (index, pointIdxInGeometry) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.REMOVE_POLYGON_POINT,
        index,
        pointIndex: pointIdxInGeometry,
      },
      { strategy: 'state2x' }
    );
  };

  handleLineLabel = (index, lineIndex, lines) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.LABEL_LINE,
        index,
        lineIndex,
        lines,
      },
      {
        strategy: 'history',
      }
    );
  };

  handleSegmentAzimuth = (idx, azimuth) => {
    const { resolution } = this.state;
    const segment = this.state.segments[idx];
    const area = calculateSegmentArea(segment, resolution);
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.PATCH_SEGMENT,
        index: idx,
        patch: {
          azimuth: Number(azimuth),
          area,
          pvwatts_update: true,
        },
      },
      { strategy: 'state3x' }
    );
  };

  handleSegmentPitchAndArea = (idx, pitch) => {
    const { resolution } = this.state;
    if (idx === -1) {
      const segments = this.state.segments.map((segment) => ({
        ...segment,
        pitch: Number(pitch),
        area: calculateSegmentArea(segment, resolution),
        pvwatts_update: true,
      }));
      return this.applySharedDesignerCommand(
        {
          type: DesignerCommandTypes.SET_SEGMENTS,
          segments,
        },
        { strategy: 'state3x' }
      );
    }
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.PATCH_SEGMENT,
        index: idx,
        patch: {
          pitch: Number(pitch),
          area: calculateSegmentArea(this.state.segments[idx], resolution),
          pvwatts_update: true,
        },
      },
      { strategy: 'state3x' }
    );
  };

  handleSegmentEaveHeight = (idx, height) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.PATCH_SEGMENT,
        index: idx,
        patch: { height },
      },
      { strategy: 'state3x' }
    );
  };

  handleTreeUpdate = (tree, idx) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.PATCH_TREE,
        tree,
        index: idx,
      },
      { strategy: 'state3x' }
    );
  };

  // TODO: re-write this + subsequent into a single method
  handleAddPointToPolygonFromMenu = (key) => {
    this.setState2x({
      mode: 'edit',
      polyEdit: 1,
      focusedPolygonToEdit: key,
    });
  };

  handleRemovePointFromPolygonFromMenu = (key) => {
    this.setState2x({
      mode: 'edit',
      polyEdit: 2,
      focusedPolygonToEdit: key,
    });
  };

  handleReplaceShapes = (shapes, removeKeys, scaled = true) => {
    const add = Array.isArray(shapes) ? shapes : [shapes];
    const remove = Array.isArray(removeKeys) ? removeKeys : [removeKeys];
    const accordion = this.state.currentAccordion;
    const commandResult = this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.REPLACE_SHAPES,
        add,
        remove,
        options: { scaled, accordion },
      },
      {
        strategy: accordion === 'segments' ? 'history' : 'state3x',
        persistCanvas: accordion !== 'segments',
      }
    );
    if (accordion === 'segments') {
      const { CanvasAPI } = this.context;
      const productionResetState = this.resetProductionForLayoutChange();
      if (CanvasAPI?.saveCanvas) {
        CanvasAPI.saveCanvas({
          segments: commandResult.state.segments,
          panels: commandResult.state.panels,
          ...createProductionResetCanvas(),
        });
      }
      this.setState3x(productionResetState);
    }
    return commandResult;
  };

  handleDeleteShape = (key) => {
    if (this.state.currentAccordion === 'segments') {
      return this.handleDeleteSegment(key);
    }
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.DELETE_SHAPE,
        key,
      },
      {
        persistCanvas: this.state.currentAccordion === 'annotations',
      }
    );
  };

  handleDeleteSegment = (key) => {
    const { CanvasAPI } = this.context;
    const source = this.pendingDesignerState || this.state;
    const next = removeGeometry(source, 'segment', key);
    this.pendingDesignerState = {
      ...source,
      segments: next.segments,
      panels: next.panels,
      selectedObjects: next.selectedObjects,
      selectedRoof: next.selectedRoof,
      selectedPanels: next.selectedPanels,
    };
    const productionResetState = this.resetProductionForLayoutChange();

    CanvasAPI.saveCanvas({
      segments: next.segments,
      panels: next.panels,
      ...createProductionResetCanvas(),
    });
    this.setState3x({
      segments: next.segments,
      panels: next.panels,
      selectedObjects: next.selectedObjects,
      selectedRoof: next.selectedRoof,
      selectedPanels: next.selectedPanels,
      ...productionResetState,
    });
    setTimeout(() => this.checkShadingRerunNeeded(), 0);
  };

  handleDeleteObstacle = (key) => {
    return this.applySharedDesignerCommand({
      type: DesignerCommandTypes.DELETE_SHAPE,
      key,
      options: { accordion: 'obstacles' },
    });
  };

  handleDeleteTree = (key) => {
    return this.applySharedDesignerCommand({
      type: DesignerCommandTypes.DELETE_SHAPE,
      key,
      options: { accordion: 'trees' },
    });
  };

  handleDeleteAllTrees = () => {
    return this.applySharedDesignerCommand({
      type: DesignerCommandTypes.DELETE_ALL_TREES,
    });
  };

  handleDeleteAnnotation = (key) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.REMOVE_ANNOTATION,
        key,
      },
      {
        persistCanvas: true,
      }
    );
  };

  handleNewPanel = async () => {
    const { viewMode, panels } = this.state;
    if (countPlacedDesignerPanels(panels) === 0) {
      await this.applyPendingPanelHardware();
    }
    if (viewMode === '3D') {
      this.canvas3DElement.toggleView('insert');
      return;
    }
    this.placePanelsElement.addNewPanel();
  };

  handleDeletePanel = () => {
    const { panels, selectedPanels, viewMode } = this.state;
    if (viewMode === '3D') {
      this.canvas3DElement.deletePanels();
      return;
    }
    if (!selectedPanels) return;

    const deleted = panels.map((panel) => {
      const horizontal = panel.horizontal.points.filter(
        (pt, jdx) => !panel.horizontal.selected[jdx]
      );
      const vertical = panel.vertical.points.filter(
        (pt, jdx) => !panel.vertical.selected[jdx]
      );
      return {
        ...panel,
        horizontal: {
          ...panel.horizontal,
          points: horizontal,
          selected: Array(horizontal.length).fill(false),
        },
        vertical: {
          ...panel.vertical,
          points: vertical,
          selected: Array(vertical.length).fill(false),
        },
      };
    });
    this.setState2x({
      panels: deleted,
      selectedPanels: false,
      ...this.resetProductionForLayoutChange(),
    });
    this.syncSelectedPanelFrom2D();
    this.persistProductionReset({ panels: deleted });
    this.scheduleSolarProduction('panels_deleted', { forceRun: true });
  };

  handleRotatePanel = () => {
    const { panels, selectedPanels, viewMode } = this.state;
    if (viewMode === '3D') {
      this.canvas3DElement.rotatePanels();
      return;
    }
    if (!selectedPanels) return;

    const rotated = panels.map((panel) => {
      const horizontal = [];
      const vertical = [];
      panel.horizontal.points.forEach((pt, jdx) => {
        if (panel.horizontal.selected[jdx]) vertical.push(pt);
        else horizontal.push(pt);
      });
      panel.vertical.points.forEach((pt, jdx) => {
        if (panel.vertical.selected[jdx]) horizontal.push(pt);
        else vertical.push(pt);
      });
      return {
        ...panel,
        horizontal: {
          ...panel.horizontal,
          points: horizontal,
          selected: Array(horizontal.length).fill(false),
        },
        vertical: {
          ...panel.vertical,
          points: vertical,
          selected: Array(vertical.length).fill(false),
        },
      };
    });
    this.setState2x({
      panels: rotated,
      selectedPanels: false,
      ...this.resetProductionForLayoutChange(),
    });
    this.syncSelectedPanelFrom2D();
    this.persistProductionReset({ panels: rotated });
    this.scheduleSolarProduction('panels_rotated', { forceRun: true });
  };

  handlePanelAzimuth = (index, azimuth) => {
    if (index === null) return;
    this.setStatex(
      ({ segments, panels }) => {
        const segment = segments[index];
        const rotated = rotateSegmentPanels(segment, panels[index], azimuth);
        panels.splice(index, 1, rotated);
        return {
          panels: [...panels],
          ...this.resetProductionForLayoutChange(),
        };
      },
      () => this.persistProductionReset({ panels: this.state.panels }),
      ['panels']
    );
  };

  updateSetbacks = (
    pFireSetbacks = null,
    pSetbackMode = null,
    forceUpdate = false
  ) => {
    const next = applySetbacks(this.state, {
      fireSetbacks: pFireSetbacks,
      setbackMode: pSetbackMode,
      forceUpdate,
    });
    const hasChanged = Boolean(next.__setbacksChanged);

    this.setState2x({
      segments: next.segments,
      setbackMode: next.setbackMode,
      fireSetbacks: next.fireSetbacks,
    });
    if (hasChanged)
      this.context.CanvasAPI.saveCanvas({
        segments: next.segments,
      });
    return hasChanged;
  };

  handleSetbackMode = (setbackMode) =>
    this.setStatex({ setbackMode }, () =>
      this.updateSetbacks(null, null, true)
    );

  handleFireSetbacks = (setback, label) => {
    this.setStatex(
      (state) => {
        const next = patchFireSetbacks(state, setback, label);
        return { fireSetbacks: next.fireSetbacks };
      },
      () => {
        this.updateSetbacks(null, null, true);
      },
      ['fireSetbacks']
    );
  };

  handleLineSetbackEdit = (editLines, setback) => {
    const next = patchSegmentSetbacks(this.state, editLines, setback);
    this.setStatex({ segments: next.segments }, null, ['segments']);
  };

  handlePanels = (panels) => {
    const prevPanels = this.state.panels;
    const pendingPanel = this.maybeApplyPendingPanelForFirstPlacement(
      prevPanels,
      panels
    );
    const panelCommit = buildSelectedPanelCommit(
      this.state.package,
      pendingPanel
    );
    const packageUpdate = pendingPanel
      ? { package: panelCommit.package }
      : {};
    this.setState3x({
      panels,
      ...packageUpdate,
      ...this.resetProductionForLayoutChange(),
    });
    this.persistProductionReset({
      panels,
      selected_panel_id: panelCommit.persistence.selected_panel_id,
      ...(pendingPanel
        ? {
            selected_panel_spec:
              panelCommit.persistence.selected_panel_spec,
          }
        : {}),
    });
  };

  handleTool = (tool) => this.designerState.applyTool(tool);

  handleSelectedLabel = (selectedLabel) =>
    this.designerState.applySelectedLabel(selectedLabel);

  clearLabelsHandler = () => {
    const { segments } = this.state;
    const newSegments = [...segments];
    newSegments.forEach((s) => {
      s.lines = s.geometry.map(() => '');
    });
    this.setStatex({ segments: newSegments }, () => {
      this.updateSetbacks(null, null, true);
    });
  };

  clearMeasurment = () => {
    const { segments } = this.state;
    const newSegments = [...segments];
    newSegments.forEach((s) => {
      s.pitch = 0;
      s.azimuth = 0;
      s.height = 0;
    });
    this.setSegmentParameters(newSegments);
  };

  resetProductionForPanelLayoutChange = () => {
    const updates = {
      productionHandled: false,
      totalAnnualKwh: 0,
      totalMonthlyKwh: Array(12).fill(0),
      totalClippingKwh: 0,
      totalMonthlyClippingKwh: Array(12).fill(0),
      dcAcRatio: null,
      stringingData: null,
      invertersUsed: null,
      productionPerPanel: 0,
      productionPerPanelData: null,
      productionPerStringData: null,
      hourlyProduction: null,
      productionHardware: null,
      selectedPanelCount: 0,
      systemSizeKw: null,
      mpptCountTotal: null,
    };
    this.lastProductionSnapshot = null;
    this.setState(updates);
    try {
      this.context.CanvasAPI.saveCanvas({
        total_annual_kwh: 0,
        total_monthly_kwh: Array(12).fill(0).join(','),
        total_clipping_kwh: 0,
        total_monthly_clipping_kwh: Array(12).fill(0).join(','),
        dc_ac_ratio: null,
        stringing_data: null,
        inverters_used: null,
        production_per_panel: null,
        production_per_string: null,
        hourly_production: null,
        system_size_kw: null,
        mppt_count_total: null,
      });
    } catch (e) {}
  };

  clearPanels = () => {
    const { panelPlacementOnlySelectedRoof, selectedObjects } = this.state;
    this.canvas3DElement.clearPanels(panelPlacementOnlySelectedRoof);

    // Clear panels state
    // If clearing all panels (not just selected roof), set to empty array to disable Calculate Production button
    // If clearing only selected roof, update those specific panels but keep the array structure
    let clearedPanels = [];

    if (panelPlacementOnlySelectedRoof) {
      // Only clear panels for selected roof segments - keep array structure
      const { panels, segments } = this.state;
      const selectedRoofIndices = this.state.selectedObjects?.roofSegments || [];
      clearedPanels = panels.map((panel, index) => {
        if (selectedRoofIndices.includes(index)) {
          // Return empty panel structure for selected roofs
          return {
            ...panel,
            id: panel?.id || segments[index]?.id || String(index),
            azimuth: panel?.azimuth || 0,
            horizontal: {
              ...panel?.horizontal,
              points: [],
              selected: [],
            },
            vertical: {
              ...panel?.vertical,
              points: [],
              selected: [],
            },
          };
        }
        return panel; // Keep existing panel for non-selected roofs
      });
    } else {
      // Clear all panels - set to empty array so panels.length === 0 and button is disabled
      clearedPanels = [];
    }

    this.setState({
      panels: clearedPanels,
      selectedPanels: false,
      selectedObjects: { ...selectedObjects, panels: {} },
      ...this.resetProductionForLayoutChange(),
    });

    this.context.CanvasAPI.saveCanvas({
      panels: clearedPanels,
      ...createProductionResetCanvas(),
    });
  };

  scheduleSolarProduction = (reason = 'change', options = {}) => {
    try {
      clearTimeout(this.solarProductionDebounceTimer);
    } catch (e) { }

    const isPanelOrInverterChange =
      String(reason || '').includes('panel') || String(reason || '').includes('inverter');
    if (!options?.forceRun && isPanelOrInverterChange) {
      this.solarProductionDebounceReason = reason;
      if (String(reason || '').includes('panel')) {
        this.resetProductionForPanelLayoutChange();
      }
      return;
    }

    this.solarProductionDebounceReason = reason;
    this.solarProductionDebounceTimer = setTimeout(() => {
      try {
        this.handleSolarProduction({ persistSelectionState: true, ...options });
      } catch (e) { }
    }, 900);
  };

  clearSelectedPanelsOnly = () => {
    const next = clearPanelSelectionFlags(this.state);
    this.setState2x(
      {
        panels: next.panels,
        selectedPanels: next.selectedPanels,
        selectedObjects: next.selectedObjects,
      },
      () => {
        this.syncSelectedPanelFrom2D();
      }
    );
  };

  handleBuffer = (buffer) => {
    this.setState3x({ buffer });
    try {
      if (this.context.CanvasAPI?.saveCanvas) this.context.CanvasAPI.saveCanvas({ buffer });
    } catch (e) {}
  };

  handleRowSpacing = (rowSpacing) => {
    this.setState3x({ rowSpacing });
    try {
      if (this.context.CanvasAPI?.saveCanvas) this.context.CanvasAPI.saveCanvas({ rowSpacing });
    } catch (e) {}
  };

  handlePanelTilt = (panelTilt) => {
    this.setState3x({ panelTilt });
    try {
      if (this.context.CanvasAPI?.saveCanvas) this.context.CanvasAPI.saveCanvas({ panelTilt });
    } catch (e) {}
  };

  handleAzimuthRestriction = (azimuthRestriction) => {
    this.setState3x({ azimuthRestriction });
    try {
      if (this.context.CanvasAPI?.saveCanvas) this.context.CanvasAPI.saveCanvas({ azimuthRestriction });
    } catch (e) {}
  };

  handleSegmentTabs = (currentTab) => {
    const mode = currentTab === 'segment-labels' ? 'label' : 'draw';
    this.setState2x({ mode, currentTab });
  };

  handleSelectedPanel = (id, isSelected = null) => {
    const [idx, hv, jdx] = id.split('_');
    const panelIndex = Number(idx);
    const selectedIndex = Number(jdx);
    const { panels: currentPanels } = this.state;

    const panels = currentPanels.map((panel, index) => {
      if (index !== panelIndex) return panel;
      const selected = [...panel[hv].selected];
      selected[selectedIndex] =
        isSelected === null ? !selected[selectedIndex] : isSelected;
      return {
        ...panel,
        [hv]: {
          ...panel[hv],
          selected,
        },
      };
    });

    const selectedPanels = panels.some(
      (panel) =>
        panel.vertical.selected.some((el) => el) ||
        panel.horizontal.selected.some((el) => el)
    );

    this.setState2x({ panels, selectedPanels });
    try {
      this.context.CanvasAPI?.saveCanvas?.({ panels });
    } catch (e) {}

    this.syncSelectedPanelFrom2D();
    if (this.state.onlySelectedPanels) {
      this.setState(this.resetProductionForLayoutChange());
    }
  };

  handleSelectedRoof = (index) => {
    const selectedRoof = index === undefined ? -1 : index;
    this.setState3x({ selectedRoof });
    this.syncSelectedRoofFrom2D();
  };

  // TODO: do we still need this?
  // setScroller = (left, top) => this.setStatex({ scroller: [left, top] });

  handleResetScale = () => {
    this.setState({ scale: DESIGN_SCALE });
    this.canvas3DElement.zoomCamera(0);
  };

  handleScaleUp = () => {
    this.setState(({ scale }) => ({ scale: Math.min(scale * 1.3, 10) }));
    this.canvas3DElement.zoomCamera(1.1);
  };

  handleScaleDown = () => {
    this.setState(({ scale }) => ({
      scale: Math.max(scale / 1.3, DESIGN_SCALE),
    }));
    this.canvas3DElement.zoomCamera(0.9);
  };

  automaticAzimuthMode = (mode) => {
    this.setState3x({ automaticAzimuth: mode });
  };

  mapsLink = () => {
    const { lead } = this.context;
    const [lat, lng] = lead.property.coordinates;
    return `https://www.google.com/maps/@${lat},${lng},61m/data=!3m1!1e3`;
  };

  toggleOverlay = () => this.setState({ showOverlay: !this.state.showOverlay });

  cleanCanvas = () => {
    const { CanvasAPI, displaySnack, removeShadingsAPI, lead } = this.context;
    // this.drawCanvasElement.cleanCanvas();
    try {
      this.canvas3DElement?.clearPanels?.(false);
    } catch (e) { }
    const clearedCanvas = {
      segments: [],
      obstacles: [],
      trees: [],
      panels: [],
    };
    this.setState3x({
      ...clearedCanvas,
      ...this.resetProductionForLayoutChange(),
    });
    if (CanvasAPI?.saveCanvas) {
      CanvasAPI.saveCanvas({
        ...clearedCanvas,
        ...createProductionResetCanvas(),
      }).catch(() => {
        try {
          displaySnack({
            variant: 'danger',
            message: 'Unable to clear canvas.',
          });
        } catch (e) {}
      });
    }
    const request = { uid: lead.uid, design_id: this.getActiveDesignId() };
    removeShadingsAPI
      ?.create?.(request)
      ?.then((data) => {
        console.log('shading gradients removed');
      })
      ?.catch(() => {});
  };

  canvas_import_dxf = () => {
    const { canvasImportDxfAPI, lead } = this.context;
    const request = {
      uid: lead.uid,
    };
    canvasImportDxfAPI.create(request).then((data) => {
      console.log('import dxf');
    });
  };

  handleMouseWheel = (event) => {
    const { scale, viewMode, currentAccordion, canvasSize } = this.state;
    if (viewMode === '2D') {
      const wheel = event.deltaY / 120;
      // if (wheel < 0) this.handleScaleUp();
      // else this.handleScaleDown();
      this.mouseDownPosition = [event.clientX, event.clientY];
      const { top: ctop, left: cleft } = this.container.getBoundingClientRect();
      const { top, left } = event.target.getBoundingClientRect();
      const pos = [
        this.mouseDownPosition[0] - left,
        this.mouseDownPosition[1] - top,
      ];
      const newScale =
        wheel < 0
          ? Math.min(scale * 1.3, 10)
          : Math.max(scale / 1.3, DESIGN_SCALE);
      const scaleRatio = newScale / scale;
      const newPos = [pos[0] * scaleRatio, pos[1] * scaleRatio];
      const baseSize = canvasSize || DEFAULT_CANVAS_SIZE;
      const size = baseSize * newScale;
      if (konvaKeys.includes(currentAccordion)) {
        // this.placePanelsElement.updateScale(newScale);
        // pass
      } else {
        // this.drawCanvasElement.updateScale(newScale, size);
      }
      this.container.scrollLeft =
        newPos[0] - (this.mouseDownPosition[0] - cleft);
      this.container.scrollTop = newPos[1] - (this.mouseDownPosition[1] - ctop);
    }
  };

  handleMouseDown = (event) => {
    if (this.mouseDownState) return;

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (event.button === 2 || isIOS) {
      event.preventDefault();
      event.stopPropagation();
      this.mouseDownState = true;
      this.mouseDownPosition = [event.clientX, event.clientY];
      this.scrollPosition = [
        this.container.scrollLeft,
        this.container.scrollTop,
      ];
    }
  };

  handleMouseMove = (event) => {
    const { iframe, designFrame } = this.props;
    if (!designFrame) {
      if (
        this.canvas3DElement.isLoaded &&
        this.container &&
        !this.container.hidden
      )
        disableScroll.on({ disableScroll: true, disableWheel: true });
    }
    if (this.mouseDownState) {
      const pos = [event.clientX, event.clientY];
      this.container.scrollLeft =
        this.scrollPosition[0] - pos[0] + this.mouseDownPosition[0];
      this.container.scrollTop =
        this.scrollPosition[1] - pos[1] + this.mouseDownPosition[1];
    }
  };

  handleMouseUp = () => {
    this.mouseDownState = false;
    this.handleWindowMouseUp();
  };

  handleMouseLeave = () => {
    disableScroll.off();
  };

  handleMouseEnter = () => {
    const { iframe, designFrame } = this.props;
    if (!designFrame) {
      if (
        this.canvas3DElement.isLoaded &&
        this.container &&
        !this.container.hidden
      ) {
        disableScroll.on({ disableScroll: true, disableWheel: true });
      }
    }
  };

  // replace with inline arrow function
  goFullScreen = (enabled) => {
    this.setState({ isFullScreen: enabled });
  };

  changePanelHardware = async (panel) => {
    const transition = selectDesignerPanelHardware(this.state, panel);
    if (!transition.selectedPanel) return false;
    if (!transition.pending) {
      this.firstManualInsertPanel = transition.selectedPanel;
      return new Promise((resolve) => {
        this.setStatex(
          { package: transition.state.package },
          () => {
            try {
              this.context.CanvasAPI.saveCanvas(transition.persistence);
            } catch (e) {}
            resolve(true);
          }
        );
      });
    }

    this.firstManualInsertPanel = null;
    return new Promise((resolve) => {
      this.setStatex(
        { package: transition.state.package },
        () => resolve(true)
      );
    });
  };

  applyPendingPanelHardware = () => {
    const transition = applyPendingDesignerPanelHardware(this.state);
    if (!transition.selectedPanel) return Promise.resolve(false);
    return new Promise((resolve) => {
      this.setStatex(
        { package: transition.state.package },
        () => resolve(true)
      );
    });
  };

  changeInverterHardware = (inverter, additional_inverters = []) => {
    const { package: installationPackage } = this.state;
    if (inverter) {
      const registeredInverterId =
        inverter.id !== undefined && inverter.id !== null
          ? String(inverter.id)
          : null;
      const selectedInverter = registeredInverterId
        ? inverter
        : buildEffectiveInlineHardwareSpec(
            installationPackage.inverter,
            inverter
          );
      if (!selectedInverter) return;

      const prevId = installationPackage?.inverter?.id || null;
      const nextId = selectedInverter?.id || null;
      if (prevId && nextId && String(prevId) === String(nextId)) {
        return;
      }
      const inverterChanged = Boolean(prevId && nextId && prevId !== nextId);
      const newQuantity = inverterChanged
        ? 1
        : installationPackage.inverterQuantity || 1;

      const isPrimaryMicro =
        selectedInverter?.type === 'M' || selectedInverter?.type === 'Micro';

      const rawAdditional = isPrimaryMicro
        ? []
        : Array.isArray(additional_inverters) && additional_inverters.length > 0
          ? additional_inverters
          : installationPackage.additional_inverters || [];

      const filteredAdditional = isPrimaryMicro
        ? []
        : (rawAdditional || []).filter((ai) => {
          if (!ai?.id) return true;
          const invObj = (this.state.inverters || []).find(
            (x) => x.id === ai.id
          );
          return matchesPrimaryInverterType(selectedInverter, invObj);
        });

      this.setStatex(
        {
          package: {
            ...installationPackage,
            inverter: selectedInverter,
            inverterQuantity: newQuantity,
            additional_inverters: filteredAdditional,
            selectedInverterSpec: registeredInverterId
              ? null
              : selectedInverter,
          },
          hasAutoCalculatedInverterQuantity: false, // Reset to auto mode when changing inverters
        },
        () => {
          // Persist the selected id/spec channel and its dependent settings together.
          this.context.CanvasAPI.saveCanvas({
            selected_inverter_id: registeredInverterId,
            selected_inverter_spec: registeredInverterId
              ? null
              : selectedInverter,
            inverter_quantity: newQuantity,
            additional_inverters: filteredAdditional,
          });
        }
      );
    }
  };

  changeInverterQuantity = (quantity) => {
    const transition = changeDesignerInverterQuantity(this.state, quantity);
    this.setStatex(
      {
        package: transition.state.package,
        hasAutoCalculatedInverterQuantity:
          transition.state.hasAutoCalculatedInverterQuantity,
        primaryInverterAutoQuantity:
          transition.state.primaryInverterAutoQuantity,
      },
      () => {
        this.context.CanvasAPI.saveCanvas(transition.persistence);
      }
    );
  };

  changeAdditionalInverters = (additionalInverters) => {
    const transition = changeDesignerAdditionalInverters(
      this.state,
      additionalInverters
    );
    this.setStatex(
      {
        package: transition.state.package,
        primaryInverterAutoQuantity:
          transition.state.primaryInverterAutoQuantity,
        hasAutoCalculatedInverterQuantity:
          transition.state.hasAutoCalculatedInverterQuantity,
      },
      () => {
        this.context.CanvasAPI.saveCanvas(transition.persistence);
      }
    );
  };

  calculateOptimalInverterQuantity = () => {
    return calculateDesignerOptimalInverterQuantity({
      inverter: this.state.package?.inverter,
      panel: this.state.package?.panel,
      panels: this.state.panels,
    });
  };

  updateInverterQuantityAfterPlacement = () => {
    const next = applyAutomaticInverterQuantity(this.state);
    if (next === this.state) return;
    this.setStatex({ package: next.package });
  };

  calculateInverterClipping = () => {
    const installationPackage = this.state.package || {};
    return calculateDesignerInverterClipping({
      inverter: installationPackage.inverter,
      inverterQuantity: installationPackage.inverterQuantity,
      additionalInverters: installationPackage.additional_inverters,
      panel: installationPackage.panel,
      panels: this.state.panels,
    });
  };

  updateInverterClippingAfterPlacement = () => {
    return this.calculateInverterClipping();
  };

  switchView = (viewMode) => {
    this.setState3x({ viewMode });
    this.canvas3DElement.setViewMode(viewMode);
    if (viewMode === '2D') this.setState({ scale: DESIGN_SCALE });
  };

  syncSelectedRoofFrom3D = () => {
    this.setState(
      (prevState) => syncSelectedRoofFrom3DTransition(prevState),
      () => {
        this.callbackDesignerIframe(
          { selectedRoof: this.state.selectedRoof },
          false
        );
      }
    );
  };

  syncSelectedRoofFrom2D = () => {
    this.setState((prevState) => syncSelectedRoofFrom2DTransition(prevState));
  };

  syncSelectedPanelFrom3D = () => {
    const patch = syncSelectedPanelFrom3DTransition(this.state);
    const panels = this.state.panels;
    if (Array.isArray(patch.panels) && Array.isArray(panels)) {
      patch.panels.forEach((nextPanel, index) => {
        if (!panels[index] || !nextPanel) return;
        if (panels[index].horizontal && nextPanel.horizontal) {
          panels[index].horizontal.selected = nextPanel.horizontal.selected;
        }
        if (panels[index].vertical && nextPanel.vertical) {
          panels[index].vertical.selected = nextPanel.vertical.selected;
        }
      });
      this.setState2x({
        panels,
        selectedPanels: patch.selectedPanels,
      });
      return;
    }
    this.setState2x(patch);
  };

  syncSelectedPanelFrom2D = () => {
    const patch = syncSelectedPanelFrom2DTransition(this.state);
    this.setState(patch);
  };

  addToSelectedObjects = (index, objectType, removeOld = false) => {
    const next = applyAddToSelection(this.state, index, objectType, {
      removeOld,
      currentAccordion: this.state.currentAccordion,
    });
    const selectedObjects = next.selectedObjects;

    if (objectType === 'panels') {
      this.setState2x({ selectedObjects }, () => {
        this.syncSelectedPanelFrom3D();
        if (
          this.state.onlySelectedPanels &&
          !this.state.productionIsRunning &&
          !this.suppressSolarProductionFromSelection
        ) {
          this.resetProductionForPanelLayoutChange();
        }
      });
      return;
    }

    const patch = { selectedObjects };
    if (
      next.selectedRoof !== undefined &&
      next.selectedRoof !== this.state.selectedRoof
    ) {
      patch.selectedRoof = next.selectedRoof;
    }
    this.setState(patch, () => {
      if (objectType === 'roofSegments') {
        this.callbackDesignerIframe(
          { selectedRoof: this.state.selectedRoof },
          false
        );
      }
    });
  };

  addToSelectedObjectsBulk = (indices, objectType, clearExisting = false) => {
    const items = Array.isArray(indices) ? indices : [indices];
    if (!items || items.length === 0) return;
    this.addToSelectedObjects(items, objectType, clearExisting);
  };

  removeFromSelectedObjects = (index, objectType) => {
    const next = applyRemoveFromSelection(this.state, index, objectType);
    const selectedObjects = next.selectedObjects;

    if (objectType === 'panels') {
      this.setState2x({ selectedObjects }, () => {
        this.syncSelectedPanelFrom3D();
        if (
          this.state.onlySelectedPanels &&
          !this.state.productionIsRunning &&
          !this.suppressSolarProductionFromSelection
        ) {
          this.resetProductionForPanelLayoutChange();
        }
      });
      return;
    }

    const patch = { selectedObjects };
    if (
      next.selectedRoof !== undefined &&
      next.selectedRoof !== this.state.selectedRoof
    ) {
      patch.selectedRoof = next.selectedRoof;
    }
    this.setState(patch, () => {
      if (objectType === 'roofSegments') {
        this.callbackDesignerIframe(
          { selectedRoof: this.state.selectedRoof },
          false
        );
      }
    });
  };

  clearSelection = (objectType, forceClear = false) => {
    const next = applyClearSelection(this.state, objectType, forceClear);
    if (objectType === 'panels') {
      this.setState2x({ selectedObjects: next.selectedObjects }, () => {
        this.syncSelectedPanelFrom3D();
      });
      return;
    }
    const patch = { selectedObjects: next.selectedObjects };
    if (
      objectType === 'roofSegments' &&
      next.selectedRoof !== undefined &&
      next.selectedRoof !== this.state.selectedRoof
    ) {
      patch.selectedRoof = next.selectedRoof;
    }
    this.setState(patch, () => {
      if (objectType === 'roofSegments') {
        this.callbackDesignerIframe(
          { selectedRoof: this.state.selectedRoof },
          false
        );
      }
    });
  };

  deleteSelectedObjects = (objectType) => {
    if (objectType !== 'roofSegments') return;
    const next = deleteSelectedRoofSegments(this.state);
    this.setState3x({ segments: next.segments });
  };

  setHeight = (value) => {
    const next = updateSelectedSegmentMeasurement(
      this.state,
      'height',
      value
    );
    this.setState3x({ segments: next.segments });
  };

  setPitch = (value) => {
    const next = updateSelectedSegmentMeasurement(this.state, 'pitch', value);
    this.setState3x({ segments: next.segments });
  };

  setSetback = (length, changeClockwise) => {
    const { segments, obstacles, selectedObjects, setback, setbackMode } =
      this.state;
    const newSegments = [...segments];
    const newObstacles = [...obstacles];
    let changeSegments = false;
    let changeObstacles = false;
    const segLen = newSegments.length;
    Object.keys(selectedObjects.fireSetbacks).forEach((pi) => {
      if (pi < segLen) {
        const len = newSegments[pi].geometry.length;
        if (!newSegments[pi].setbacks)
          newSegments[pi].setbacks = new Array(len).fill(setback);
        selectedObjects.fireSetbacks[pi].forEach((vi) => {
          if (changeClockwise[pi])
            newSegments[pi].setbacks[len - vi - 1] = parseFloat(length);
          else newSegments[pi].setbacks[vi] = parseFloat(length);
        });
        newSegments[pi].setbacks = [...newSegments[pi].setbacks];
        changeSegments = true;
      } else {
        newObstacles[pi - segLen].setback = parseFloat(length);
        changeObstacles = true;
      }
    });
    if (changeSegments) {
      this.setState3x({ segments: newSegments });
      this.context.CanvasAPI.saveCanvas({
        segments: newSegments,
        setback_mode: setbackMode === 0 ? 'G' : 'E',
      });
      // Use setTimeout to check after state update completes
      setTimeout(() => this.checkShadingRerunNeeded(), 0);
    }
    if (changeObstacles) {
      this.setState3x({ obstacles: newObstacles });
      this.context.CanvasAPI.saveCanvas({ obstacles: newObstacles });
      // Use setTimeout to check after state update completes
      setTimeout(() => this.checkShadingRerunNeeded(), 0);
    }
  };

  setShadingStatus = (status) => {
    this.setState2x(resolveShadingStatusPatch(status));
  };

  /**
   * Checks if shading needs to be re-run after design changes
   * If shading has run and we haven't shown the notice yet, shows a snackbar
   * and sets flags to disable proposal button
   */
  checkShadingRerunNeeded = (options = {}) => {
    const { displaySnack } = this.context;
    const transition = resolveShadingStaleTransition(this.state, options);
    if (!transition.shouldNotify || !displaySnack) return;

    if (transition.shouldClearPanels) {
      try {
        this.canvas3DElement?.clearPanels?.(false);
      } catch (e) {}
      this.setState({ panels: [] });
      this.resetProductionForPanelLayoutChange();
      try {
        this.context.CanvasAPI.saveCanvas({ panels: [] });
      } catch (e) {}
    }

    displaySnack({
      variant: 'warning',
      message: transition.message,
    });
    this.setState2x(transition.patch);
  };

  /**
   * Detects if shading analysis has been run by examining canvas data
   * Checks multiple indicators to determine if shading has been executed:
   * 1. 'color_range' being set with non-default values (indicates shading visualization)
   * 2. Segments having calculated shading values (not all default 1.0 values)
   * 
   * Note: The 'shaded' flag is not reliable and should not be used for detection
   * 
   * @param {Object} canvasData - The canvas data object from the API
   * @returns {boolean} - True if shading has been run, false otherwise
   */
  setShadingTexture = (texture, month) => {
    this.setState2x({
      showOverlay: true,
      shadingMonth: month,
      shadingTexture: texture,
    });
  };

  moveRoofVertex = (x, y) => {
    const next = moveSelectedRoofVertices(this.state, x, y);
    this.setState3x({ segments: next.segments });
    // Use setTimeout to check after state update completes
    setTimeout(() => this.checkShadingRerunNeeded(), 0);
  };

  setSegmentPosition = (vertices, roofAttributes) => {
    const { segments } = this.state;
    const newSegments = [...segments];
    const filteredMergedSegments = setSegmentAttributes(
      vertices,
      roofAttributes,
      newSegments
    );
    filteredMergedSegments.forEach((seg, segIndex) => {
      newSegments[segIndex].area = calculateLegacySegmentArea(
        newSegments[segIndex],
        samplingRate
      );
    });
    this.setState3x({ segments: filteredMergedSegments });
    // Use setTimeout to check after state update completes
    setTimeout(() => this.checkShadingRerunNeeded(), 0);
    setTimeout(() => {
      this.setState3x({
        optimizer1IsRunning: false,
        optimizer2IsRunning: false,
      });
    }, 500);
  };

  setSegmentParameters = (changedSegments) => {
    const { segments } = this.state;
    const newSegments = [...segments];
    newSegments.forEach((seg, segIndex) => {
      if (changedSegments[segIndex]) {
        newSegments[segIndex].pvwatts_update = true;
        newSegments[segIndex].pitch = Math.min(
          69.99,
          Number(changedSegments[segIndex].pitch).toFixed(2)
        );
        newSegments[segIndex].azimuth = Number(
          changedSegments[segIndex].azimuth
        ).toFixed(2);
        newSegments[segIndex].height = Number(
          changedSegments[segIndex].height
        ).toFixed(2);
        newSegments[segIndex].area = calculateLegacySegmentArea(
          newSegments[segIndex],
          samplingRate
        );
      }
    });
    // const filteredNewSegments = newSegments.filter((el) => (el.pitch < 69 && el.height > 2.5));
    this.setState3x({ segments: newSegments });
    // Use setTimeout to check after state update completes
    setTimeout(() => this.checkShadingRerunNeeded(), 0);
    setTimeout(() => {
      this.setState3x({
        measureIsRunning: false,
        optimizer1IsRunning: false,
        optimizer2IsRunning: false,
      });
    }, 500);
  };

  setPanelsOrientation = (changedSegments) => {
    const { segments } = this.state;
    segments.forEach((seg, segIndex) => {
      const orientation = Number(
        changedSegments[segIndex].panelOrientation || segments[segIndex].azimuth
      );
      if (seg?.panelOrientation !== orientation)
        seg.panelOrientation = orientation;
    });
  };

  changeEdgeTypes = (changedSegments) => {
    const next = transitionSegmentEdgeTypes(this.state, changedSegments);
    const newSegments = next.segments;
    this.skipNextSegmentsAutoSave = true;
    this.setStatex({ segments: newSegments }, () => {
      const savePromise = this.context?.CanvasAPI?.saveCanvas
        ? this.context.CanvasAPI.saveCanvas({ segments: newSegments })
        : Promise.resolve();
      savePromise.finally(() => {
        this.setState3x({ edgeDetectionIsRunning: false });
      });
    });
  };

  setPanelPlacement = (panels) => {
    if (this.panelPlacementUnmounted) return;
    const prevPanels = this.state.panels;
    const completion = this.panelPlacementCompletion;
    const placementPanelCount = countAddedPanels(
      panels,
      completion?.baselinePanelCount,
      completion?.targetSegmentIndices
    );
    const pendingPanel = this.maybeApplyPendingPanelForFirstPlacement(
      prevPanels,
      panels
    );
    const panelCommit = buildSelectedPanelCommit(
      this.state.package,
      pendingPanel
    );
    const packageUpdate = pendingPanel
      ? { package: panelCommit.package }
      : {};
    const segments = this.state.segments.map((seg) => ({ ...seg }));
    const productionResetState = this.resetProductionForLayoutChange();

    if (this.panelPlacementCallbackArmed) {
      const placementRequestId = this.panelPlacementCallbackRequestId;
      if (
        placementRequestId === null ||
        this.panelPlacementUnmounted ||
        this.panelPlacementRequestId !== placementRequestId
      ) {
        return;
      }
      this.saveState({ panels });
      this.setState({
        panels,
        segments,
        ...packageUpdate,
        ...productionResetState,
      });
      if (this.panelPlacementFinalizeTimer) {
        clearTimeout(this.panelPlacementFinalizeTimer);
      }
      const finalizeTimer = setTimeout(async () => {
        if (this.panelPlacementFinalizeTimer === finalizeTimer) {
          this.panelPlacementFinalizeTimer = null;
        }
        if (
          this.panelPlacementUnmounted ||
          this.panelPlacementRequestId !== placementRequestId
        ) {
          return;
        }
        this.panelPlacementCallbackArmed = false;
        this.panelPlacementCallbackRequestId = null;
        const actionId = completion?.actionId;
        const latestPanels = this.state.panels;
        const hardwarePersistence = pendingPanel
          ? panelCommit.persistence
          : buildSelectedPanelCommit(this.state.package).persistence;
        const persistence = this.queuePanelPlacementPersistence(() =>
          this.persistProductionReset(
            {
              panels: latestPanels,
              ...hardwarePersistence,
            },
            {
              strict: true,
              actionId,
            }
          )
        );
        try {
          const outcome = await persistPanelPlacement({
            actionId,
            panels: latestPanels,
            placementPanelCount,
            baselinePanelCount: completion?.baselinePanelCount,
            save: () => persistence
          });
          if (
            this.panelPlacementUnmounted ||
            this.panelPlacementRequestId !== placementRequestId
          ) {
            return;
          }
          this.setState3x({ panelPlacementIsRunning: false }, false);
          this.unlockPageScroll();
          console.info('[Fill Panels] persisted', outcome);
          try {
            this.context.displaySnack({
              variant:
                outcome.status === 'empty' || outcome.status === 'unchanged'
                  ? 'warning'
                  : 'success',
              message: panelPlacementOutcomeMessage(outcome)
            });
          } catch (e) {}
          const { callback: iframeCallback } = this.props;
          if (iframeCallback) iframeCallback('PanelPlacement', outcome);
          this.resolvePanelPlacementCompletion(
            null,
            placementRequestId,
            outcome
          );
        } catch (error) {
          if (typeof completion?.fail === 'function') {
            completion.fail(error);
          }
        }
      }, 500);
      this.panelPlacementFinalizeTimer = finalizeTimer;
      return;
    }

    this.setState3x({
      panels,
      segments,
      ...packageUpdate,
      ...productionResetState,
    });
    if (this.panelPlacementUpdateTimer) {
      clearTimeout(this.panelPlacementUpdateTimer);
    }
    const updateTimer = setTimeout(() => {
      if (this.panelPlacementUpdateTimer === updateTimer) {
        this.panelPlacementUpdateTimer = null;
      }
      if (this.panelPlacementUnmounted) return;
      this.setState3x(
        { panelPlacementIsRunning: false, ...productionResetState },
        false
      );
      const latestPanels = this.state.panels;
      const hardwarePersistence = pendingPanel
        ? panelCommit.persistence
        : buildSelectedPanelCommit(this.state.package).persistence;
      this.queuePanelPlacementPersistence(() =>
        this.persistProductionReset({
          panels: latestPanels,
          ...hardwarePersistence,
        })
      ).catch(() => {});
      this.unlockPageScroll();
    }, 500);
    this.panelPlacementUpdateTimer = updateTimer;
    const { callback: iframeCallback } = this.props;
    if (iframeCallback) iframeCallback('PanelPlacement', '');
  };

  handleObstacleRadius = (oi, v) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.PATCH_OBSTACLE,
        index: oi,
        patch: { radius: parseFloat(v) },
      },
      { strategy: 'state3x' }
    );
  };

  handleObstacleHeight = (oi, v) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.PATCH_OBSTACLE,
        index: oi,
        patch: { height: parseFloat(v) },
      },
      { strategy: 'state3x' }
    );
  };

  handleObstacleSetback = (oi, v) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.PATCH_OBSTACLE,
        index: oi,
        patch: { setback: parseFloat(v) },
      },
      { strategy: 'state3x' }
    );
  };

  handleObstacleOrientation = (oi, v) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.PATCH_OBSTACLE,
        index: oi,
        patch: { orientation: v, height: 1 },
      },
      { strategy: 'state3x' }
    );
  };

  setSegmentShadingFactors = (factors) => {
    const next = applySegmentShadingFactors(this.state, factors);
    this.setState3x({
      segments: next.segments,
      shadingHasRun: next.shadingHasRun,
      shadingNeedsRerun: next.shadingNeedsRerun,
      shadingRerunNoticeShown: next.shadingRerunNoticeShown,
    });
  };

  setSegmentShadingFactorsServerSide = (segmentsShadingFactors) => {
    const next = applyServerSideSegmentShadingFactors(
      this.state,
      segmentsShadingFactors
    );
    if (next === this.state) return;
    this.setState3x({
      segments: next.segments,
      shadingHasRun: next.shadingHasRun,
      shadingNeedsRerun: next.shadingNeedsRerun,
      shadingRerunNoticeShown: next.shadingRerunNoticeShown,
    });
    this.context.CanvasAPI.saveCanvas({ segments: next.segments }).catch(() => {});
  };

  setOptPitchAndAzimuth = (pitch, azimuth) => {
    const { updateLead } = this.context;
    const optPitchAndAzimuth = { pitch, azimuth };
    updateLead({ property: { optimal_roof: optPitchAndAzimuth } }, true);
  };

  setDSMParams = (DSMParams) => {
    const { CanvasAPI } = this.context;
    const nextDSMParams = resolveDesignerDsmParams(
      this.state.dsmParams,
      DSMParams
    );
    this.setState2x({ dsmParams: nextDSMParams });
    if (CanvasAPI?.saveCanvas) CanvasAPI.saveCanvas({ dsmParams: nextDSMParams });
  };

  goFullScreen = (e) => {
    this.setState({ isFullScreen: e });
  };

  capture_image = async () => {
    const image_data = await this.canvas3DElement.exportToJPG();
    return image_data;
  };

  newAnnotation = (position, type, params = {}) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.ADD_ANNOTATION,
        position,
        annotationType: type,
        params,
      },
      { strategy: 'state3x', persistCanvas: true, checkShading: false }
    );
  };

  setAnnotations = (annotations) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.SET_ANNOTATIONS,
        annotations,
      },
      { strategy: 'state3x', persistCanvas: true, checkShading: false }
    );
  };

  removeAnnotation = (index) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.REMOVE_ANNOTATION,
        key: index,
      },
      { strategy: 'state3x', persistCanvas: true, checkShading: false }
    );
  };

  handleCanvasData = (data) => {
    return this.applySharedDesignerCommand(
      {
        type: DesignerCommandTypes.IMPORT_CANVAS_DATA,
        data,
      },
      { strategy: 'state3x', checkShading: false }
    );
  };

  translateCanvas = async (
    offsetX,
    offsetY,
    flipX,
    flipY,
    translateRoofs,
    translateObstacles,
    translateTrees
  ) => {
    const { CanvasAPI } = this.context;
    const next = translateDesignerGeometry(this.state, {
      offsetX,
      offsetY,
      flipX,
      flipY,
      translateRoofs,
      translateObstacles,
      translateTrees,
      canvasSize: this.state.canvasSize || DEFAULT_CANVAS_SIZE,
    });
    this.setState3x(next);
    CanvasAPI.saveCanvas(next);
  };

  getUIState = () => {
    const {
      currentAccordion,
      tool,
      designType,
      buffer,
      rowSpacing,
      panelTilt,
      azimuthRestriction,
      setbackMode,
      fireSetbacks,
      mode,
      moveMode,
      selectedLabel,
      automaticAzimuth,
      pitch_in_degrees,
      viewMode,
      selectionMode,
      coordinates,
      optPitchAndAzimuth,
      segments,
      obstacles,
      trees,
      panels,
      annotations,
      losses,
      measureIsRunning,
      optimizer1IsRunning,
      optimizer2IsRunning,
      edgeDetectionIsRunning,
      AIIsRunning,
      panelPlacementIsRunning,
      panelPlacementFillMode,
      panelPlacementLayoutMode,
      panelPlacementOnlySelectedRoof,
      shadingMonth,
      shadingStatus,
      shadingIsRunning,
      serverSideShadingIsRunning,
      solarPanels,
      colorRange,
      roofAreasSqFt,
      roofAreasUnit,
      primaryInverterAutoQuantity,
      hasAutoCalculatedInverterQuantity,
      weatherDatasetSelected,
      weatherDatasetFetchedPath,
      resolution,
      selectedRoof,
      selectedPanels,
    } = this.state;

    const selectedImagery = this.selectedCanvasImagery();
    const hasRGB = Boolean(selectedImagery.rgb);
    const hasDSM = Boolean(selectedImagery.dsm);

    const data = {
      currentAccordion,
      tool,
      designType,
      buffer,
      rowSpacing,
      panelTilt,
      azimuthRestriction,
      setbackMode,
      fireSetbacks,
      mode,
      moveMode,
      selectedLabel,
      automaticAzimuth,
      hasRGB,
      hasDSM,
      pitchInDegrees: pitch_in_degrees ?? true,
      viewMode,
      selectionMode,
      coordinates,
      optPitchAndAzimuth,
      segments,
      obstacles,
      trees,
      panels,
      annotations,
      losses,
      package: this.state.package,
      measureIsRunning,
      optimizer1IsRunning,
      edgeDetectionIsRunning,
      AIIsRunning,
      panelPlacementIsRunning,
      panelPlacementFillMode,
      panelPlacementLayoutMode,
      panelPlacementOnlySelectedRoof,
      shadingMonth,
      shadingStatus,
      shadingIsRunning,
      serverSideShadingIsRunning,
      solarPanels,
      colorRange,
      roofAreasSqFt,
      roofAreasUnit,
      primaryInverterAutoQuantity,
      hasAutoCalculatedInverterQuantity,
      weatherDatasetSelected,
      weatherDatasetFetchedPath,
      resolution,
      selectedRoof,
      selectedPanels,
    };

    return data;
  };

  setStatex = (data, callback, stateNames) => {
    const isFunc = data instanceof Function;
    if (isFunc) this.saveState(data, stateNames, true);
    else this.saveState(data);

    if (!callback) this.setState(data);
    else this.setState(data, callback);

    if (isFunc && stateNames) {
      setTimeout(() => {
        const stateValues = Object.assign(
          {},
          ...stateNames.map((x) => ({ [x]: this.state[x] }))
        );
        this.callbackDesignerIframe(stateValues);
        this.saveState(stateValues, stateNames, false, true);
      }, 500);
    } else if (typeof data === 'object') {
      this.callbackDesignerIframe(data);
    }
  };

  setState2x = (data, callback) => {
    this.saveState(data);
    this.setState(data, callback);
    this.callbackDesignerIframe(data);
  };

  setState3x = (data, saveState = true) => {
    if (saveState) this.saveState(data);
    this.setState(data);
    this.callbackDesignerIframe(data, false);
  };

  callbackDesignerIframe = (data, check = true) => {
    const { iframe, designFrame, callback: iframeCallback } = this.props;
    if (iframe && designFrame && iframeCallback) {
      const resolvedAzimuthRestriction =
        data?.azimuthRestriction ?? this.state.azimuthRestriction;
      if (!check) {
        const payload =
          resolvedAzimuthRestriction === undefined
            ? data
            : { ...data, azimuthRestriction: resolvedAzimuthRestriction };
        iframeCallback('State', payload);
      } else {
        const {
          tool,
          designType,
          segments,
          obstacles,
          trees,
          panels,
          annotations,
          solarPanels,
          buffer,
          rowSpacing,
          panelTilt,
          azimuthRestriction,
          automaticAzimuth,
          setbackMode,
          fireSetbacks,
          mode,
          selectedLabel,
          moveMode,
          currentAccordion,
          viewMode,
          selectionMode,
          coordinates,
          optPitchAndAzimuth,
          pitchUnit,
          shadingMonth,
          shadingStatus,
          package: package_,
          selectedRoof,
          weatherDatasetSelected,
          weatherDatasetFetchedPath,
        } = data;

        const filteredData = {
          tool,
          designType,
          segments,
          obstacles,
          trees,
          panels,
          annotations,
          // solarPanels,
          buffer,
          rowSpacing,
          panelTilt,
          azimuthRestriction:
            azimuthRestriction === undefined
              ? resolvedAzimuthRestriction
              : azimuthRestriction,
          automaticAzimuth,
          setbackMode,
          fireSetbacks,
          mode,
          selectedLabel,
          moveMode,
          currentAccordion,
          viewMode,
          selectionMode,
          coordinates,
          optPitchAndAzimuth,
          pitchUnit,
          shadingMonth,
          shadingStatus,
          package: package_,
          selectedRoof,
          weatherDatasetSelected,
          weatherDatasetFetchedPath,
        };

        Object.keys(filteredData).forEach((key) =>
          filteredData[key] === undefined ? delete filteredData[key] : {}
        );
        if (filteredData) iframeCallback('State', filteredData);
      }
    }
  };

  setHistoryEnabled = (enabled) => {
    const commandResult = runDesignerHistoryCommand(
      this.state,
      this.histories,
      this.historyState,
      {
        type: DesignerHistoryCommandTypes.SET_ENABLED,
        enabled,
      }
    );
    this.historyState = commandResult.historyState;
  };

  undo = () => {
    return this.applySharedHistoryCommand(DesignerHistoryCommandTypes.UNDO);
  };

  redo = () => {
    return this.applySharedHistoryCommand(DesignerHistoryCommandTypes.REDO);
  };

  applySharedHistoryCommand = (type) => {
    const commandResult = runDesignerHistoryCommand(
      this.state,
      this.histories,
      this.historyState,
      { type }
    );
    this.histories = commandResult.histories;
    this.historyState = commandResult.historyState;
    if (!commandResult.snapshot) return commandResult;
    const patch = {};
    Object.keys(commandResult.state).forEach((key) => {
      if (commandResult.state[key] !== this.state[key]) {
        patch[key] = commandResult.state[key];
      }
    });
    this.setState3x(patch, false);
    return commandResult;
  };

  saveState = (data, keys = null, onlySaveOld = false, updateOld = false) => {
    if (!(this.canvas3DElement && this.canvas3DElement.isLoaded)) return;
    const targetKeys = keys || Object.keys(data);
    let previousHistoryItem = {};
    let historyItem = {};

    if (onlySaveOld) {
      targetKeys.forEach((key) => {
        if (!HISTORY_KEYS.includes(key)) return;
        const oldValue =
          typeof this.state[key] === 'string'
            ? this.state[key]
            : JSON.stringify(this.state[key]);
        if (oldValue === undefined) return;
        previousHistoryItem[key] = oldValue;
      });
    } else if (updateOld) {
      targetKeys.forEach((key) => {
        if (!HISTORY_KEYS.includes(key)) return;
        const newValue =
          typeof data[key] === 'string' ? data[key] : JSON.stringify(data[key]);
        if (newValue === undefined) return;
        historyItem[key] = newValue;
      });
    } else {
      const snapshot = buildHistorySnapshot(this.state, data, targetKeys);
      previousHistoryItem = snapshot.previousHistoryItem;
      historyItem = snapshot.historyItem;
    }

    const next = pushHistory(this.histories, this.historyState, {
      previousHistoryItem,
      historyItem,
      keys: targetKeys,
    });
    this.histories = next.histories;
    this.historyState = next.historyState;
  };

  checkIsLoaded = () => {
    return this.canvas3DElement.isLoaded;
  };

  checkIsShadingRunning = () => {
    return this.state.shadingIsRunning;
  };

  checkIsPVWattsHandled = () => {
    return this.state.pvwattsHandled;
  };

  setPanelPlacementFillMode = (fillMode) => {
    this.setState3x({ panelPlacementFillMode: fillMode });
    try {
      if (this.context.CanvasAPI?.saveCanvas) this.context.CanvasAPI.saveCanvas({ panelPlacementFillMode: fillMode });
    } catch (e) {}
  };

  setPanelPlacementLayoutMode = (layoutMode) => {
    this.setState3x({ panelPlacementLayoutMode: layoutMode });
    try {
      if (this.context.CanvasAPI?.saveCanvas) this.context.CanvasAPI.saveCanvas({ panelPlacementLayoutMode: layoutMode });
    } catch (e) {}
  };

  setPanelPlacementOnlySelectedRoof = (onlySelectedRoof) => {
    const nextState = toggleSelectedRoofPlacement(this.state, onlySelectedRoof);
    this.setState3x({
      panelPlacementOnlySelectedRoof: nextState.panelPlacementOnlySelectedRoof,
      ...(onlySelectedRoof
        ? { mode: nextState.mode, selectionMode: nextState.selectionMode }
        : {
            selectedRoof: nextState.selectedRoof,
            selectedObjects: nextState.selectedObjects,
          }),
    });
    try {
      if (this.context.CanvasAPI?.saveCanvas) this.context.CanvasAPI.saveCanvas({ panelPlacementOnlySelectedRoof: onlySelectedRoof });
    } catch (e) {}
  };

  placeGroundMount = (gridOption, segmentOption, panelOptions) => {
    const segment = buildGroundMountSegment(
      gridOption,
      segmentOption,
      panelOptions,
      this.state.resolution
    );
    this.handleNewSegment(segment);
  };

  setUseGoogleDSMForTreeAI = (value) => {
    this.setState3x({ useGoogleDSMForTreeAI: Boolean(value) });
  };

  render() {
    if (this.state.designerLoadError) {
      return (
        <Alert variant="danger" role="alert" className="m-3">
          {this.state.designerLoadError}
          <Button className="ml-3" onClick={this.loadDesignerData} disabled={this.state.designerIsLoading}>
            Retry
          </Button>
        </Alert>
      );
    }

    const {
      iframe,
      designFrame,
      companyName,
      callback: iframeCallback,
      context: iframeContext = {},
    } = this.props;

    const { panelNotSet } = this.state;
    if (panelNotSet) return <></>;

    // if (Object.keys(this.state.package).length === 0) {
    //   return !iframe ? (
    //     <Alert variant="warning">
    //       <Alert.Heading>No Installation Package Was Found</Alert.Heading>
    //       <p>
    //         It looks like you tried to create a design without having configured an
    //         installation package in your settings.
    //         <br />
    //         It will only take a minute, you&apos;re almost there!
    //       </p>
    //     </Alert>
    //   ) : <p>No Installation Package Was Found</p>;
    // }

    const {
      lead: { property },
      validUtility,
      uid,
    } = this.context;
    if (!property?.coordinates && !iframe) {
      // && property?.effectiveRate === undefined
      // && property?.fixedCharge === undefined)) {
      return (
        <Alert className="w-75 m-5" variant="info">
          <InfoCircle size={20} className="mr-2" />
          Property Details, and Utility Details must be filled out before
          creating a design.
        </Alert>
      );
    }

    const selectedImagery = this.selectedCanvasImagery();
    const hasRGB = Boolean(selectedImagery.rgb);
    const hasDSM = Boolean(selectedImagery.dsm);

    const {
      isFullScreen,
      overlay,
      showOverlay,
      scale,
      resolution,
      currentAccordion: accordion,
      tool,
      segments,
      obstacles,
      trees,
      panels,
      annotations,
      buffered,
      selectedRoof,
      selectedLabel,
      selectedPanels,
      shade,
      buffer,
      rowSpacing,
      panelTilt,
      azimuthRestriction,
      fireSetbacks,
      mode,
      moveMode,
      setbackMode,
      polyEdit,
      focusedPolygonToEdit,
      colorRange,
      designType,
      package: installationPackage,
      shadingMonth,
      shadingStatus,
      viewMode,
      coordinates,
      setback,
      selectionMode,
      selectedObjects,
      shadingTexture,
      shadingIsRunning,
      serverSideShadingIsRunning,
      optimizer1IsRunning,
      optimizer2IsRunning,
      edgeDetectionIsRunning,
      rectificationIsRunning,
      measureIsRunning,
      panelPlacementIsRunning,
      AIIsRunning,
      treeAIIsRunning,
      solarPanels,
      inverters,
      automaticAzimuth,
      updateRGBTextureIsRunning,
      panelPlacementFillMode,
      panelPlacementLayoutMode,
      panelPlacementOnlySelectedRoof,
      hasAutoCalculatedInverterQuantity,
      // Production state
      productionIsRunning,
      productionHandled,
      totalAnnualKwh,
      totalMonthlyKwh,
      totalClippingKwh,
      totalMonthlyClippingKwh,
      dcAcRatio,
      stringingData,
      invertersUsed,
      productionPerPanel,
      selectedPanelCount,
      productionHardware,
      // Target production state
      useTargetProduction,
      targetProductionKwh,
      // Auto quantity state
      primaryInverterAutoQuantity,
      packageAdditionalInverters,

      designs,
      isLoadingDesigns,
      isCloningDesign,
      droneModal,
      cloneDialogOpen,
      cloneName,
      cloneTarget,
      archiveSiblingsOpen,
      archiveSiblings,
    } = this.state;

    // Destructure hardware from installation package
    const {
      panel: panelHardware,
      inverter: inverterHardware,
      additional_inverters: additionalInvertersHardware = [],
    } = installationPackage || {};

    // value that is passed to context indicating id client's device is running iOS
    const isIos = ios();

    const fullAddress = `${property.street}, ${property.city}, ${property.state}`;
    const showDesignSwitcher = !iframe;
    const activeDesignId = this.getActiveDesignId();
    const activeCanvasId = this.getActiveCanvasId();
    const designOptions = Array.isArray(designs) ? designs : [];
    const designTree = shapeCanvasDesignTree(
      designOptions,
      'all-active-designs'
    );
    const activeScopeNode = designTree.find(
      (node) => String(node.canvasId) === String(activeCanvasId)
    );
    const activeScopeChild = (activeScopeNode?.children || []).find(
      (child) => String(child.designId) === String(activeDesignId)
    );
    const activeScopeLabel = activeScopeChild?.label
      ? `${activeScopeChild.label}`
      : (activeScopeNode?.label || activeDesignId || activeCanvasId || 'Select design');
    const saveNeeded = isDirtyStatus(this.state.dirtyStatus);
    const activeCanvasRow = designOptions.find(
      (item) => String(item?.id || item?.pk || '') === String(activeCanvasId)
    );
    const activeDesignRow = (activeCanvasRow?.designs || []).find(
      (row) => String(row?.id || '') === String(activeDesignId)
    );
    const activeDesignName = String(activeDesignRow?.name || '').trim();
    const hasActiveCanvasDesign = ((activeCanvasRow?.designs) || []).some(
      (row) => !row?.archived_at
    );
    const activeDesign =
      designOptions.find((d) => String(d?.id) === String(activeCanvasId)) ||
      designOptions[0];
    const hasGoogleDSMDesign = designOptions.some(
      (d) => d?.image_source === 'google'
    );
    const canUseGoogleDSMForTreeAI =
      hasGoogleDSMDesign &&
      ['nearmap', 'nearmap_rgb_only'].includes(activeDesign?.image_source);
    const canvasData = canvasKeys.includes(accordion)
      ? this.state[accordion]
      : [];
    const ISODate = new Date().toISOString();
    const overlaySrc = `${overlay}?iso=${ISODate}`;
    const size = (this.state.canvasSize || DEFAULT_CANVAS_SIZE) * scale;

    const show2D = viewMode === '2D';
    const showPlacePanels = konvaKeys.includes(accordion);
    this.lastRenderedPlacedPanelCount = countPlacedDesignerPanels(panels);
    const currentPanel = installationPackage?.pendingPanel || panelHardware;
    const appliedPanel = panelHardware;
    // Keep these actions clickable even if CanvasAPI is attached after the
    // first render; each handler handles missing save support independently.
    const bottomControlsDisabled = false;

    const providerValues = createDesignerCanvasContextValue({
      state: this.state,
      runtime: {
        property,
        panelType: currentPanel,
        iframe,
        designFrame,
        ios: isIos,
      },
      commands: this.designerCanvasCommands,
    });

    const viewerHeight = !iframe
      ? (this.state.canvasSize || DEFAULT_CANVAS_SIZE) * DESIGN_SCALE + 2
      : '100%';

    const handlers = isIos
      ? {
        onPointerDown: this.handleMouseDown,
        onPointerMove: this.handleMouseMove,
        onPointerUp: this.handleMouseUp,
        onPointerEnter: this.handleMouseEnter,
        onPointerLeave: this.handleMouseLeave,
      }
      : {
        onMouseDown: this.handleMouseDown,
        onMouseMove: this.handleMouseMove,
        onMouseUp: this.handleMouseUp,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
      };

    // TODO: Remove after migrating old data from /media to /imagery
    function parsePropertyDataURL(property, type) {
      try {
        if (!property) return null;
        const imagery = property[type];
        if (imagery && imagery.startsWith('pd_')) {
          if (type == 'rgb') {
            return `${process.env.REACT_APP_PROPERTY_DATA_RGB_PUBLIC_URL}/${imagery}/rgb.tiff`;
          } else if (type == 'dsm') {
            return `${process.env.REACT_APP_PROPERTY_DATA_DSM_PUBLIC_URL}/${imagery}/dsm.tiff`;
          }
        } else {
          if (typeof imagery !== 'string' || !imagery) return null;
          return mediaUrl(imagery);
        }
      } catch (error) {
        console.log('Error parsing property imagery', error);
        return null;
      }
    }

    const hasCanvasRgb = Object.prototype.hasOwnProperty.call(
      this.state,
      'rgb'
    );
    const hasCanvasDsm = Object.prototype.hasOwnProperty.call(
      this.state,
      'dsm'
    );
    const activeDsm = hasCanvasDsm ? this.state.dsm : property.dsm;
    const effectiveProperty = property
      ? {
          rgb: hasCanvasRgb ? this.state.rgb : property.rgb,
          dsm: activeDsm,
        }
      : null;
    let rgbImage = undefined;
    let dsmImage = undefined;
    if (effectiveProperty) {
      rgbImage = parsePropertyDataURL(effectiveProperty, 'rgb');
      dsmImage = parsePropertyDataURL(effectiveProperty, 'dsm');
    }

    const viewer = (
      <div
        aria-hidden="true"
        ref={(e) => {
          this.container = e;
        }}
        className="mw-100 position-relative rounded border border-primary overflow-auto"
        onWheel={this.handleMouseWheel}
        {...handlers}
        style={{
          maxHeight: viewerHeight,
          height: viewerHeight,
        }}
      >
        <Canvas3D
          key={`canvas3d-${activeDesignId}-${this.state.imageryCacheKey || ''}`}
          ref={(canvas3D) => {
            this.canvas3DElement = canvas3D;
          }}
          visible
          imgSrc={rgbImage}
          dsmSrc={dsmImage}
          segments={segments}
          obstacles={obstacles}
          trees={trees}
          panels={panels}
          annotations={annotations || []}
          size={size}
          iframeCallback={iframeCallback}
          initViewMode={'2D'}
          // Stringing overlay (only when Production accordion is open)
          stringingData={this.state.stringingData || []}
          showStringing={Boolean(
            this.state.currentAccordion === 'production' &&
            Array.isArray(this.state.stringingData) &&
            this.state.stringingData.length > 0
          )}
          forceShowStringing={false}
          stringingPanelIndexMode={this.state.stringingPanelIndexMode || 'all'}
          stringingSelectedPanelIndexMap={
            this.state.stringingSelectedPanelIndexMap || null
          }
          // LeadContext props
          lead={this.context.lead}
          designId={activeDesignId}
          canvasId={activeCanvasId}
          user={this.context.user}
          displaySnack={this.context.displaySnack}
          saveShadingsAPI={this.context.saveShadingsAPI}
          runShadingsAPI={this.context.runShadingsAPI}
          runShadingRequiredClientDataAPI={
            this.context.runShadingRequiredClientDataAPI
          }
          weatherDataset={this.state.weatherDatasetSelected || 'nsrdb_goes_v4_2024'}
          exportDesignAPI={this.context.exportDesignAPI}
          proposalShadings={this.state.shading_images || null}
          shadingHasRun={Boolean(this.state.shadingHasRun)}
          allowLeadShadingFallback={true}
        />
        {iframe &&
          companyName !== 'Astrawatt' &&
          companyName !== 'demand-iq' && <IFrameLogo />}
      </div>
    );

    if (iframe) {
      return (
        <DesignContext.Provider value={providerValues}>
          <Fullscreen
            isEnter={isFullScreen}
            onChange={(e) => this.setState({ isFullScreen: e })}
          >
            {viewer}
          </Fullscreen>
        </DesignContext.Provider>
      );
    }

    if (iframe && designFrame) {
      //
      return (
        <DesignContext.Provider value={providerValues}>
          <Row className="bg-light py-3 full-screenable-node font-vh g-0">
            <Col lg={8} md={12} s={12} xs={12} className="mb-5">
              <Controls
                mode={mode}
                moveMode={moveMode}
                setMode={this.handleMode}
                setMoveMode={this.designerCanvasCommands.setMoveMode}
                resetScale={this.handleResetScale}
                scaleUp={this.handleScaleUp}
                scaleDown={this.handleScaleDown}
                mapsLink={this.mapsLink}
                viewMode={konvaKeys.includes(accordion) ? '3D' : viewMode}
                switchView={this.switchView}
              />
              {/* <Fullscreen isEnter={isFullScreen} onChange={(e) => this.setStatex({ isFullScreen: e })}> */}
              <div className="mh-100" style={{ height: 600 }}>
                {viewer}
              </div>
              {/* </Fullscreen> */}
              {/* <ControlsBottom
                saveCanvas={this.handleSaveAll}
                cleanCanvas={this.cleanCanvas}
                disabled={!accordion || konvaKeys.includes(accordion)}
              /> */}
            </Col>
            <Col lg={4} md={12} s={12} xs={12} className="mt-5 mw-100">
              <Menu
                activeKey={accordion}
                designType={designType}
                hasRGB={hasRGB}
                hasDSM={hasDSM}
                shaded={shade}
                buffer={buffer}
                rowSpacing={rowSpacing}
                panelTilt={panelTilt}
                azimuthRestriction={azimuthRestriction}
                fireSetbacks={fireSetbacks}
                setbackMode={setbackMode}
                shadingIsRunning={shadingIsRunning}
                serverSideShadingIsRunning={serverSideShadingIsRunning}
                setbackModeHandler={this.handleSetbackMode}
                fireSetbackHandler={this.handleFireSetbacks}
                colorRange={colorRange}
                currentAccordionHandler={this.handleCurrentAccordion}
                currentTabHandler={this.handleSegmentTabs}
                tool={tool}
                toolHandler={this.handleTool}
                selectedLabel={selectedLabel}
                selectedRoof={selectedRoof}
                selectedPanels={selectedPanels}
                selectedLabelHandler={this.handleSelectedLabel}
                clearLabelsHandler={this.clearLabelsHandler}
                deleteShapeHandler={this.handleDeleteShape}
                addPointToPolygonHandler={this.handleAddPointToPolygonFromMenu}
                removePointFromPolygonHandler={
                  this.handleRemovePointFromPolygonFromMenu
                }
                obstacleHeightHandler={this.handleObstacleHeight}
                obstacleRadiusHandler={this.handleObstacleRadius}
                obstacleSetbackHandler={this.handleObstacleSetback}
                obstacleOrientationHandler={this.handleObstacleOrientation}
                newPanelHandler={this.handleNewPanel}
                deletePanelHandler={this.handleDeletePanel}
                rotatePanelHandler={this.handleRotatePanel}
                setPVwattsLosses={this.setPVwattsLosses}
                losses={this.state.losses}
                segments={segments}
                resolution={resolution}
                segmentAzimuthHandler={this.handleSegmentAzimuth}
                segmentPitchAndAreaHandler={this.handleSegmentPitchAndArea}
                segmentEaveHeightHandler={this.handleSegmentEaveHeight}
                treeUpdateHandler={this.handleTreeUpdate}
                treeDeleteAllHandler={this.handleDeleteAllTrees}
                pitchInDegrees={this.state.pitch_in_degrees ?? true}
                onPitchInDegreesChange={this.handlePitchInDegreesChange}
                obstacles={obstacles}
                trees={trees}
                panels={panels}
                panelPlacementIsRunning={panelPlacementIsRunning}
                placementHandler={this.handlePlacement}
                shadingHandler={this.handleShading}
                weatherDataset={this.state.weatherDatasetSelected}
                setWeatherDataset={this.setWeatherDatasetSelected}
                weatherDatasetFetchedPath={this.state.weatherDatasetFetchedPath}
                weatherDatasetReady={(() => {
                  const p = this.state.weatherDatasetFetchedPath;
                  const sel = this.state.weatherDatasetSelected;
                  if (!p || !sel) return false;
                  const base = (String(p).split('/').pop() || '').trim();
                  const expectedFilename = `${sel}.csv`;
                  return base === expectedFilename;
                })()}
                onWeatherDatasetFetched={this.handleWeatherDatasetFetched}
                measureHandler={this.handleMeasure}
                runOptimizationHandler={this.runOptimizationHandler}
                runEdgeDetectionHandler={this.runEdgeDetectionHandler}
                runRectificationHandler={this.runRectificationHandler}
                runAIHandler={this.runAIHandler}
                canSelectDifferentImage={
                  activeDesign?.image_source === 'nearmap'
                }
                runTreeAIHandler={this.runTreeAIHandler}
                canUseGoogleDSMForTreeAI={canUseGoogleDSMForTreeAI}
                useGoogleDSMForTreeAI={this.state.useGoogleDSMForTreeAI}
                onUseGoogleDSMForTreeAIChange={this.setUseGoogleDSMForTreeAI}
                runObstacleTune={this.runObstacleTune}
                reloadCanvasObstacles={this.reloadCanvasObstacles}
                runTreeTune={this.runTreeTune}
                onDroneAppHandler={this.openDroneApp}
                proposalHandler={this.handleProposal}
                isCreatingProposal={this.state.isCreatingProposal}
                shadingNeedsRerun={this.state.shadingNeedsRerun}
                shadingHasRun={this.state.shadingHasRun}
                hasActiveCanvasDesign={hasActiveCanvasDesign}
                panelAzimuthHandler={this.handlePanelAzimuth}
                currentPanel={currentPanel}
                appliedPanel={appliedPanel}
                currentInverter={inverterHardware}
                currentInverterQuantity={
                  installationPackage?.inverterQuantity || 1
                }
                hasAutoCalculatedInverterQuantity={
                  hasAutoCalculatedInverterQuantity
                }
                currentAdditionalInverters={additionalInvertersHardware}
                packageAdditionalInverters={packageAdditionalInverters}
                changePanelHardware={this.changePanelHardware}
                changeInverterHardware={this.changeInverterHardware}
                changeInverterQuantity={this.changeInverterQuantity}
                changeAdditionalInverters={this.changeAdditionalInverters}
                bufferHandler={this.handleBuffer}
                rowSpacingHandler={this.handleRowSpacing}
                panelTiltHandler={this.handlePanelTilt}
                azimuthRestrictionHandler={this.handleAzimuthRestriction}
                showOverlay={showOverlay}
                toggleOverlay={this.toggleOverlay}
                shadingMonth={shadingMonth}
                shadingStatus={shadingStatus}
                roofAreasSqFt={this.state.roofAreasSqFt}
                roofAreasUnit={this.state.roofAreasUnit}
                solarPanels={solarPanels}
                inverters={inverters}
                panelPlacementFillMode={panelPlacementFillMode}
                setPanelPlacementFillMode={this.setPanelPlacementFillMode}
                panelPlacementLayoutMode={panelPlacementLayoutMode}
                setPanelPlacementLayoutMode={this.setPanelPlacementLayoutMode}
                panelPlacementOnlySelectedRoof={panelPlacementOnlySelectedRoof}
                setPanelPlacementOnlySelectedRoof={
                  this.setPanelPlacementOnlySelectedRoof
                }
                clearPanels={this.clearPanels}
                // Production props
                productionIsRunning={productionIsRunning}
                productionHandled={productionHandled}
                totalAnnualKwh={totalAnnualKwh}
                totalClippingKwh={totalClippingKwh}
                dcAcRatio={dcAcRatio}
                stringingData={stringingData}
                invertersUsed={invertersUsed}
                productionPerPanel={productionPerPanel}
                selectedPanelCount={selectedPanelCount}
                productionHardware={productionHardware}
                systemSizeKw={this.state.systemSizeKw}
                mpptCountTotal={this.state.mpptCountTotal}
                handleSolarProduction={this.handleSolarProduction}
                // Target production props
                useTargetProduction={useTargetProduction}
                targetProductionKwh={targetProductionKwh}
                maxDcAcRatio={this.state.maxDcAcRatio}
                onMaxDcAcRatioChange={(value) => {
                  const next =
                    value === null || value === undefined || Number.isNaN(value)
                      ? 1.5
                      : value;
                  this.setState({ maxDcAcRatio: next });
                  this.context.CanvasAPI.saveCanvas({
                    max_dc_ac_ratio: next,
                  });
                }}
                onlySelectedPanels={this.state.onlySelectedPanels}
                onOnlySelectedPanelsChange={(value) => {
                  this.setState({ onlySelectedPanels: value });
                  this.context.CanvasAPI.saveCanvas({
                    only_selected_panels: value,
                  });
                }}
                onUseTargetProductionChange={(value) => {
                  const nextTarget = value ? this.state.targetProductionKwh : 0;
                  this.setState({
                    useTargetProduction: value,
                    targetProductionKwh: nextTarget,
                  });
                  this.context.CanvasAPI.saveCanvas({
                    use_target_production: value,
                    target_production_kwh: value ? nextTarget : null,
                  });
                }}
                onTargetProductionKwhChange={(value) => {
                  this.setState({ targetProductionKwh: value });
                  this.context.CanvasAPI.saveCanvas({
                    // If user is setting a target, ensure toggle is persisted as enabled
                    use_target_production:
                      value > 0 ? true : this.state.useTargetProduction,
                    target_production_kwh: value > 0 ? value : null,
                  });
                }}
                // Auto quantity props
                primaryInverterAutoQuantity={primaryInverterAutoQuantity}
                onPrimaryInverterAutoQuantityChange={(value) => {
                  const nextQty = value
                    ? this.state.package?.inverterQuantity
                    : 1;
                  this.setState((prev) => ({
                    primaryInverterAutoQuantity: value,
                    hasAutoCalculatedInverterQuantity: !value,
                    package: {
                      ...(prev.package || {}),
                      inverterQuantity: value
                        ? prev.package?.inverterQuantity || 1
                        : 1,
                    },
                  }));
                  this.context.CanvasAPI.saveCanvas({
                    primary_inverter_auto_quantity: value,
                    inverter_quantity: value ? nextQty || 1 : 1,
                  });
                }}
              />
            </Col>
          </Row>
        </DesignContext.Provider>
      );
    }

    return (
      <DesignContext.Provider value={providerValues}>
        <DroneIframeModal
          iframeRef={this.droneIframeRef}
          show={droneModal.show}
          title="Drone Managment"
          src={droneModal.src}
          loading={droneModal.loading}
          onLoad={this.postDroneBootstrapToFrame}
          onHide={this.closeDroneModal}
        />
        <Modal
          show={Boolean(cloneDialogOpen)}
          onHide={this.closeCloneDialog}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Save as</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                value={cloneName || ''}
                placeholder="Name"
                onChange={(event) =>
                  this.setState({ cloneName: event.target.value })
                }
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.closeCloneDialog}
              disabled={isCloningDesign}
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={(event) => {
                event.preventDefault();
                this.confirmCloneDesign();
              }}
              disabled={
                isCloningDesign ||
                !String(cloneName || '').trim()
              }
            >
              {isCloningDesign ? 'Saving…' : 'Save as'}
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={Boolean(archiveSiblingsOpen)}
          onHide={() => this.setState({ archiveSiblingsOpen: false })}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Archive other designs</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              This canvas change will archive the other designs on this canvas.
              Use Save as if you want to keep them.
            </p>
            <ul className="mb-0">
              {(archiveSiblings || []).map((design) => (
                <li key={design.id}>
                  {design.name}
                  {design.created_at ? ` — ${design.created_at}` : ''}
                </li>
              ))}
            </ul>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ archiveSiblingsOpen: false })}
            >
              Cancel
            </Button>
            <Button variant="outline-primary" onClick={this.openCloneDialog}>
              Save as
            </Button>
            <Button variant="warning" onClick={() => this.handleSaveAll(true)}>
              Archive and save
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={Boolean(this.state.scopeConfirm)}
          onHide={() => this.setState({ scopeConfirm: null })}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Unsaved changes</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-0">{UNSAVED_CHANGES_GUARD_MESSAGE}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ scopeConfirm: null })}
            >
              Stay
            </Button>
            <Button
              variant="warning"
              onClick={() => {
                const next = this.state.scopeConfirm;
                this.setState({ scopeConfirm: null });
                if (next) void this.applyScopeSelect(next.canvasId, next.designId);
              }}
            >
              Discard and switch
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={Boolean(this.state.renameModal)}
          onHide={() => this.setState({ renameModal: null })}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.renameModal?.kind === 'canvas' ? 'Rename canvas' : 'Rename design'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                value={this.state.renameModal?.name || ''}
                onChange={(event) => this.setState({
                  renameModal: {
                    ...this.state.renameModal,
                    name: event?.target?.value || '',
                  },
                })}
                placeholder="Name"
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ renameModal: null })}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              disabled={!String(this.state.renameModal?.name || '').trim() || this.state.isRenamingDesign}
              onClick={this.submitRenameModal}
            >
              Save name
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={Boolean(this.state.archiveModal)}
          onHide={() => this.setState({ archiveModal: null })}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Archive</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-0">{this.state.archiveModal?.message}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ archiveModal: null })}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              disabled={this.state.isArchivingDesign}
              onClick={this.submitArchiveModal}
            >
              Archive
            </Button>
          </Modal.Footer>
        </Modal>
        <Card className="shadow w-100 mt-3 bg-primary text-white" body>
          <div className="float-right d-flex align-items-center">
            {showDesignSwitcher && (
              <>
                <Dropdown className="mr-2 d-inline-block">
                  <Dropdown.Toggle
                    size="sm"
                    variant="outline-light"
                    id="canvas-design-scope-switcher"
                    disabled={isLoadingDesigns || isCloningDesign}
                  >
                    {activeScopeLabel}
                    <style>{`@keyframes canvasDirtyPulse { 0% { opacity: 1; } 50% { opacity: 0.25; } 100% { opacity: 1; } }`}</style>
                    <span
                      className="ml-2 d-inline-block rounded-circle"
                      title={saveNeeded ? 'Unsaved changes' : 'All changes saved'}
                      style={{
                        width: 10,
                        height: 10,
                        backgroundColor: saveNeeded ? '#ff9800' : '#4caf50',
                        animation: saveNeeded ? 'canvasDirtyPulse 1s infinite' : 'none',
                      }}
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ maxWidth: 420, minWidth: 300 }}>
                    {designTree.map((node) => {
                      const nodeChildren = node.children || [];
                      const nodeHasActiveChild = nodeChildren.length > 0;
                      const nodeActiveChild = nodeChildren.find(
                        (child) => String(child.designId) === String(activeDesignId)
                      );
                      const nodeIsActive =
                        !nodeActiveChild &&
                        String(node.canvasId) === String(activeCanvasId) &&
                        String(node.designId) === String(activeDesignId);
                      const nodeStyle = nodeIsActive
                        ? { backgroundColor: '#e9ecef', color: '#212529' }
                        : undefined;
                      return (
                      <React.Fragment key={node.canvasId}>
                        {nodeHasActiveChild ? (
                        <Dropdown.Header>
                          <div className="d-flex align-items-center justify-content-between">
                            <span className="text-truncate">
                              {node.label}
                              {node.isDefault ? ' (default)' : ''}
                            </span>
                            <span className="ml-2 d-flex">
                              <Button
                                size="sm"
                                variant="link"
                                className="p-0 mr-2"
                                title={`Rename canvas ${node.label}`}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.handleRenameDesign(node.canvasId, node.designId, 'canvas');
                                }}
                              >
                                Rename
                              </Button>
                              <Button
                                size="sm"
                                variant="link"
                                className="p-0 text-danger"
                                title={`Archive canvas ${node.label}`}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.handleArchiveDesign(node.canvasId, node.designId, 'canvas', node.label);
                                }}
                              >
                                Archive
                              </Button>
                            </span>
                          </div>
                        </Dropdown.Header>
                        ) : (
                        <Dropdown.Item
                          active={nodeIsActive}
                          style={nodeStyle}
                          onClick={() => this.handleScopeSelect(node.canvasId, node.designId)}
                        >
                          <div className="d-flex align-items-center justify-content-between">
                            <span className="text-truncate">
                              {node.label}
                              {node.isDefault ? ' (default)' : ''}
                            </span>
                            <span className="ml-2 d-flex">
                              <Button
                                size="sm"
                                variant="link"
                                className="p-0 mr-2"
                                title={`Rename canvas ${node.label}`}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.handleRenameDesign(node.canvasId, node.designId, 'canvas');
                                }}
                              >
                                Rename
                              </Button>
                              <Button
                                size="sm"
                                variant="link"
                                className="p-0 text-danger"
                                title={`Archive canvas ${node.label}`}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.handleArchiveDesign(node.canvasId, node.designId, 'canvas', node.label);
                                }}
                              >
                                Archive
                              </Button>
                            </span>
                          </div>
                        </Dropdown.Item>
                        )}
                        {nodeChildren.map((child) => {
                          const childIsActive =
                            String(child.designId) === String(activeDesignId);
                          const childStyle = childIsActive
                            ? { backgroundColor: '#e9ecef', color: '#212529' }
                            : undefined;
                          return (
                          <Dropdown.Item
                            key={child.designId}
                            active={childIsActive}
                            style={childStyle}
                            onClick={() => this.handleScopeSelect(node.canvasId, child.designId)}
                          >
                            <div
                              className="d-flex align-items-center justify-content-between"
                              style={{ paddingLeft: 16 }}
                            >
                              <span className="text-truncate">
                                {child.label}
                                {child.isDefault ? ' (default)' : ''}
                              </span>
                              <span className="ml-2 d-flex">
                                <Button
                                  size="sm"
                                  variant="link"
                                  className="p-0 mr-2"
                                  title={`Rename design ${child.label}`}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    this.handleRenameDesign(node.canvasId, child.designId, 'design');
                                  }}
                                >
                                  Rename
                                </Button>
                                <Button
                                  size="sm"
                                  variant="link"
                                  className="p-0 text-danger"
                                  title={`Archive design ${child.label}`}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    this.handleArchiveDesign(node.canvasId, child.designId, 'design', child.label);
                                  }}
                                >
                                  Archive
                                </Button>
                              </span>
                            </div>
                          </Dropdown.Item>
                          );
                        })}
                      </React.Fragment>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
                <Button
                  type="button"
                  size="sm"
                  variant="outline-light"
                  className="mr-2"
                  onClick={(event) => {
                    event.preventDefault();
                    this.handleSaveAll();
                  }}
                  disabled={isLoadingDesigns || isCloningDesign}
                >
                  Save
                </Button>
                <Button
                  type="button"
                  size="sm"
                  variant="outline-light"
                  className="mr-2"
                  onClick={(event) => {
                    event.preventDefault();
                    this.openCloneDialog();
                  }}
                  disabled={isLoadingDesigns || isCloningDesign}
                >
                  {isCloningDesign ? 'Saving…' : 'Save as'}
                </Button>
              </>
            )}
            <Button
              size="sm"
              variant="light"
              onClick={() => this.setState({ isFullScreen: !isFullScreen })}
            >
              <ArrowsFullscreen />
            </Button>
          </div>
          {activeDesignName ? (
            <div className="mb-1" style={{ fontSize: '0.95rem' }}>
              {activeDesignName}
            </div>
          ) : null}
          Here is your custom solar design for
          <h3 className="mt-2">{fullAddress}</h3>
        </Card>
        <Fullscreen
          isEnter={isFullScreen}
          onChange={(e) => this.setState({ isFullScreen: e })}
        >
          <Row className="bg-light py-3 full-screenable-node" noGutters>
            <Col xl={8} lg={12} md={12} s={12} xs={12} className="mb-3 pr-2">
              <Controls
                mode={mode}
                moveMode={moveMode}
                setMode={this.handleMode}
                setMoveMode={this.designerCanvasCommands.setMoveMode}
                resetScale={this.handleResetScale}
                scaleUp={this.handleScaleUp}
                scaleDown={this.handleScaleDown}
                mapsLink={this.mapsLink}
                viewMode={konvaKeys.includes(accordion) ? '3D' : viewMode}
                switchView={this.switchView}
              />
              {viewer}
              <ControlsBottom
                saveCanvas={this.handleSaveAll}
                cleanCanvas={this.cleanCanvas}
                exportJSON={this.handleDownload3DJSON}
                exportDXF={this.handleDownloadDXF}
                disabled={bottomControlsDisabled}
              />
            </Col>
            <Col xl={4} lg={12} md={12} s={12} xs={12}>
              <Menu
                activeKey={accordion}
                designType={designType}
                hasRGB={hasRGB}
                hasDSM={hasDSM}
                shaded={shade}
                buffer={buffer}
                rowSpacing={rowSpacing}
                panelTilt={panelTilt}
                azimuthRestriction={azimuthRestriction}
                fireSetbacks={fireSetbacks}
                setbackMode={setbackMode}
                shadingIsRunning={shadingIsRunning}
                serverSideShadingIsRunning={serverSideShadingIsRunning}
                setbackModeHandler={this.handleSetbackMode}
                fireSetbackHandler={this.handleFireSetbacks}
                colorRange={colorRange}
                currentAccordionHandler={this.handleCurrentAccordion}
                currentTabHandler={this.handleSegmentTabs}
                tool={tool}
                toolHandler={this.handleTool}
                selectedLabel={selectedLabel}
                selectedRoof={selectedRoof}
                selectedPanels={selectedPanels}
                selectedLabelHandler={this.handleSelectedLabel}
                clearLabelsHandler={this.clearLabelsHandler}
                deleteShapeHandler={this.handleDeleteShape}
                addPointToPolygonHandler={this.handleAddPointToPolygonFromMenu}
                removePointFromPolygonHandler={
                  this.handleRemovePointFromPolygonFromMenu
                }
                obstacleHeightHandler={this.handleObstacleHeight}
                obstacleRadiusHandler={this.handleObstacleRadius}
                obstacleSetbackHandler={this.handleObstacleSetback}
                obstacleOrientationHandler={this.handleObstacleOrientation}
                newPanelHandler={this.handleNewPanel}
                deletePanelHandler={this.handleDeletePanel}
                rotatePanelHandler={this.handleRotatePanel}
                setPVwattsLosses={this.setPVwattsLosses}
                losses={this.state.losses}
                segments={segments}
                resolution={resolution}
                segmentAzimuthHandler={this.handleSegmentAzimuth}
                segmentPitchAndAreaHandler={this.handleSegmentPitchAndArea}
                segmentEaveHeightHandler={this.handleSegmentEaveHeight}
                treeUpdateHandler={this.handleTreeUpdate}
                treeDeleteAllHandler={this.handleDeleteAllTrees}
                pitchInDegrees={this.state.pitch_in_degrees ?? true}
                onPitchInDegreesChange={this.handlePitchInDegreesChange}
                obstacles={obstacles}
                trees={trees}
                panels={panels}
                panelPlacementIsRunning={panelPlacementIsRunning}
                placementHandler={this.handlePlacement}
                shadingHandler={this.handleShading}
                weatherDataset={this.state.weatherDatasetSelected}
                setWeatherDataset={this.setWeatherDatasetSelected}
                weatherDatasetFetchedPath={this.state.weatherDatasetFetchedPath}
                weatherDatasetReady={(() => {
                  const p = this.state.weatherDatasetFetchedPath;
                  const sel = this.state.weatherDatasetSelected;
                  if (!p || !sel) return false;
                  const base = (String(p).split('/').pop() || '').trim();
                  const expectedFilename = `${sel}.csv`;
                  return base === expectedFilename;
                })()}
                onWeatherDatasetFetched={this.handleWeatherDatasetFetched}
                measureHandler={this.handleMeasure}
                runOptimizationHandler={this.runOptimizationHandler}
                runEdgeDetectionHandler={this.runEdgeDetectionHandler}
                runRectificationHandler={this.runRectificationHandler}
                runAIHandler={this.runAIHandler}
                canSelectDifferentImage={
                  activeDesign?.image_source === 'nearmap'
                }
                runTreeAIHandler={this.runTreeAIHandler}
                canUseGoogleDSMForTreeAI={canUseGoogleDSMForTreeAI}
                useGoogleDSMForTreeAI={this.state.useGoogleDSMForTreeAI}
                onUseGoogleDSMForTreeAIChange={this.setUseGoogleDSMForTreeAI}
                runObstacleTune={this.runObstacleTune}
                reloadCanvasObstacles={this.reloadCanvasObstacles}
                runTreeTune={this.runTreeTune}
                onDroneAppHandler={this.openDroneApp}
                proposalHandler={this.handleProposal}
                isCreatingProposal={this.state.isCreatingProposal}
                shadingNeedsRerun={this.state.shadingNeedsRerun}
                shadingHasRun={this.state.shadingHasRun}
                hasActiveCanvasDesign={hasActiveCanvasDesign}
                panelAzimuthHandler={this.handlePanelAzimuth}
                currentPanel={currentPanel}
                appliedPanel={appliedPanel}
                currentInverter={inverterHardware}
                currentInverterQuantity={
                  installationPackage?.inverterQuantity || 1
                }
                hasAutoCalculatedInverterQuantity={
                  hasAutoCalculatedInverterQuantity
                }
                currentAdditionalInverters={additionalInvertersHardware}
                packageAdditionalInverters={packageAdditionalInverters}
                changePanelHardware={this.changePanelHardware}
                changeInverterHardware={this.changeInverterHardware}
                changeInverterQuantity={this.changeInverterQuantity}
                changeAdditionalInverters={this.changeAdditionalInverters}
                bufferHandler={this.handleBuffer}
                rowSpacingHandler={this.handleRowSpacing}
                panelTiltHandler={this.handlePanelTilt}
                azimuthRestrictionHandler={this.handleAzimuthRestriction}
                showOverlay={showOverlay}
                toggleOverlay={this.toggleOverlay}
                shadingMonth={shadingMonth}
                shadingStatus={shadingStatus}
                roofAreasSqFt={this.state.roofAreasSqFt}
                roofAreasUnit={this.state.roofAreasUnit}
                solarPanels={solarPanels}
                inverters={inverters}
                panelPlacementFillMode={panelPlacementFillMode}
                setPanelPlacementFillMode={this.setPanelPlacementFillMode}
                panelPlacementLayoutMode={panelPlacementLayoutMode}
                setPanelPlacementLayoutMode={this.setPanelPlacementLayoutMode}
                panelPlacementOnlySelectedRoof={panelPlacementOnlySelectedRoof}
                setPanelPlacementOnlySelectedRoof={
                  this.setPanelPlacementOnlySelectedRoof
                }
                clearPanels={this.clearPanels}
                // Production props
                productionIsRunning={productionIsRunning}
                productionHandled={productionHandled}
                totalAnnualKwh={totalAnnualKwh}
                totalClippingKwh={totalClippingKwh}
                dcAcRatio={dcAcRatio}
                stringingData={stringingData}
                invertersUsed={invertersUsed}
                productionPerPanel={productionPerPanel}
                selectedPanelCount={selectedPanelCount}
                productionHardware={productionHardware}
                systemSizeKw={this.state.systemSizeKw}
                mpptCountTotal={this.state.mpptCountTotal}
                handleSolarProduction={this.handleSolarProduction}
                // Target production props
                useTargetProduction={useTargetProduction}
                targetProductionKwh={targetProductionKwh}
                maxDcAcRatio={this.state.maxDcAcRatio}
                onMaxDcAcRatioChange={(value) => {
                  const next =
                    value === null || value === undefined || Number.isNaN(value)
                      ? 1.5
                      : value;
                  this.setState({ maxDcAcRatio: next });
                  this.context.CanvasAPI.saveCanvas({
                    max_dc_ac_ratio: next,
                  });
                }}
                onlySelectedPanels={this.state.onlySelectedPanels}
                onOnlySelectedPanelsChange={(value) => {
                  this.setState({ onlySelectedPanels: value });
                  this.context.CanvasAPI.saveCanvas({
                    only_selected_panels: value,
                  });
                }}
                onUseTargetProductionChange={(value) => {
                  const nextTarget = value ? this.state.targetProductionKwh : 0;
                  this.setState({
                    useTargetProduction: value,
                    targetProductionKwh: nextTarget,
                  });
                  this.context.CanvasAPI.saveCanvas({
                    use_target_production: value,
                    target_production_kwh: value ? nextTarget : null,
                  });
                }}
                onTargetProductionKwhChange={(value) => {
                  this.setState({ targetProductionKwh: value });
                  this.context.CanvasAPI.saveCanvas({
                    // If user is setting a target, ensure toggle is persisted as enabled
                    use_target_production:
                      value > 0 ? true : this.state.useTargetProduction,
                    target_production_kwh: value > 0 ? value : null,
                  });
                }}
                // Auto quantity props
                primaryInverterAutoQuantity={primaryInverterAutoQuantity}
                onPrimaryInverterAutoQuantityChange={(value) => {
                  const nextQty = value
                    ? this.state.package?.inverterQuantity
                    : 1;
                  this.setState((prev) => ({
                    primaryInverterAutoQuantity: value,
                    hasAutoCalculatedInverterQuantity: !value,
                    package: {
                      ...(prev.package || {}),
                      inverterQuantity: value
                        ? prev.package?.inverterQuantity || 1
                        : 1,
                    },
                  }));
                  this.context.CanvasAPI.saveCanvas({
                    primary_inverter_auto_quantity: value,
                    inverter_quantity: value ? nextQty || 1 : 1,
                  });
                }}
              />
            </Col>
          </Row>
        </Fullscreen>
        <ShadeReport
          wattage={panelHardware?.power || 0}
          segments={segments}
          panels={panels}
          stringingData={this.state.stringingData}
          productionPerPanelData={this.state.productionPerPanelData}
          optPitchAndAzimuth={property.optimal_roof}
        />
      </DesignContext.Provider>
    );
  }
}

DesignTool.contextType = LeadContext;
export default withRouter(DesignTool);
